import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import axios from "axios";
import { Space } from "antd";
import { useNavigate } from "react-router-dom";
import { Bars } from "react-loader-spinner";
import movementicon from "../assets/average_tradeall.png";
import eye_btn_tooltip from "../assets/IBUTTON.png";
import color1 from "../assets/highest_average.png";
import color2 from "../assets/second_highest_average.png";
import color3 from "../assets/third_highest_average.png";
import livegraph_icon from "../assets/line_chart.png";
import color4 from "../assets/color4.png";
import color5 from "../assets/color5.png";
import color6 from "../assets/color6.png";
import { IoArrowBack } from "react-icons/io5";
import color7 from "../assets/color7.png";
import color8 from "../assets/color8.png";
import color9 from "../assets/color9.png";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import crossicon from "../assets/cross1.png";
import refresh_icon from "../assets/refresh.png";
import logout_eye_btn from "../assets/IBUTTON.png";
import dateicon from "../assets/date.png";
import eventicon from "../assets/event.png";
import timeicon from "../assets/time1).png";
import locationicon from "../assets/location(1).png";
import impacticon from "../assets/impact(1).png";
import frequencyicon from "../assets/calendar(1).png";
import RingLoader from "react-spinners/RingLoader";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import UserNavbar from "../components/user/userNavbar";
import styles from "../components/tradeall.module.css";

const EventshistoryUserTrial = () => {
  const navigate = useNavigate();

  const [run_modalloader, setRun_modalloader] = useState(true);
  const [run_clickedevent_dateapi, setRunclickedevent_dateapi] =
    useState(false);
  const [run_clickedevent_dateapi2, setRunclickedevent_dateapi2] =
    useState(false);
  const [runclickedevent_dateapi3, setRunclickedevent_dateapi3] =
    useState(false);
  const [Loading_3rdtable, setLoading_3rdtable] = useState(false);

  const [timeclickedurl_state, setTimeclickedurl_state] = useState(1);

  const [isgraphbuttonDisabled, setIsgraphbuttonDisbled] = useState(false);
  const [optionValue, setOptionValue] = useState(6);

  const [eventname_forerror, seteventname_forerror] = useState("");

  // <----------------here is the final averge of flat points---------->

  const [isReloadLoading, setIsReloadLoading] = useState(false);

  // const [errorMessage, setErrorMessage] = useState("");
  // const [eventHistory, setEventHistory] = useState([]);
  // const [eventHistory2, setEventHistory2] = useState([]);
  const [clickedtimeButton, setClickedtimeButton] = useState("1min");
  const [country, setCountry] = useState("");
  const [eventdate, setEventDate] = useState("");
  const [event, setEvent] = useState("");
  const [impact, setimpact] = useState("");
  const [date, setdate] = useState("");
  const [time, settime] = useState("");

  const [impacthighlow, setimpacthighlow] = useState([]);
  const [impacthighlowbeforethis, setimpacthighlowbeforethis] = useState([]);
  const [modalimpactdatabeforetime, setmodalimpactdatabeforetime] = useState(
    []
  );
  const [modalimpactdataontime, setmodalimpactdataontime] = useState([]);

  const [frequency_date, setFrequency_date] = useState();
  const [Loading, setLoading] = useState(false);

  const [selectedTime, setSelectedTime] = useState(1);
  const [allEventHistory, setAllEventHistory] = useState([]);
  const [allEventHistory2, setAllEventHistory2] = useState([]);

  // <<--------for flat 0 averages----->

  const [eventimpactontimespecificdate, seteventimpactontimespecificdate] =
    useState();
  const [
    eventimpactbeforetimespecificdate,
    seteventimpactbeforetimespecificdate,
  ] = useState();

  const [clickeddate_Loading, setclickeddate_Loading] = useState(true);
  const [modalShow, setModalshow] = useState(false);

  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);

  const tooltipRef = useRef(null);

  const handleImageClick = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip((prev) => !prev);
  };
  const handleImageClick2 = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip2((prev) => !prev);
  };
  const handleImageClick3 = (event) => {
    event.stopPropagation(); // Prevent immediate closing on click
    setShowTooltip3((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      setShowTooltip(false);
      setShowTooltip2(false);
      setShowTooltip3(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });

  const UKHeaders = [
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "GBP/CAD", id: "gbpcad" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "GBP/NZD", id: "gbpnzd" },
    { name: "GBP/USD", id: "gbpusd" },
  ];
  const USHeaders = [
    { name: "AUD/USD", id: "audusd" },
    { name: "USD/CAD", id: "usdcad" },
    { name: "USD/CHF", id: "usdchf" },
    { name: "EUR/USD", id: "eurusd" },
    { name: "GBP/USD", id: "gbpusd" },
    { name: "USD/JPY", id: "usdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
  ];
  const JPHeaders = [
    { name: "AUD/JPY", id: "audjpy" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "EUR/JPY", id: "eurjpy" },
    { name: "GBP/JPY", id: "gbpjpy" },
    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "USD/JPY", id: "usdjpy" },
  ];
  const CAHeaders = [
    { name: "AUD/CAD", id: "audcad" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "GBP/CAD", id: "gbpcad" },
    { name: "CAD/JPY", id: "cadjpy" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "USD/CAD", id: "usdcad" },
  ];
  const CHEHeaders = [
    { name: "AUD/CHF", id: "audchf" },
    { name: "CAD/CHF", id: "cadchf" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "GBP/CHF", id: "gbpchf" },
    { name: "CHF/JPY", id: "chfjpy" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "USD/CHF", id: "usdchf" },
  ];
  const EUHeaders = [
    { name: "EUR/AUD", id: "euraud" },
    { name: "EUR/CAD", id: "eurcad" },
    { name: "EUR/CHF", id: "eurchf" },
    { name: "EUR/GBP", id: "eurgbp" },
    { name: "EUR/JPY", id: "eurjpy" },

    { name: "EUR/NZD", id: "eurnzd" },
    { name: "EUR/USD", id: "eurusd" },
  ];
  const AUHeaders = [
    { name: "AUD/CAD", id: "audcad" },
    { name: "AUD/CHF", id: "audchf" },
    { name: "EUR/AUD", id: "euraud" },
    { name: "GBP/AUD", id: "gbpaud" },
    { name: "AUD/JPY", id: "audjpy" },
    { name: "AUD/NZD", id: "audnzd" },
    { name: "AUD/USD", id: "audusd" },
  ];
  const NZHeaders = [
    { name: "AUD/NZD", id: "audnzd" },
    { name: "NZD/CAD", id: "nzdcad" },
    { name: "NZD/CHF", id: "nzdchf" },
    { name: "EUR/NZD", id: "eurnzd" },
    { name: "GBP/NZD", id: "gbpnzd" },

    { name: "NZD/JPY", id: "nzdjpy" },
    { name: "NZD/USD", id: "nzdusd" },
  ];

  const headersMap =
    country === "UK"
      ? UKHeaders
      : country === "US"
        ? USHeaders
        : country === "JP"
          ? JPHeaders
          : country === "CA"
            ? CAHeaders
            : country === "CH"
              ? CHEHeaders
              : country === "EU" ||
                country === "DE" ||
                country === "IT" ||
                country === "FR"
                ? EUHeaders
                : country === "AU"
                  ? AUHeaders
                  : NZHeaders;

  const headers = headersMap.sort((a, b) => a.name.localeCompare(b.name)) || [];

  const handlegeneratechart = () => {
    // window.open("/user/graphdata", "_blank");
    // navigate("/admin/graphdata");

    const urlParams = new URLSearchParams(window.location.search);
    const eventId = decodeURIComponent(urlParams.get("eventId"));
    // alert(eventId)
    const url = new URL(window.location.origin + "/user/graphdata");
    url.searchParams.set("eventName", event);
    url.searchParams.set("eventcountry", country);
    url.searchParams.set("eventId", eventId);
    url.searchParams.set("eventdate", eventdate);
    const newTab = window.open(url.toString(), "_blank");
  };

  const handlelivechart = () => {
    const url = new URL(window.location.origin + "/user/livecharts");
    const newTab = window.open(url.toString(), "_blank");
  };

  // <---------------headers------------>
  const getheaderscount_highlow = async () => {
    console.log("hi am in header code now ");
    setclickeddate_Loading(true);
    if (run_clickedevent_dateapi) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const eventName = decodeURIComponent(urlParams.get("eventName"));
        const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));

        console.log("eventcountry", eventcountry);
        const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
        const eventtime = decodeURIComponent(urlParams.get("eventtime"));
        const eventdate = decodeURIComponent(urlParams.get("eventdate"));

        const uniqueKey = `${eventName}-${eventcountry}-${eventdate}-${eventtime}`;
        setEventDate(eventdate);
        setCountry(eventcountry);
        setEvent(eventName);
        setimpact(eventimpact);
        setdate(eventdate);
        settime(eventtime);
        const tokenfromls = localStorage.getItem("usertoken");
        const headers = { authorization: tokenfromls };

        // Fetch specific date impact data
        const response5 = await axios.post(
          `${process.env.REACT_APP_URL}/eventsimpactonaspecificdate`,
          { eventName, eventcountry, eventdate, eventtime },
          { headers }
        );

        const specificdateimpactontime = response5.data;
        // console.log("specificdateimpactontime", specificdateimpactontime);

        // Fetch before specific date impact data
        const response6 = await axios.post(
          `${process.env.REACT_APP_URL}/eventsimpactbeforeaspecificdate`,
          { eventName, eventcountry, eventdate, eventtime },
          { headers }
        );

        const specificdateimpactbeforetime = response6.data;
        // console.log(
        //   "specificdateimpactbeforetime",
        //   specificdateimpactbeforetime
        // );
        setRunclickedevent_dateapi2(true);

        seteventimpactontimespecificdate(specificdateimpactontime);
        seteventimpactbeforetimespecificdate(specificdateimpactbeforetime);
        setclickeddate_Loading(false);
      } catch (error) {
        console.error("Error fetching specific date impact data:", error);
        setclickeddate_Loading(false);
      }
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlCountry = decodeURIComponent(urlParams.get("eventcountry"));
    setCountry(urlCountry);
  }, []);

  useEffect(() => {
    if (run_clickedevent_dateapi) {
      getheaderscount_highlow();
    }
  }, [run_clickedevent_dateapi]);

  // <-----------modal high low count------------>
  const handlegetmodaldata_fromApi = async () => {
    if (run_clickedevent_dateapi2) {
      //  console.log("hi")
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const eventName = decodeURIComponent(urlParams.get("eventName"));
        const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
        // const eventimpact = decodeURIComponent(urlParams.get('eventimpact'));
        const eventtime = decodeURIComponent(urlParams.get("eventtime"));
        const eventdate = decodeURIComponent(urlParams.get("eventdate"));

        // // <---------------data first time run and setting into local------------->

        const tokenfromls = localStorage.getItem("usertoken");
        const h = { authorization: tokenfromls };

        const response2 = await axios.post(
          `${process.env.REACT_APP_URL}/findhighlowhistoryevents`,
          { eventName, eventcountry },
          { headers: h }
        );

        // console.log("response2", response2);
        const response3 = await axios.post(
          `${process.env.REACT_APP_URL}/highloweventbeforedate`,
          { eventName, eventcountry },
          { headers: h }
        );
        // console.log("response3", response3);

        // <-----------this code is for on time-------------->
        const gethighlowimpact = response2.data;
        const modalimpacthighlowontime = gethighlowimpact.impactdata1;
        const summaryimpacthighlow = gethighlowimpact.impactdata2;

        // <-----------this code is for before time-------------->
        const impactdata = response3.data;
        const finalimpactsummary = impactdata.impactdata2;
        const modalimpactdata2 = impactdata.impactdata1;
        // <-------------main data--------------->
        setRun_modalloader(false);
        const dataToStore3 = {
          finalimpactsummary,
          summaryimpacthighlow,
          modalimpacthighlowontime,
          modalimpactdata2,
        };
        setimpacthighlow(summaryimpacthighlow);
        setmodalimpactdataontime(modalimpacthighlowontime);
        setimpacthighlowbeforethis(finalimpactsummary);
        setmodalimpactdatabeforetime(modalimpactdata2);
      } catch (error) {
        console.log("error", error);
        setRun_modalloader(false);
      }
    }
  };

  useEffect(() => {
    if (run_clickedevent_dateapi2) {
      handlegetmodaldata_fromApi();
    }
  }, [run_clickedevent_dateapi2]);

  const handleModalShowClick = () => {
    setModalshow(true);
  };

  const handleRefresh = () => {
    setIsReloadLoading(true);
    setLoading(false);
    // Loop through localStorage and remove any item with "Clickeddate_data_"
    Object.keys(localStorage).forEach((key) => {
      if (
        key.includes("Clickeddate_data_") ||
        key.includes("table3_historyData_") ||
        key.includes("clickedmodal_data_2ndpage_")
      ) {
        localStorage.removeItem(key);
      }
    });

    localStorage.removeItem("All_events_history");
    localStorage.removeItem("lastDeletionTime");
    localStorage.removeItem("UserId");
    localStorage.removeItem("userId");
    localStorage.removeItem("selectedtime");
    localStorage.removeItem("4GraphDataobjects");

    localStorage.removeItem("token");
    localStorage.removeItem("todayDate");
    localStorage.removeItem("previousDate_u_search_history");

    localStorage.removeItem("selectedtime");

    setIsReloadLoading(false);
    setLoading(false);
    // historydata_table(selectedTime);
    getFirstTabledata();
    window.location.reload();
  };

  const handlegoback = () => {
    navigate("/user/economicdata");
  };

  const [filteredModalData, setFilteredModalData] = useState([]);
  const handleShowModalbeforetime = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2").showModal();
  };

  const handleShowModalbeforetime_2nd_table = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2_2nd_table").showModal();
  };

  const handleShowModalbeforetime_3rd_table = (date) => {
    const filteredData = modalimpactdatabeforetime.filter(
      (item) => item.date === date
    );
    setFilteredModalData(filteredData);
    document.getElementById("my_modal_2_3rdtable").showModal();
  };

  const [filteredModalDataontime, setFilteredModalDataontime] = useState([]);
  const handleShowModalontime = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3").showModal();
  };
  const handleShowModalontime_2nd_table = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3_2nd_table").showModal();
  };
  const handleShowModalontime_3rd_table = (date) => {
    const filteredData = modalimpactdataontime.filter(
      (item) => item.date === date
    );
    setFilteredModalDataontime(filteredData);
    document.getElementById("my_modal_3_3rd_table").showModal();
  };

  useEffect(() => {
    const modal = document.getElementById("my_modal_3_3rd_table");

    const handleOpen = () => {
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    };

    const handleClose = () => {
      document.body.style.overflow = "auto"; // Restore scrolling
    };

    if (modal) {
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.close(); // Close modal when clicking outside
        }
      });

      modal.addEventListener("cancel", handleClose); // When user presses "Escape"
      modal.addEventListener("close", handleClose); // When modal closes normally
      modal.addEventListener("DOMNodeInserted", handleOpen); // Detect when it's added
    }

    return () => {
      if (modal) {
        modal.removeEventListener("cancel", handleClose);
        modal.removeEventListener("close", handleClose);
        modal.removeEventListener("DOMNodeInserted", handleOpen);
      }
      document.body.style.overflow = "auto"; // Cleanup on unmount
    };
  }, [handleShowModalontime_3rd_table, handleShowModalbeforetime_3rd_table]);
  function autoClickButton() {
    var button = document.getElementById("aashima_id");
    button.click();
  }
  function autoClickButton_2nd_table() {
    var button = document.getElementById("aashima_id_2nd_table");
    button.click();
  }
  function autoClickButton_3rd_table() {
    var button = document.getElementById("aashima_id_3rd_table");
    button.click();
  }
  function autoClickButton1() {
    var button = document.getElementById("closemod11");
    button.click();
  }
  function autoClickButton1_2nd_table() {
    var button = document.getElementById("closemod11__2nd_table");
    button.click();
  }
  function autoClickButton1_3rd_table() {
    var button = document.getElementById("closemod11__3rd_table");
    button.click();
  }

  const [volatilityImpact_firsttable, setVolatilityImpact_firsttable] =
    useState([]);
  const [
    volatilityImpact_firsttable_nonzero,
    setVolatilityImpact_firsttable_nonzero,
  ] = useState([]);
  const [
    volatilityImpact_firsttable_zero,
    setVolatilityImpact_firsttable_zero,
  ] = useState([]);

  const [volatilityImpact_secondtable, setVolatilityImpact_secondtable] =
    useState([]);

  const [
    volatilityImpact_secondtable_flatPOS_flatNEV,
    setVolatilityImpact_secondtable_flatPOS_flatNEV,
  ] = useState([]);
  const missingEstimateKeys = useMemo(() => {
    const keys = new Set();
    volatilityImpact_firsttable.forEach((item) => {
      const estimateValue = item?.estimate;
      if (
        estimateValue === null ||
        estimateValue === undefined ||
        estimateValue === "" ||
        estimateValue === "N/A"
      ) {
        const dateKey = item?.date?.split(" ")[0];
        const timeKey = item?.time?.slice(0, 5);
        if (dateKey && timeKey) {
          keys.add(`${dateKey}${timeKey}`);
        }
      }
    });
    return keys;
  }, [volatilityImpact_firsttable]);
  const [eventRange, setEventRange] = useState("6");
  const [eventType, setEventType] = useState("1min");

  const handleOptionChange = (value) => {
    setEventRange(value);
    // setOptionValue(value)
    // console.log("value", value)
  };

  const handletimebtnclick = (value) => {
    setEventType(value);
    // console.log("value", value)
  };
  // <--both tables data ---below api--->
  const getFirstTabledata = async () => {
    try {
      // if (timeclicked === 1) {
      //   setoff_minutebuttons1(true);
      //   setoff_minutebuttons2(false);
      //   setoff_minutebuttons3(false);
      //   setoff_minutebuttons4(false);
      // } else if (timeclicked === 5) {
      //   setoff_minutebuttons1(true);
      //   setoff_minutebuttons2(true);
      //   setoff_minutebuttons3(false);
      //   setoff_minutebuttons4(false);
      // } else if (timeclicked === 15) {
      //   setoff_minutebuttons1(true);
      //   setoff_minutebuttons2(true);
      //   setoff_minutebuttons3(true);
      //   setoff_minutebuttons4(false);
      // } else {
      //   setoff_minutebuttons1(true);
      //   setoff_minutebuttons2(true);
      //   setoff_minutebuttons3(true);
      //   setoff_minutebuttons4(true);
      // }
      // console.log("hi i ma in api" , eventRange , eventType)
      const urlParams = new URLSearchParams(window.location.search);
      const eventId = decodeURIComponent(urlParams.get("eventId"));
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/user/geteventtable/${eventId}`,
        {
          params: {
            eventRange: eventRange,
            eventType: eventType,
          },
        }
      );
      // console.log("eventRange:", eventRange, "eventType:", eventType);

      console.log("response.data", response.data)

      // const res_data = response.data.volatilityEvent.data;
      const res_data = response.data.volatilityEvent.data.output;
      const res_data_nonzero = response.data.volatilityEvent.data.nonZeroEvent;
      const res_data_zero = response.data.volatilityEvent.data.zeroEvent;
      const sorted_res_data = res_data.sort((a, b) =>
        Object.keys(a)[0].localeCompare(Object.keys(b)[0])
      );
      const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) =>
        Object.keys(a)[0].localeCompare(Object.keys(b)[0])
      );
      const sorted_res_data_zero = res_data_zero.sort((a, b) =>
        Object.keys(a)[0].localeCompare(Object.keys(b)[0])
      );
      // console.log("sorted_res_data" , sorted_res_data);
      // console.log("sorted_res_data_nonzero-------->" , sorted_res_data_nonzero);
      // console.log("sorted_res_data_zero-------->" , sorted_res_data_zero);
      setVolatilityImpact_firsttable(sorted_res_data);
      setVolatilityImpact_firsttable_nonzero(sorted_res_data_nonzero);
      setVolatilityImpact_firsttable_zero(sorted_res_data_zero);

      // setLoading_3rdtable(true);

      // <----second table---->
      const second_table_res_data = response.data.event.data.output;
      const second_table_res_data_nonzero =
        response.data.event.data.nonZeroEvent;

      const second_table_res_data_zero = response.data.event.data.zeroEvent;
      const second_table_res_data_flatPOS_flatNEV =
        response.data.event.data.postiveNegative;

      setVolatilityImpact_secondtable(second_table_res_data);
      // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
      // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
      setVolatilityImpact_secondtable_flatPOS_flatNEV(
        second_table_res_data_flatPOS_flatNEV
      );
      setLoading(false);
      setRunclickedevent_dateapi(true);
      setRunclickedevent_dateapi2(true);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getFirstTabledata();
    handleOptionChange();
    handletimebtnclick();
  }, []);

  useEffect(() => {
    const dates = volatilityImpact_firsttable.map((item) => item.date);
    // Function to parse dates and calculate the difference in days
    function getDateDifferences(dates) {
      const dateDifferences = [];
      for (let i = 0; i < dates.length - 1; i++) {
        const date1 = new Date(dates[i]);
        const date2 = new Date(dates[i + 1]);
        const differenceInTime = Math.abs(date2.getTime() - date1.getTime());
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        dateDifferences.push(differenceInDays);
      }
      return dateDifferences;
    }

    // Get the date differences for the first 6 days
    const first6Dates = dates.slice(0, 6);
    const dateDifferences = getDateDifferences(first6Dates);
    const sumOfDifferences = dateDifferences.reduce(
      (sum, diff) => sum + diff,
      0
    );
    const averageGap = sumOfDifferences / dateDifferences.length;
    const roundedAverageGap = Math.round(averageGap);
    setFrequency_date(roundedAverageGap);
    // console.log('Average gap between the first 6 days:', roundedAverageGap);
  }, [volatilityImpact_firsttable]);

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedIndexes, setSelectedIndexes] = useState([]);

  // const handleCheckboxChange = (e, id, index) => {
  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      // setSelectedIndexes((prev) => [...prev, index]);
      setSelectedIds((prev) => [...prev, id]);
    } else {
      // setSelectedIndexes((prev) => prev.filter((i) => i !== index));
      setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
    }
  };

  useEffect(() => {
    getFirstTabledata();
  }, [eventRange, eventType]);

  const handleSend = async () => {
    try {
      console.log("selectedIds", selectedIds);
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/user/getParticularRowsTable`,
        { ids: selectedIds }
      );
      toast.success("final rows selected.", { position: "top-right" });
      // console.log('Success:', response.data);
      const res_data = response.data.volatilityEvent.data.output;
      const res_data_nonzero = response.data.volatilityEvent.data.nonZeroEvent;
      console.log("res_data_nonzero", res_data_nonzero);
      const res_data_zero = response.data.volatilityEvent.data.zeroEvent;
      const sorted_res_data = res_data.sort((a, b) =>
        Object.keys(a)[0].localeCompare(Object.keys(b)[0])
      );
      const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) =>
        Object.keys(a)[0].localeCompare(Object.keys(b)[0])
      );
      const sorted_res_data_zero = res_data_zero.sort((a, b) =>
        Object.keys(a)[0].localeCompare(Object.keys(b)[0])
      );
      // console.log("res_data" , res_data);
      console.log("sorted_res_data_zero-------->", sorted_res_data_zero);
      setVolatilityImpact_firsttable(sorted_res_data);
      setVolatilityImpact_firsttable_nonzero(sorted_res_data_nonzero);
      setVolatilityImpact_firsttable_zero(sorted_res_data_zero);
      setSelectedIds([]);
      // setLoading_3rdtable(true);

      // <----second table---->
      const second_table_res_data = response.data.event.data.output;
      const second_table_res_data_nonzero =
        response.data.event.data.nonZeroEvent;

      const second_table_res_data_zero = response.data.event.data.zeroEvent;
      const second_table_res_data_flatPOS_flatNEV =
        response.data.event.data.postiveNegative;

      setVolatilityImpact_secondtable(second_table_res_data);
      // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
      // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
      setVolatilityImpact_secondtable_flatPOS_flatNEV(
        second_table_res_data_flatPOS_flatNEV
      );
      setSelectedIds([]);
      // console.log("selectedids" , selectedIds)
    } catch (error) {
      console.error("Error sending IDs:", error);
    }
  };

  return (
    <>
      {volatilityImpact_firsttable.length > 0 && !Loading ? (
        <div className="">
          <UserNavbar />

          <div className="w-full flex justify-center items-center px-2 sm:px-4 md:px-8 lg:px-10">
            <div
              className={`${styles.eventpage}
      w-full max-w-[96.5%]   /* 🔥 Wider width */
      mx-auto mt-[18%] sm:mt-[16%] md:mt-[10%] lg:mt-[8%] xl:mt-[4%]
      bg-white/95 backdrop-blur-md rounded-2xl
      shadow-[0_20px_50px_rgba(36,13,58,0.10)]
      border border-[#E4D7FB]
      overflow-hidden`}
            >
              {/* Top colored strip */}
              <div className="h-1 w-full bg-gradient-to-r from-[#5829A9] via-[#8B5CF6] to-[#EC4899]" />

              {/* EVENT HEADER */}
              <div className="px-6 sm:px-8 md:px-10 pt-5 pb-4">
                <div className="flex items-center gap-2 text-xs sm:text-sm text-[#6B21A8] font-semibold uppercase tracking-[0.12em]">
                  <span className="inline-flex items-center justify-center rounded-full bg-[#F3E8FF] px-2 py-0.5 text-[10px] sm:text-xs">
                    Economic Event
                  </span>
                  <span className="h-[1px] flex-1 bg-gradient-to-r from-[#D1C4F6] to-transparent" />
                </div>

                <div className="mt-4 flex flex-col gap-2">
                  <div className="flex items-start gap-3">
                    <img
                      src={eventicon}
                      alt="eventicon"
                      className="h-7 w-7 mt-0.5 flex-shrink-0"
                    />
                    <div className="flex flex-col">
                      <span className="text-xs sm:text-sm font-medium text-[#6B7280]">
                        Event
                      </span>
                      <h1 className="text-xl sm:text-2xl md:text-3xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-purple-700 via-indigo-600 to-purple-700 drop-shadow-sm">
                        {event}
                      </h1>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="border-t border-[#E5E7EB]" />

              {/* META GRID (WIDER) */}
              <div className="px-6 sm:px-8 md:px-10 py-6 bg-gradient-to-br from-[#FAF7FF] via-white to-[#F4F4FB]">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 gap-4">
                  {/* Country */}
                  <div className="flex items-start gap-3 rounded-xl bg-white/85 border border-[#E4D7FB] px-4 py-3 shadow-sm">
                    <img src={locationicon} className="h-6 w-6 mt-1" />
                    <div>
                      <p className="text-xs text-[#6B7280] font-medium">
                        Country
                      </p>
                      <p className="text-base font-semibold text-[#5829A9]">
                        {country}
                      </p>
                    </div>
                  </div>

                  {/* Date */}
                  <div className="flex items-start gap-3 rounded-xl bg-white/85 border border-[#E4D7FB] px-4 py-3 shadow-sm">
                    <img src={dateicon} className="h-6 w-6 mt-1" />
                    <div>
                      <p className="text-xs text-[#6B7280] font-medium">Date</p>
                      <p className="text-base font-semibold text-[#240D3A]">
                        {date}
                      </p>
                    </div>
                  </div>

                  {/* Time */}
                  <div className="flex items-start gap-3 rounded-xl bg-white/85 border border-[#E4D7FB] px-4 py-3 shadow-sm">
                    <img src={timeicon} className="h-6 w-6 mt-1" />
                    <div>
                      <p className="text-xs text-[#6B7280] font-medium">
                        Time (GMT)
                      </p>
                      <p className="text-base font-semibold text-[#240D3A]">
                        {time.slice(0, 5)}
                      </p>
                    </div>
                  </div>

                  {/* Impact */}
                  <div className="flex items-start gap-3 rounded-xl bg-white/85 border border-[#E4D7FB] px-4 py-3 shadow-sm">
                    <img src={impacticon} className="h-6 w-6 mt-1" />
                    <div>
                      <p className="text-xs text-[#6B7280] font-medium">
                        Impact
                      </p>
                      <p className="text-base font-semibold text-[#DC2626]">
                        {impact}
                      </p>
                    </div>
                  </div>

                  {/* Frequency */}
                  <div className="flex items-start gap-3 rounded-xl bg-white/85 border border-[#E4D7FB] px-4 py-3 shadow-sm sm:col-span-2 lg:col-span-1 xl:col-span-1">
                    <img src={frequencyicon} className="h-6 w-6 mt-1" />
                    <div>
                      <p className="text-xs text-[#6B7280] font-medium">
                        Avg. event frequency
                      </p>
                      <p className="text-base font-semibold text-[#5829A9]">
                        {frequency_date}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <hr className="border-t border-[#E5E7EB]" />

              {/* EVENT COUNTS */}
              <div className="px-6 sm:px-8 md:px-10 py-6 bg-white rounded-2xl shadow-[0_8px_24px_rgba(0,0,0,0.06)] border border-[#E5E7EB]">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="font-semibold text-[#111827] text-lg tracking-tight">
                    Event Count Analytics
                  </h2>
                  {/* subtle meta (optional) */}
                  <span className="hidden sm:inline text-xs text-[#4B5563]">
                    {date ? `${date}` : ""}
                  </span>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* On Event Time */}
                  <div className="rounded-xl bg-[#F9FAFB] border border-[#E5E7EB] px-4 py-3 flex items-start sm:items-center gap-3">
                    <p className="font-medium text-[#4B5563] leading-snug">
                      Count on <span className="text-[#5829A9]">{date}</span> at{" "}
                      <span className="text-[#5829A9] tabular-nums">
                        {time.slice(0, 5)}
                      </span>
                      :
                    </p>

                    <span
                      className="font-semibold text-[#111827] shrink-0"
                      aria-live="polite"
                      aria-busy={clickeddate_Loading ? "true" : "false"}
                    >
                      {clickeddate_Loading ? (
                        <span className="loader1 text-red-400">Loading...</span>
                      ) : eventimpactontimespecificdate.every(
                        (i) => i === ""
                      ) ? (
                        "No data"
                      ) : (
                        eventimpactontimespecificdate
                      )}
                    </span>
                  </div>

                  {/* Before Event Time */}
                  <div className="rounded-xl bg-[#F9FAFB] border border-[#E5E7EB] px-4 py-3 flex items-start sm:items-center  gap-3">
                    <p className="font-medium text-[#4B5563] leading-snug">
                      Count on <span className="text-[#5829A9]">{date}</span>{" "}
                      before{" "}
                      <span className="text-[#5829A9] tabular-nums">
                        {time.slice(0, 5)}
                      </span>
                      :
                    </p>

                    <span
                      className="font-semibold text-[#111827] shrink-0"
                      aria-live="polite"
                      aria-busy={clickeddate_Loading ? "true" : "false"}
                    >
                      {clickeddate_Loading ? (
                        <span className="loader1 text-red-400">Loading...</span>
                      ) : eventimpactbeforetimespecificdate.every(
                        (i) => i === ""
                      ) ? (
                        "No data"
                      ) : (
                        eventimpactbeforetimespecificdate
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="flex flex-col md:flex-row justify-between mx-[3%] mt-[0.5%] 
    bg-white/70 backdrop-blur-lg p-4 md:p-5 rounded-xl shadow-[0_6px_20px_rgba(0,0,0,0.06)]
    border border-[#E4D7FB]"
          >
            {/* LEFT SECTION */}
            <div className="flex gap-5 items-center">
              {/* Back Button */}
              <IoArrowBack
                className="cursor-pointer mb-3 text-2xl text-[#4A3178] hover:text-[#6B21A8] transition-all"
                onClick={() => navigate("/user/economicdata")}
                title="Back Button"
              />

              {/* Select Range */}
              <div className="pr-3 mb-4 inline-block">
                <Space
                  style={{ width: "100%", paddingTop: 0, height: "46px" }}
                  direction="vertical"
                >
                  <FormControl sx={{ width: 220, height: 46 }}>
                    <InputLabel id="range-select-label">
                      Select Range
                    </InputLabel>
                    <Select
                      labelId="range-select-label"
                      value={eventRange}
                      defaultValue="6"
                      onChange={(e) => handleOptionChange(e.target.value)}
                      label="Events Range"
                      sx={{
                        height: 46,
                        borderRadius: "14px",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        border: "2px solid #7c3aed",
                        fontWeight: "600",
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        "&:hover": { boxShadow: "0 4px 12px rgba(124, 58, 237, 0.1)" },
                        "& .MuiSvgIcon-root": { color: "#7c3aed" },
                      }}
                    >
                      <MenuItem value="6">Last 6</MenuItem>
                      <MenuItem value="12">Last 12</MenuItem>
                      <MenuItem value="24">Last 24</MenuItem>
                    </Select>
                  </FormControl>
                </Space>
              </div>

              {/* Select Time */}
              <div className="pr-3 mb-4 inline-block">
                <Space
                  style={{ width: "100%", paddingTop: 0, height: "46px" }}
                  direction="vertical"
                >
                  <FormControl sx={{ width: 220, height: 46 }}>
                    <InputLabel id="time-select-label">Select Time</InputLabel>
                    <Select
                      labelId="time-select-label"
                      value={eventType}
                      defaultValue="1min"
                      onChange={(e) => handletimebtnclick(e.target.value)}
                      label="Select Time"
                      sx={{
                        height: 46,
                        borderRadius: "14px",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        border: "2px solid #7c3aed",
                        fontWeight: "600",
                        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        "&:hover": { boxShadow: "0 4px 12px rgba(124, 58, 237, 0.1)" },
                        "& .MuiSvgIcon-root": { color: "#7c3aed" },
                      }}
                    >
                      <MenuItem value="1min">1 min</MenuItem>
                      <MenuItem value="5min" disabled>
                        5 min
                      </MenuItem>
                      <MenuItem value="15min" disabled>
                        15 min
                      </MenuItem>
                      <MenuItem value="1hour" disabled>
                        1 hr
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Space>
              </div>
            </div>

            {/* RIGHT: BUTTONS */}
            <div className="flex items-center gap-3 mt-2 md:mt-0">
              {/* Generate Charts */}
              <div
                className={`h-[42px] px-4 text-[#240d3a] text-[14px] flex items-center 
      border border-[#A78BFA] rounded-[14px] shadow-sm transition-all
      ${isgraphbuttonDisabled
                    ? "cursor-not-allowed opacity-40 bg-[#F3E8FF]"
                    : "cursor-pointer hover:bg-[#F3E8FF] hover:shadow-md bg-white"
                  }`}
                onClick={
                  !isgraphbuttonDisabled ? handlegeneratechart : undefined
                }
              >
                <img
                  src={movementicon}
                  alt="graphs"
                  title="Generate Charts"
                  className="w-[22px] h-[22px]"
                />
                <h1 className="ml-2 font-semibold">Generate Charts</h1>
              </div>

              {/* Live Graph (Disabled) */}
              <div
                className={`h-[42px] px-4 text-[#240d3a] text-[14px] flex items-center 
      border border-[#A78BFA] rounded-[14px] bg-[#F5F3FF]
      cursor-not-allowed opacity-50`}
                disabled
              >
                <img
                  src={livegraph_icon}
                  className="w-[22px] h-[22px]"
                  alt="Live graph"
                  title="Live graph"
                />
                <h1 className="ml-2 font-semibold">Live Graph</h1>
              </div>

              {/* Refresh */}
              <div className="ml-1">
                <img
                  src={refresh_icon}
                  alt="Refresh"
                  title="Refresh"
                  className="h-[42px] w-[42px] cursor-pointer hover:rotate-90 transition-all duration-300"
                  onClick={handleModalShowClick}
                />
              </div>
            </div>
          </div>

          <div
            className="mx-[3%] my-3 mt-5 py-3 flex items-center justify-between 
  bg-white/80 backdrop-blur-sm rounded-xl border border-[#E4D7FB] 
  shadow-[0_8px_24px_rgba(36,13,58,0.06)] px-3 sm:px-4 md:px-5"
          >
            {/* LEFT: Heading + Tooltip */}
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="relative inline-block">
                {/* Dim background when tooltip is open */}
                {showTooltip && (
                  <div className="fixed inset-0 backdrop-blur-[1px] bg-black/5 z-10"></div>
                )}

                {/* Tooltip */}
                {showTooltip && (
                  <div
                    ref={tooltipRef}
                    className="
            w-[256px] md:w-[520px]
            absolute bottom-[135%] left-[220px] md:left-[420px]
            -translate-x-1/2 z-[99]
            rounded-xl bg-white border border-[#E4D7FB]
            shadow-[0_18px_45px_rgba(36,13,58,0.18)]
            text-[#240d3a] text-sm p-4
          "
                  >
                    <div className="bg-[#F8F5FF] rounded-lg p-3 flex flex-col md:flex-row gap-4">
                      {/* Summary Color Key */}
                      <div className="flex flex-col flex-1">
                        <h1 className="font-bold text-[#240d3a] text-[16px] md:text-[18px] mb-2">
                          Summary Color Key:
                        </h1>
                        <div className="mt-1 space-y-2">
                          <div className="flex items-center">
                            <h1 className="w-[175px] font-bold text-[#5a2989] md:text-[14px]">
                              Highest Average:
                            </h1>
                            <img
                              src={color1}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                          </div>
                          <div className="flex items-center">
                            <h1 className="w-[175px] font-bold text-[#5a2989] md:text-[14px]">
                              2nd Highest Average:
                            </h1>
                            <img
                              src={color2}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                          </div>
                          <div className="flex items-center">
                            <h1 className="w-[175px] font-bold text-[#5a2989] md:text-[14px]">
                              3rd Highest Average:
                            </h1>
                            <img
                              src={color3}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Table Color Key */}
                      <div className="flex flex-col flex-1">
                        <h1 className="font-bold text-[#240d3a] text-[16px] md:text-[18px] mb-2">
                          Table Color Key:
                        </h1>
                        <div className="mt-1 space-y-2">
                          <div className="flex items-center">
                            <h1 className="w-[175px] font-bold text-[#5a2989] md:text-[14px]">
                              {">500 % :"}
                            </h1>
                            <img
                              src={color4}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                          </div>
                          <div className="flex items-center">
                            <h1 className="w-[175px] font-bold text-[#5a2989] md:text-[14px]">
                              {"300-500 % :"}
                            </h1>
                            <img
                              src={color5}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                          </div>
                          <div className="flex items-center">
                            <h1 className="w-[175px] font-bold text-[#5a2989] md:text-[14px]">
                              {"<300 % :"}
                            </h1>
                            <img
                              src={color6}
                              title="color"
                              alt="color"
                              className="ml-4 w-[25px] h-[27px]"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Triangle Tip */}
                    <div
                      className="absolute bottom-[-10px] left-[8%] -translate-x-1/2 
            w-0 h-0 border-l-[10px] border-l-transparent 
            border-r-[10px] border-r-transparent 
            border-t-[10px] border-white"
                    ></div>
                  </div>
                )}
              </div>

              <h1 className="font-bold text-[18px] sm:text-[20px] text-[#240d3a] flex items-center gap-1">
                Event Volatility Impact
                <img
                  src={eye_btn_tooltip}
                  title="Information of Volatility Correlation Table"
                  alt="eye_btn_tooltip"
                  className="w-[22px] h-[24px] cursor-pointer pb-1 hover:scale-105 transition-transform"
                  onClick={handleImageClick}
                />
                <span>:</span>
              </h1>
            </div>

            {/* RIGHT: Final Selected Rows Button */}
            <div className="flex items-center justify-end mb-1">
              <h1
                className="rounded-[14px] flex justify-center items-center
        text-white bg-gradient-to-r from-[#240D3A] via-[#4B2C82] to-[#6D28D9]
        border border-[#5b6b8b] px-4 py-2 text-[14px] sm:text-[15px] font-bold
        cursor-pointer shadow-[0_10px_25px_rgba(36,13,58,0.25)]
        hover:shadow-[0_12px_30px_rgba(36,13,58,0.3)]
        hover:translate-y-[-1px] active:translate-y-[0px] transition-all"
                title="Click here for final selection of rows"
                onClick={handleSend}
              >
                Final Selected Rows
              </h1>
            </div>
          </div>

          {/* <button onClick={handleSend} className="btn">
          Send
        </button> */}

          <div className="overflow-auto relative">
            <div
              className={`mx-[3%] overflow-x-auto overflow-y-auto relative${optionValue === "last 6"
                ? "max-h-[103vh]"
                : optionValue === "last 12"
                  ? "max-h-[165vh]"
                  : optionValue === "last 24"
                    ? "max-h-[300vh]"
                    : ""
                }`}
            >
              <table
                className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
              >
                <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
                  <tr>
                    <th
                      className="bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white "
                      colSpan={12}
                    ></th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white  text-white"
                      colSpan={7}
                    >
                      % Price movement vs. prior 5 minute range (High-Low)
                    </th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
                      colSpan={7}
                    >
                      {`Total points moved post release (High – Low , (1min))`}
                    </th>
                    <th
                      className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
                      colSpan={11}
                    >
                      {`Total points moved post release (High – Low , (5min))`}
                    </th>
                  </tr>
                  <tr className="h-[81px]">
                    <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
                      Make selection
                    </th>
                    <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
                      S. No
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[73px]">Date</th>
                    <th className="sticky top-0 py-2 px-2 w-[91px]">
                      Time(GMT)
                    </th>
                    <th
                      className={`sticky top-0 py-2 px-2 w-[200px] min-w-[200px]`}
                    >
                      Event count before this time
                    </th>
                    <th className="sticky top-0 py-2 w-[150px] px-2 min-w-[150px]">
                      Event count at this time
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[77px]">
                      Previous
                    </th>
                    <th className="sticky top-0 py-2 px-2 w-[60px]">Actual</th>
                    <th className="sticky top-0 py-2 px-2 w-[77px]">
                      Estimate
                    </th>

                    <th className="sticky w-[97px] top-0 py-2 px-2  min-w-[99.33px]">
                      Act - Prev
                    </th>

                    <th className="z-[99] w-[98px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6]  min-w-[99.33px]">
                      Act - Est
                    </th>
                    <th className=" z-[99] w-[100px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6] bg-[#b38dd3] bg-opacity-[56%] ">
                      Final movement direction
                    </th>

                    {headers.map((header, index) => (
                      <th
                        key={header.id}
                        className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${index === headers.length - 1
                          ? "border-r-4 border-white"
                          : ""
                          }`}
                      >
                        {header.name}
                        {/* <br />
                        (severity) */}
                      </th>
                    ))}
                    {headers.map((header, index) => (
                      <th
                        key={header.id}
                        className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${index === headers.length - 1
                          ? "border-r-4 border-white"
                          : ""
                          }`}
                      >
                        {header.name}
                      </th>
                    ))}
                    {headers.map((header, index) => (
                      <th
                        key={header.id}
                        className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${index === headers.length - 1
                          ? "border-r-4 border-white"
                          : ""
                          }`}
                      >
                        {header.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
                  {volatilityImpact_firsttable.map((item, index) => {
                    // {console.log("me hu ji item jo aya hu map ke time pAR--->" , item)}
                    const itemDatecheck = item.date.split(" ")[0];

                    // Filtering impacthighlow array to find the matching data
                    const matchingData = impacthighlow.find((data) =>
                      data.startsWith(itemDatecheck)
                    );

                    const normalizeDate = (dateStr) => {
                      return dateStr.split(" ")[0];
                    };

                    const filterImpactData = (date) => {
                      const normalizedDate = normalizeDate(date);

                      return impacthighlowbeforethis.filter((impact) => {
                        const impactDate = impact.split(":")[0];

                        return impactDate === normalizedDate;
                      });
                    };

                    const impactData = filterImpactData(item.date);
                    return (
                      <>
                        <tr
                          key={index}
                          className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] "
                        >
                          <td>
                            <input
                              type="checkbox"
                              // item={geteditdata}

                              className="mt-0 ml-4"
                              onChange={(e) =>
                                handleCheckboxChange(e, item._id)
                              }
                              checked={selectedIds.includes(item._id)}
                            // checked={selectedIndexes.includes(index)}
                            //  checked={selectedIds.includes(item._id)}
                            />
                          </td>
                          <td className="py-2 min-w-[81px]">{index + 1}.</td>
                          <td className="py-2 ">{item.date}</td>
                          <td className="py-2 ">{item.time.slice(0, 5)}</td>

                          {run_modalloader ? (
                            <td className="min-w-[200px] w-[200px]">
                              {" "}
                              <span className="loader1 text-[#1c72ca] text-center">
                                Loading...
                              </span>
                            </td>
                          ) : (
                            <>
                              <td
                                className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
                                onClick={() =>
                                  handleShowModalbeforetime(item.date)
                                }
                              >
                                {impactData.length > 0 ? (
                                  impactData.map((impact, i) => {
                                    const impactParts = impact.split(" ");
                                    // Remove the first element (date and time)
                                    const formattedImpact = impactParts
                                      .slice(1)
                                      .join(" ");

                                    return (
                                      <span key={i} className="font-bold block">
                                        {formattedImpact}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <span className="font-bold">No Data</span>
                                )}
                              </td>

                              <dialog
                                id="my_modal_2"
                                onClick={() => {
                                  autoClickButton();
                                }}
                                className={` ${styles.addmodalDirection_eventhistory} modal p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 absolute max-h-[60vh]  top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                              >
                                <form
                                  method="dialog"
                                  className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
                                >
                                  <div className="modal-box relative top-[3px]">
                                    <div
                                      onClick={() => {
                                        autoClickButton();
                                      }}
                                    >
                                      <button id="aashima_id">
                                        <img
                                          alt="img"
                                          src={crossicon}
                                          className="w-[20px] h-[20px]"
                                        ></img>
                                      </button>
                                    </div>
                                    <div className="">
                                      {filteredModalData.length > 0 ? (
                                        <>
                                          {/* High Impact */}
                                          {filteredModalData.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "high"
                                          ) && (
                                              <div className="text-center flex items-center justify-center">
                                                <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                  High Impact :-
                                                </h3>
                                              </div>
                                            )}
                                          <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                            {filteredModalData.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event :{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}{" "}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>

                                          {/* Medium Impact */}
                                          {filteredModalData.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "medium"
                                          ) && (
                                              <div className="text-center flex items-center justify-center">
                                                <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                  Medium Impact :-
                                                </h3>
                                              </div>
                                            )}
                                          <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                            {filteredModalData.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />{" "}
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <p className="text-center mt-4">
                                          No Data
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </dialog>
                            </>
                          )}

                          {run_modalloader ? (
                            <td>
                              <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
                                Loading...
                              </span>
                            </td>
                          ) : (
                            <>
                              {" "}
                              <td
                                className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
                                onClick={() => handleShowModalontime(item.date)}
                              >
                                {matchingData && (
                                  <span className="font-bold text-[13px]">
                                    {matchingData.includes(": ")
                                      ? matchingData.substring(
                                        matchingData.indexOf(": ") + 2
                                      )
                                      : matchingData}
                                  </span>
                                )}
                              </td>
                              <dialog
                                id="my_modal_3"
                                onClick={() => {
                                  autoClickButton1();
                                }}
                                className={`  ${styles.addmodalDirection_eventhistory} modal p-6 absolute max-h-[60vh] top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                              >
                                <form
                                  method="dialog"
                                  className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
                                >
                                  <div className="modal-box relative top-[3px]">
                                    <div
                                      onClick={() => {
                                        autoClickButton1();
                                      }}
                                    >
                                      <button id="closemod11">
                                        <img
                                          alt="img"
                                          src={crossicon}
                                          className="w-[20px] h-[20px]"
                                        ></img>
                                      </button>
                                    </div>
                                    <div>
                                      {filteredModalDataontime.length > 0 ? (
                                        <>
                                          {/* High Impact */}
                                          {filteredModalDataontime.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "high"
                                          ) && (
                                              <div className="text-center flex items-center justify-center">
                                                <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                  High Impact :-
                                                </h3>
                                              </div>
                                            )}
                                          <div className="">
                                            {filteredModalDataontime.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}{" "}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event :{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}{" "}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>

                                          {/* Medium Impact */}
                                          {filteredModalDataontime.some(
                                            (data) =>
                                              data.impact.toLowerCase() ===
                                              "medium"
                                          ) && (
                                              <div className="text-center flex items-center justify-center">
                                                <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                  Medium Impact :-
                                                </h3>
                                              </div>
                                            )}
                                          <div className="">
                                            {filteredModalDataontime.map(
                                              (data, index) => {
                                                if (
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                                ) {
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="text-start pl-[20px] my-4"
                                                    >
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={dateicon}
                                                            alt="dateicon"
                                                            className="h-[20px] w-[20px] mr-2  "
                                                          />{" "}
                                                          Date:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.date}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={timeicon}
                                                            alt="timeicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Time:{" "}
                                                        </span>
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.time.slice(
                                                            0,
                                                            5
                                                          )}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={locationicon}
                                                            alt="locationicon"
                                                            className="h-[20px] w-[20px] mr-2 font-bold "
                                                          />{" "}
                                                          Country:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.country}
                                                        </span>
                                                      </p>
                                                      <p className="flex items-center mb-[6px] text-[16px]">
                                                        <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                          <img
                                                            src={eventicon}
                                                            alt="eventicon"
                                                            className="h-[20px] w-[20px] mr-2 "
                                                          />{" "}
                                                          Event:
                                                        </span>{" "}
                                                        <span className="text-[#5a2989]">
                                                          {" "}
                                                          {data.event}
                                                        </span>
                                                      </p>
                                                      <hr />
                                                    </div>
                                                  );
                                                }
                                                return null;
                                              }
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        <p className="text-center mt-4">
                                          No Data
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </form>
                              </dialog>
                            </>
                          )}

                          <td className="py-2 ">{item.previous}</td>
                          <td className="py-2 ">{item.actual}</td>
                          <td className="py-2 ">{item.estimate}</td>

                          <td
                            className={`py-2 text-[#240d3a] font-bold ${item.actualminusprevious == null ||
                              item.actualminusprevious === "N/A" ||
                              item.actualminusprevious === ""
                              ? "bg-[#E5E7EB]"
                              : parseFloat(item.actualminusprevious) > 0
                                ? "bg-[#5de98e]"
                                : parseFloat(item.actualminusprevious) === 0
                                  ? "bg-[#f1d500]"
                                  : parseFloat(item.actualminusprevious) < 0
                                    ? "bg-[#ff8e8ef2]"
                                    : "bg-[#E5E7EB]"
                              }`}
                          >
                            {item.actualminuspreviousdivestimate != null &&
                              item.actualminuspreviousdivestimate !== "N/A"
                              ? item.actualminuspreviousdivestimate
                              : "N/A"}

                            <br />

                            {item.actualminusprevious != null &&
                              item.actualminusprevious !== "N/A"
                              ? `(${item.actualminusprevious})`
                              : ""}
                          </td>

                          <td
                            className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${item.actualminusestimate == null ||
                              item.actualminusestimate === "N/A" ||
                              item.actualminusestimate === ""
                              ? "bg-[#E5E7EB]"
                              : parseFloat(item.actualminusestimate) > 0
                                ? "bg-[#5de98e]"
                                : parseFloat(item.actualminusestimate) === 0
                                  ? "bg-[#f1d500]"
                                  : parseFloat(item.actualminusestimate) < 0
                                    ? "bg-[#ff8e8ef2]"
                                    : "bg-[#E5E7EB]"
                              }`}
                          >
                            {item.actualminusestimatedivestimate != null &&
                              item.actualminusestimatedivestimate !== "N/A"
                              ? item.actualminusestimatedivestimate
                              : "N/A"}

                            <br />

                            {item.actualminusestimate != null &&
                              item.actualminusestimate !== "N/A"
                              ? `(${item.actualminusestimate})`
                              : ""}
                          </td>

                          <td
                            className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
                              // background color logic (based on which value is used)
                              item.actualminusestimate == null ||
                                item.actualminusestimate === "N/A" ||
                                item.actualminusestimate === ""
                                ? // use actualminusprevious color if estimate invalid
                                parseFloat(item.actualminusprevious) > 0
                                  ? "bg-[#5de98e]"
                                  : parseFloat(item.actualminusprevious) === 0
                                    ? "bg-[#f1d500]"
                                    : parseFloat(item.actualminusprevious) < 0
                                      ? "bg-[#ff8e8ef2]"
                                      : "bg-[#E5E7EB]"
                                : // use actualminusestimate color normally
                                parseFloat(item.actualminusestimate) > 0
                                  ? "bg-[#5de98e]"
                                  : parseFloat(item.actualminusestimate) === 0
                                    ? "bg-[#f1d500]"
                                    : parseFloat(item.actualminusestimate) < 0
                                      ? "bg-[#ff8e8ef2]"
                                      : "bg-[#E5E7EB]"
                              }`}
                          >
                            {/* Fallback logic display */}
                            {item.actualminusestimate == null ||
                              item.actualminusestimate === "N/A" ||
                              item.actualminusestimate === "" ? (
                              <>
                                {item.actualminuspreviousdivestimate != null &&
                                  item.actualminuspreviousdivestimate !== "N/A"
                                  ? item.actualminuspreviousdivestimate
                                  : "N/A"}
                                <br />
                                {item.actualminusprevious != null &&
                                  item.actualminusprevious !== "N/A"
                                  ? `(${item.actualminusprevious})`
                                  : ""}
                              </>
                            ) : (
                              <>
                                {item.actualminusestimatedivestimate != null &&
                                  item.actualminusestimatedivestimate !== "N/A"
                                  ? item.actualminusestimatedivestimate
                                  : "N/A"}
                                <br />
                                {item.actualminusestimate != null &&
                                  item.actualminusestimate !== "N/A"
                                  ? `(${item.actualminusestimate})`
                                  : ""}
                              </>
                            )}
                          </td>

                          {/* <td
                            className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
                              item.actualminusestimate == null ||
                              item.actualminusestimate === "N/A" ||
                              item.actualminusestimate === ""
                                ? "bg-[#E5E7EB]"
                                : parseFloat(item.actualminusestimate) > 0
                                ? "bg-[#5de98e]"
                                : parseFloat(item.actualminusestimate) === 0
                                ? "bg-[#f1d500]"
                                : parseFloat(item.actualminusestimate) < 0
                                ? "bg-[#ff8e8ef2]"
                                : "bg-[#E5E7EB]"
                            }`}
                          >
                            {item.actualminusestimatedivestimate != null &&
                            item.actualminusestimatedivestimate !== "N/A"
                              ? item.actualminusestimatedivestimate
                              : "N/A"}

                            <br />

                            {item.actualminusestimate != null &&
                            item.actualminusestimate !== "N/A"
                              ? `(${item.actualminusestimate})`
                              : ""}
                          </td> */}
                          {/* <---------1st section table-------------> */}

                          {headers.map((header, index) => {
                            // {console.log("----> me hu ji header thike",headers , header,item,header.name.split("/").join("").toLowerCase() + "1minprevfive")}

                            return (
                              <td
                                className={`border-[#F6F6F6] min-w-[91.95px] ${parseFloat(
                                  item[
                                    header.name
                                      .split("/")
                                      .join("")
                                      .toLowerCase() + "1minprevfive"
                                  ]?.[0]?.highlow
                                ) > 500
                                  ? "bg-[#7fe9a4]"
                                  : parseFloat(
                                    item[
                                      header.name
                                        .split("/")
                                        .join("")
                                        .toLowerCase() + "1minprevfive"
                                    ]?.[0]?.highlow
                                  ) >= 300 &&
                                    parseFloat(
                                      item[
                                        header.name
                                          .split("/")
                                          .join("")
                                          .toLowerCase() + "1minprevfive"
                                      ]?.[0]?.highlow
                                    ) <= 500
                                    ? "bg-[#f7dc14]"
                                    : parseFloat(
                                      item[
                                        header.name
                                          .split("/")
                                          .join("")
                                          .toLowerCase() + "1minprevfive"
                                      ]?.[0]?.highlow
                                    ) < 300
                                      ? "bg-[#f3b2b2]"
                                      : "bg-[#E5E7EB]"
                                  }  ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {item[
                                  header.name
                                    .split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1minprevfive"
                                ][0]?.highlow || "N/A"}
                                {/* {JSON.stringify(item[
                                  header.name
                                    .split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1minprevfive"
                                ][0])} */}
                              </td>
                            );
                          })}

                          {headers.map((header, index) => {
                            //
                            return (
                              <td
                                className={`border-[#F6F6F6] min-w-[91.95px] ${parseFloat(
                                  item[
                                    header.name
                                      .split("/")
                                      .join("")
                                      .toLowerCase() + "1minprevfive"
                                  ]?.[0]?.highlow
                                ) > 500
                                  ? "bg-[#7fe9a4]"
                                  : parseFloat(
                                    item[
                                      header.name
                                        .split("/")
                                        .join("")
                                        .toLowerCase() + "1minprevfive"
                                    ]?.[0]?.highlow
                                  ) >= 300 &&
                                    parseFloat(
                                      item[
                                        header.name
                                          .split("/")
                                          .join("")
                                          .toLowerCase() + "1minprevfive"
                                      ]?.[0]?.highlow
                                    ) <= 500
                                    ? "bg-[#f7dc14]"
                                    : parseFloat(
                                      item[
                                        header.name
                                          .split("/")
                                          .join("")
                                          .toLowerCase() + "1minprevfive"
                                      ]?.[0]?.highlow
                                    ) < 300
                                      ? "bg-[#f3b2b2]"
                                      : "bg-[#E5E7EB]"
                                  }  ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {item[
                                  header?.name
                                    ?.split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1min"
                                ][0]?.highlow || "N/A"}
                              </td>
                            );
                          })}

                          {headers.map((header, index) => {
                            const colorcodeofTable1 =
                              item[
                                header.name.split("/").join("").toLowerCase() +
                                "1minnextfive"
                              ]?.[0]?.highlow;

                            const dividedValue =
                              colorcodeofTable1 /
                              item[
                                header.name.split("/").join("").toLowerCase() +
                                "1min"
                              ]?.[0]?.highlow;
                            //

                            return (
                              <td
                                className={`border-[#F6F6F6] min-w-[91.95px] ${dividedValue >= 1.5
                                  ? "bg-[#7fe9a4]"
                                  : dividedValue >= 1.2 && dividedValue < 1.5
                                    ? "bg-[#f7dc14]"
                                    : dividedValue < 1.2
                                      ? "bg-[#f3b2b2]"
                                      : "bg-[#E5E7EB]"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {item[
                                  header.name
                                    .split("/")
                                    .join("")
                                    ?.toLocaleLowerCase() + "1minnextfive"
                                ][0]?.highlow || "N/A"}
                              </td>
                            );
                          })}
                        </tr>
                      </>
                    );
                  })}

                  {/* <------normal average of 1st table------> */}
                  <tr className="bg-[#dccafe5e] text-center">
                    <td
                      className="py-2 font-bold min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
                      colSpan={4}
                    >
                      Non-Zero event (average movement)
                    </td>

                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className={`py-2 border-r-4 border-white`}></td>

                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_nonzero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key
                            ? parseFloat(
                              item[key].highminlowprevfive.replace("%", "")
                            )
                            : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];

                      let filterObject =
                        volatilityImpact_firsttable_nonzero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      console.log("filterObject", filterObject)
                      if (filterObject) {
                        let rawValue =
                          filterObject[Object.keys(filterObject)[0]]
                            .highminlowprevfive;
                        let value = parseFloat(rawValue.replace("%", ""));

                        // console.log("value" , value)
                        let bgColor = "";
                        if (value === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (value === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (value === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {rawValue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_nonzero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlow : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_nonzero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];

                      const finalValue =
                        filterObject[Object.keys(filterObject)[0]].highminlow;
                      // console.log("finalValue" , finalValue)

                      let bgColor = "";
                      if (finalValue === highest) {
                        bgColor = "text-[#089ee4]";
                      } else if (finalValue === secondHighest) {
                        bgColor = "text-[#52aed8]";
                      } else if (finalValue === thirdHighest) {
                        bgColor = "text-[#88c3d4]";
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              } `}
                          >
                            {finalValue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_nonzero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlownextfive : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_nonzero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];

                      const finaldata =
                        filterObject[Object.keys(filterObject)[0]]
                          .highminlownextfive;
                      let bgColor = "";
                      if (finaldata === highest) {
                        bgColor = "text-[#089ee4]";
                      } else if (finaldata === secondHighest) {
                        bgColor = "text-[#52aed8]";
                      } else if (finaldata === thirdHighest) {
                        bgColor = "text-[#88c3d4]";
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor}  ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {finaldata}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                  </tr>

                  {/* <------FLAT Average of 3rd table------> */}
                  <tr className="bg-[#dccafe5e] text-center">
                    <td
                      className="py-2  font-bold   min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
                      colSpan={4}
                    >
                      Flat event (average movement)
                    </td>

                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2 "></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className="py-2"></td>
                    <td className={`py-2 border-r-4 border-white`}></td>
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_zero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key
                            ? parseFloat(item[key].highminlowprevfive)
                            : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_zero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      const rawValue =
                        filterObject[Object.keys(filterObject)[0]]
                          .highminlowprevfive;
                      const Value = parseFloat(rawValue.replace("%", ""));

                      let bgColor = "";

                      if (Value > 0) {
                        if (Value === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (Value === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (Value === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {rawValue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_zero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlow : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_zero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      const finalvalue =
                        filterObject[Object.keys(filterObject)[0]].highminlow;

                      let bgColor = "";
                      if (finalvalue > 0) {
                        if (finalvalue === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (finalvalue === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (finalvalue === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {finalvalue}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                    {headers.map((header, index) => {
                      const allValues = volatilityImpact_firsttable_zero
                        .map((item) => {
                          let key = Object.keys(item).find((k) =>
                            k.includes("1min")
                          );
                          return key ? item[key].highminlownextfive : null;
                        })
                        .filter((value) => !isNaN(value)); // Ensure only numeric values

                      // Get unique sorted values
                      const sortedValues = [...new Set(allValues)].sort(
                        (a, b) => b - a
                      );
                      // console.log("sortedValues" , sortedValues)
                      const highest = sortedValues[0];
                      const secondHighest = sortedValues[1];
                      const thirdHighest = sortedValues[2];
                      let filterObject =
                        volatilityImpact_firsttable_zero.filter((item) =>
                          Object.keys(item).includes(header.id + "1min")
                        )[0];
                      const finaldata =
                        filterObject[Object.keys(filterObject)[0]]
                          .highminlownextfive;

                      let bgColor = "";

                      if (finaldata > 0) {
                        if (finaldata === highest) {
                          bgColor = "text-[#089ee4]";
                        } else if (finaldata === secondHighest) {
                          bgColor = "text-[#52aed8]";
                        } else if (finaldata === thirdHighest) {
                          bgColor = "text-[#88c3d4]";
                        }
                      }
                      if (filterObject) {
                        return (
                          <td
                            className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {finaldata}
                          </td>
                        );
                      } else {
                        return <td>N/A</td>;
                      }
                    })}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* <---second table ----> */}

          {Loading_3rdtable ? (
            <div className="mt-5 flex justify-center">
              <div
                className="
        w-full max-w-[90%] mx-auto
        rounded-xl border border-[#E4D7FB]
        bg-gradient-to-br from-[#F9FAFF] via-white to-[#F3E8FF]
        shadow-[0_10px_35px_rgba(15,23,42,0.10)]
        px-4 sm:px-6 md:px-8 py-6
        flex flex-col items-center justify-center
      "
              >
                <h2 className="font-semibold text-center text-[#240D3A] text-lg">
                  Please wait…
                </h2>

                <p className="mt-1 text-sm text-[#6B7280] text-center">
                  Correlation & Average Movement Tables are loading
                </p>

                <div className="flex items-center justify-center mt-6">
                  <RingLoader
                    height="80"
                    width="80"
                    color="#94A3B8"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="m-3 py-2 px-3 mt-4 flex">
                <div className="relative inline-flex items-center gap-2 ml-[2%]">
                  {/* Overlay blur when tooltip is open */}
                  {showTooltip2 && (
                    <div className="fixed inset-0 backdrop-blur-[1px] z-10" />
                  )}

                  {/* Tooltip */}
                  {showTooltip2 && (
                    <div
                      ref={tooltipRef}
                      className="
          absolute bottom-[135%] left-1/2 -translate-x-1/2
          w-[260px] md:w-[520px]
          rounded-2xl bg-white/95 border border-[#E4D7FB]
          shadow-[0_18px_45px_rgba(15,23,42,0.14)]
          text-[#240d3a] text-sm
          p-4 md:p-5
          z-[99]
        "
                    >
                      <div className="space-y-4">
                        {/* Definitions */}
                        <div className="space-y-3 bg-[#F9FAFB] rounded-xl px-3 py-3 border border-[#E5E7EB]">
                          <h1 className="font-semibold text-[14px] md:text-[15px] text-[#111827]">
                            Non-Zero Events:
                            <span className="block md:inline font-normal text-[#5a2989] text-[13px] md:text-[14px] mt-1 md:mt-0 md:ml-1">
                              Actual release values differing from the estimated
                              value, and from the previous release value when
                              equal to the estimated value.
                            </span>
                          </h1>

                          <h1 className="font-semibold text-[14px] md:text-[15px] text-[#111827]">
                            Flat Events:
                            <span className="block md:inline font-normal text-[#5a2989] text-[13px] md:text-[14px] mt-1 md:mt-0 md:ml-1">
                              Actual release values are the same as the
                              estimated value and the previous release value.
                            </span>
                          </h1>
                        </div>

                        {/* Summary Color Key */}
                        <div className="bg-[#F8F5FF] rounded-xl px-3 py-3 border border-[#E4D7FB]">
                          <h2 className="font-semibold text-[15px] text-[#240d3a] mb-2">
                            Summary Color Key
                          </h2>
                          <div className="space-y-2">
                            <div className="flex items-center">
                              <h1 className="w-[165px] font-medium text-[#5a2989] text-[13px] md:text-[14px]">
                                Highest Average:
                              </h1>
                              <img
                                src={color1}
                                title="color"
                                alt="color"
                                className="ml-3 w-[24px] h-[24px]"
                              />
                            </div>
                            <div className="flex items-center">
                              <h1 className="w-[165px] font-medium text-[#5a2989] text-[13px] md:text-[14px]">
                                2nd Highest Average:
                              </h1>
                              <img
                                src={color2}
                                title="color"
                                alt="color"
                                className="ml-3 w-[24px] h-[24px]"
                              />
                            </div>
                            <div className="flex items-center">
                              <h1 className="w-[165px] font-medium text-[#5a2989] text-[13px] md:text-[14px]">
                                3rd Highest Average:
                              </h1>
                              <img
                                src={color3}
                                title="color"
                                alt="color"
                                className="ml-3 w-[24px] h-[24px]"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Table Color Key */}
                        <div className="bg-[#F9FAFB] rounded-xl px-3 py-3 border border-[#E5E7EB]">
                          <h2 className="font-semibold text-[15px] text-[#240d3a] mb-2">
                            Table Color Key
                          </h2>
                          <div className="space-y-2">
                            <div className="flex items-center">
                              <h1 className="w-[165px] font-medium text-[#5a2989] text-[13px] md:text-[14px]">
                                Positive values:
                              </h1>
                              <img
                                src={color7}
                                title="color"
                                alt="color"
                                className="ml-3 w-[24px] h-[24px]"
                              />
                            </div>
                            <div className="flex items-center">
                              <h1 className="w-[165px] font-medium text-[#5a2989] text-[13px] md:text-[14px]">
                                Flat values:
                              </h1>
                              <img
                                src={color8}
                                title="color"
                                alt="color"
                                className="ml-3 w-[24px] h-[24px]"
                              />
                            </div>
                            <div className="flex items-center">
                              <h1 className="w-[165px] font-medium text-[#5a2989] text-[13px] md:text-[14px]">
                                Negative values:
                              </h1>
                              <img
                                src={color9}
                                title="color"
                                alt="color"
                                className="ml-3 w-[24px] h-[24px]"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Triangle Tip */}
                      <div className="absolute bottom-[-10px] left-10 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white" />
                    </div>
                  )}

                  {/* Heading + icon */}
                  <h1 className="ml-1 font-bold text-[18px] sm:text-[20px] text-[#240d3a]">
                    Event Volatility Correlation
                  </h1>
                  <img
                    src={eye_btn_tooltip}
                    title="Information of Volatility Correlation Table"
                    alt="eye_btn_tooltip"
                    className="w-[24px] h-[27px] cursor-pointer pb-1"
                    onClick={handleImageClick2}
                  />
                  <span className="text-[18px] text-[#9CA3AF] font-semibold">
                    :
                  </span>
                </div>
              </div>

              {/* <------------------second table--------------> */}
              <div className="overflow-auto relative">
                {/* <div className="  mx-[3%] overflow-x-auto overflow-y-auto  max-h-[91vh] "> */}
                <div
                  className={`mx-[3%] overflow-x-auto overflow-y-auto relative ${optionValue === "last 6"
                    ? "max-h-[91vh]"
                    : optionValue === "last 12"
                      ? "max-h-[130vh]"
                      : optionValue === "last 24"
                        ? "max-h-[214vh]"
                        : ""
                    }`}
                >
                  <table
                    className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
                  >
                    <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
                      <tr>
                        <th
                          className="bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white "
                          colSpan={12}
                        ></th>
                        <th
                          className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white  text-white"
                          colSpan={7}
                        >
                          {`Close price - Open Price ${timeclickedurl_state === 1
                            ? "(1min)"
                            : timeclickedurl_state === 5
                              ? "(5min)"
                              : timeclickedurl_state === 15
                                ? "(15min)"
                                : timeclickedurl_state === 60
                                  ? "(1hour)"
                                  : "(1min)"
                            }`}
                        </th>
                        <th
                          className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
                          colSpan={7}
                        >
                          {`Low price - Open Price ${timeclickedurl_state === 1
                            ? "(1min)"
                            : timeclickedurl_state === 5
                              ? "(5min)"
                              : timeclickedurl_state === 15
                                ? "(15min)"
                                : timeclickedurl_state === 60
                                  ? "(1hour)"
                                  : "(1min)"
                            }`}
                        </th>
                        <th
                          className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
                          colSpan={12}
                        >
                          {`High price - Open Price ${timeclickedurl_state === 1
                            ? "(1min)"
                            : timeclickedurl_state === 5
                              ? "(5min)"
                              : timeclickedurl_state === 15
                                ? "(15min)"
                                : timeclickedurl_state === 60
                                  ? "(1hour)"
                                  : "(1min)"
                            }`}
                        </th>
                      </tr>
                      <tr className="h-[81px]">
                        <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
                          Make selection
                        </th>
                        <th className="sticky top-0 py-2 px-2">S. No</th>
                        <th className="sticky top-0 py-2 px-2">Date</th>
                        <th className="sticky top-0 py-2 px-2">Time(GMT)</th>
                        <th className="sticky top-0 py-2 px-2  min-w-[200px] w-[200px]">
                          Event count before this time
                        </th>
                        <th className="sticky top-0 py-2 px-2  min-w-[150px] w-[150px]">
                          Event count at this time
                        </th>

                        <th className="sticky top-0 py-2 px-2">Previous</th>

                        <th className="sticky top-0 py-2 px-2">Actual</th>
                        <th className="sticky top-0 py-2 px-2">Estimate</th>
                        <th className="sticky top-0 py-2 px-2  w-[97px]  min-w-[95.99px]">
                          Act - Prev
                        </th>
                        <th className="sticky top-0 py-2 px-2  border-r-4 border-[#F6F6F6] w-[98px]  min-w-[95.99px] ">
                          Act - Est
                        </th>
                        <th className="sticky top-0 py-2 px-2  border-r-4 bg-[#b38dd3] bg-opacity-[56%] border-[#F6F6F6] w-[100px] min-w-[95.99px] ">
                          Final movement direction
                        </th>

                        {headers.map((header, index) => (
                          <th
                            key={header.id}
                            className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {header.name}
                            <br />
                            movement
                          </th>
                        ))}

                        {headers.map((header, index) => (
                          <th
                            key={header.id}
                            className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {header.name}
                            <br />
                            movement
                          </th>
                        ))}
                        {headers.map((header, index) => (
                          <th
                            key={header.id}
                            className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${index === headers.length - 1
                              ? "border-r-4 border-white"
                              : ""
                              }`}
                          >
                            {header.name}
                            <br />
                            movement
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
                      {volatilityImpact_secondtable.map((item, index) => {
                        const matchingFirstTableItem = volatilityImpact_firsttable.find((ftItem) =>
                          ftItem.date === item.date &&
                          ftItem.time === item.time &&
                          ftItem.country === item.country &&
                          ftItem.event === item.event
                        );
                        console.log(item, "item")
                        // User wants SIGN from first table.
                        const colorItem = matchingFirstTableItem || item;
                        const itemDatecheck = item.date.split(" ")[0];
                        const secondTableDateKey = item?.date?.split(" ")[0] ?? "";
                        const secondTableTimeKey = item?.time?.slice(0, 5) ?? "";
                        const secondTableKey = `${secondTableDateKey}${secondTableTimeKey}`;
                        const estimateRaw = item?.estimate;
                        const estimateString =
                          estimateRaw === null || estimateRaw === undefined
                            ? ""
                            : String(estimateRaw).trim();
                        const estimateNumber =
                          estimateString === "" ? NaN : parseFloat(estimateString);
                        const isEstimateZero =
                          estimateString !== "" &&
                          !Number.isNaN(estimateNumber) &&
                          estimateNumber === 0;
                        const shouldHighlight =
                          missingEstimateKeys.has(secondTableKey) && isEstimateZero;

                        // Filtering impacthighlow array to find the matching data
                        const matchingData = impacthighlow.find((data) =>
                          data.startsWith(itemDatecheck)
                        );

                        const normalizeDate = (dateStr) => {
                          return dateStr.split(" ")[0];
                        };

                        const filterImpactData = (date) => {
                          const normalizedDate = normalizeDate(date);

                          return impacthighlowbeforethis.filter((impact) => {
                            const impactDate = impact.split(":")[0];

                            return impactDate === normalizedDate;
                          });
                        };

                        const impactData = filterImpactData(item.date);

                        // ✅ NEW: helpers + ACT-PREV/ACT-EST calculation
                        const toNum = (v) => {
                          if (v == null) return null;
                          if (v === "N/A" || v === "") return null;
                          const n = Number(v);
                          return Number.isFinite(n) ? n : null;
                        };

                        const actualNum = toNum(item.actual);
                        const prevNum = toNum(item.previous);
                        const estNum = toNum(item.estimate);

                        const actPrev =
                          actualNum == null || prevNum == null
                            ? "N/A"
                            : actualNum - prevNum;
                        const actEst =
                          actualNum == null || estNum == null
                            ? "N/A"
                            : actualNum - estNum;

                        const getSign = (val) => {
                          if (val === "N/A" || val == null) return "N/A";
                          const n = Number(val);
                          if (!Number.isFinite(n)) return "N/A";
                          if (n > 0) return "+";
                          if (n < 0) return "-";
                          return "0";
                        };

                        const getBg = (val) => {
                          const sign = getSign(val);
                          if (sign === "N/A") return "bg-[#E5E7EB]";
                          if (sign === "+") return "bg-[#5de98e]";
                          if (sign === "0") return "bg-[#f1d500]";
                          return "bg-[#ff8e8ef2]";
                        };

                        return (
                          <>
                            <tr
                              key={index}
                              className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] relative"
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  className="mt-0 ml-4"
                                  onChange={(e) =>
                                    handleCheckboxChange(e, item._id)
                                  }
                                  checked={selectedIds.includes(item._id)}
                                />
                              </td>

                              <td className="py-2 min-w-[81px]">
                                {index + 1}.
                              </td>
                              <td className="py-2 ">{item.date}</td>
                              <td className="py-2 ">{item.time.slice(0, 5)}</td>

                              {/* <---today----> */}
                              {run_modalloader ? (
                                <td className="min-w-[200px] w-[200px]">
                                  <span className="loader1 text-[#1c72ca] text-center">
                                    Loading...
                                  </span>
                                </td>
                              ) : (
                                <>
                                  <td
                                    className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
                                    onClick={() =>
                                      handleShowModalbeforetime_2nd_table(
                                        item.date
                                      )
                                    }
                                  >
                                    {impactData.length > 0 ? (
                                      impactData.map((impact, i) => {
                                        const impactParts = impact.split(" ");
                                        const formattedImpact = impactParts
                                          .slice(1)
                                          .join(" ");
                                        return (
                                          <span
                                            key={i}
                                            className="font-bold block"
                                          >
                                            {formattedImpact}
                                          </span>
                                        );
                                      })
                                    ) : (
                                      <span className="font-bold">No Data</span>
                                    )}
                                  </td>

                                  <dialog
                                    id="my_modal_2_2nd_table"
                                    onClick={() => {
                                      autoClickButton_2nd_table();
                                    }}
                                    className={` ${styles.addmodalDirection_eventhistory_2ndTable} modal p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 absolute max-h-[60vh]  top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                                  >
                                    <form
                                      method="dialog"
                                      className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
                                    >
                                      <div className="modal-box relative top-[3px]">
                                        <div
                                          onClick={() => {
                                            autoClickButton_2nd_table();
                                          }}
                                        >
                                          <button id="aashima_id_2nd_table">
                                            <img
                                              alt="img"
                                              src={crossicon}
                                              className="w-[20px] h-[20px]"
                                            />
                                          </button>
                                        </div>

                                        <div className="">
                                          {filteredModalData.length > 0 ? (
                                            <>
                                              {/* High Impact */}
                                              {filteredModalData.some(
                                                (data) =>
                                                  data.impact.toLowerCase() ===
                                                  "high"
                                              ) && (
                                                  <div className="text-center flex items-center justify-center">
                                                    <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
                                                      High Impact :-
                                                    </h3>
                                                  </div>
                                                )}
                                              <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                                {filteredModalData.map(
                                                  (data, index) => {
                                                    if (
                                                      data.impact.toLowerCase() ===
                                                      "high"
                                                    ) {
                                                      return (
                                                        <div
                                                          key={index}
                                                          className="text-start pl-[20px] my-4"
                                                        >
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={dateicon}
                                                                alt="dateicon"
                                                                className="h-[20px] w-[20px] mr-2  "
                                                              />
                                                              Date:
                                                            </span>{" "}
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.date}{" "}
                                                            </span>
                                                          </p>
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={timeicon}
                                                                alt="timeicon"
                                                                className="h-[20px] w-[20px] mr-2 "
                                                              />
                                                              Time:{" "}
                                                            </span>
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.time.slice(
                                                                0,
                                                                5
                                                              )}{" "}
                                                            </span>
                                                          </p>
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={
                                                                  locationicon
                                                                }
                                                                alt="locationicon"
                                                                className="h-[20px] w-[20px] mr-2 font-bold "
                                                              />{" "}
                                                              Country:{" "}
                                                            </span>
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {
                                                                data.country
                                                              }{" "}
                                                            </span>
                                                          </p>
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={eventicon}
                                                                alt="eventicon"
                                                                className="h-[20px] w-[20px] mr-2 "
                                                              />{" "}
                                                              Event :{" "}
                                                            </span>
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.event}{" "}
                                                            </span>
                                                          </p>
                                                          <hr />
                                                        </div>
                                                      );
                                                    }
                                                    return null;
                                                  }
                                                )}
                                              </div>

                                              {/* Medium Impact */}
                                              {filteredModalData.some(
                                                (data) =>
                                                  data.impact.toLowerCase() ===
                                                  "medium"
                                              ) && (
                                                  <div className="text-center flex items-center justify-center">
                                                    <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
                                                      Medium Impact :-
                                                    </h3>
                                                  </div>
                                                )}
                                              <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
                                                {filteredModalData.map(
                                                  (data, index) => {
                                                    if (
                                                      data.impact.toLowerCase() ===
                                                      "medium"
                                                    ) {
                                                      return (
                                                        <div
                                                          key={index}
                                                          className="text-start pl-[20px] my-4"
                                                        >
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={dateicon}
                                                                alt="dateicon"
                                                                className="h-[20px] w-[20px] mr-2  "
                                                              />{" "}
                                                              Date:
                                                            </span>{" "}
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.date}
                                                            </span>
                                                          </p>
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={timeicon}
                                                                alt="timeicon"
                                                                className="h-[20px] w-[20px] mr-2 "
                                                              />{" "}
                                                              Time:{" "}
                                                            </span>
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.time.slice(
                                                                0,
                                                                5
                                                              )}
                                                            </span>
                                                          </p>
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={
                                                                  locationicon
                                                                }
                                                                alt="locationicon"
                                                                className="h-[20px] w-[20px] mr-2 font-bold "
                                                              />{" "}
                                                              Country:
                                                            </span>{" "}
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.country}
                                                            </span>
                                                          </p>
                                                          <p className="flex items-center mb-[6px] text-[16px]">
                                                            <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
                                                              <img
                                                                src={eventicon}
                                                                alt="eventicon"
                                                                className="h-[20px] w-[20px] mr-2 "
                                                              />{" "}
                                                              Event:
                                                            </span>{" "}
                                                            <span className="text-[#5a2989]">
                                                              {" "}
                                                              {data.event}
                                                            </span>
                                                          </p>
                                                          <hr />
                                                        </div>
                                                      );
                                                    }
                                                    return null;
                                                  }
                                                )}
                                              </div>
                                            </>
                                          ) : (
                                            <p className="text-center mt-4">
                                              No Data
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </form>
                                  </dialog>
                                </>
                              )}

                              {run_modalloader ? (
                                <td>
                                  <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
                                    Loading...
                                  </span>
                                </td>
                              ) : (
                                <>
                                  <td
                                    className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
                                    onClick={() =>
                                      handleShowModalontime_2nd_table(item.date)
                                    }
                                  >
                                    {matchingData && (
                                      <span className="font-bold text-[13px]">
                                        {matchingData.includes(": ")
                                          ? matchingData.substring(
                                            matchingData.indexOf(": ") + 2
                                          )
                                          : matchingData}
                                      </span>
                                    )}
                                  </td>

                                  <dialog
                                    id="my_modal_3_2nd_table"
                                    onClick={() => {
                                      autoClickButton1_2nd_table();
                                    }}
                                    className={`  ${styles.addmodalDirection_eventhistory_2ndTable} modal p-6 absolute max-h-[60vh] top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
                                  >
                                    <form
                                      method="dialog"
                                      className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
                                    >
                                      <div className="modal-box relative top-[3px]">
                                        <div
                                          onClick={() => {
                                            autoClickButton1_2nd_table();
                                          }}
                                        >
                                          <button id="closemod11__2nd_table">
                                            <img
                                              alt="img"
                                              src={crossicon}
                                              className="w-[20px] h-[20px]"
                                            />
                                          </button>
                                        </div>

                                        <div>
                                          {filteredModalDataontime.length >
                                            0 ? (
                                            <>
                                              {/* (your modal content unchanged) */}
                                            </>
                                          ) : (
                                            <p className="text-center mt-4">
                                              No Data
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </form>
                                  </dialog>
                                </>
                              )}

                              <td className="py-2">{item.previous}</td>
                              <td className="py-2">{item.actual}</td>
                              <td
                                className={`py-2 ${shouldHighlight ? "bg-gray-200" : ""
                                  }`}
                              >
                                {item.estimate}
                              </td>

                              {/* ✅ ACT - PREV (calculated) ONLY SIGN */}
                              <td
                                className={`py-2 text-[#240d3a] font-bold ${getBg(
                                  actPrev
                                )}`}
                              >
                                {getSign(actPrev) === "N/A"
                                  ? "N/A"
                                  : `(${getSign(actPrev)})`}
                              </td>

                              {/* ✅ ACT - EST (calculated) ONLY SIGN */}
                              <td
                                className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${getBg(
                                  actEst
                                )}`}
                              >
                                {getSign(actEst) === "N/A"
                                  ? "N/A"
                                  : `(${getSign(actEst)})`}
                              </td>

                              {/* ✅ FINAL MOVEMENT: Act-Est if available, else Act-Prev */}
                              <td
                                className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
                                  // Determine which value to use
                                  estNum != null
                                    ? getBg(actEst)        // Use Act - Est
                                    : prevNum != null
                                      ? getBg(actPrev)     // Use Act - Prev
                                      : "bg-[#E5E7EB]"     // Both missing → gray
                                  }`}
                              >
                                {estNum != null
                                  ? `(${getSign(actEst)})`
                                  : prevNum != null
                                    ? `(${getSign(actPrev)})`
                                    : "N/A"}
                              </td>

                              {/* 1. Close Minus Open Sign */}
                              {headers.map((header, index) => {
                                const key =
                                  header.name
                                    .split("/")
                                    .join("")
                                    .toLowerCase() + "1min";
                                const sign = item[key]?.closeMinusOpenSign;
                                { console.log("sign", sign) }
                                { console.log("header", header) }

                                return (
                                  <td
                                    className={`border-[#F6F6F6] min-w-[91.95px] ${sign === "+"
                                      ? "bg-[#7fe9a4]"
                                      : sign === "-"
                                        ? "bg-[#f3b2b2]"
                                        : sign === 0 || sign === "0"
                                          ? "bg-[#f7dc14]"
                                          : "bg-[#E5E7EB]"
                                      } ${index === headers.length - 1
                                        ? "border-r-4 border-white"
                                        : ""
                                      }`}
                                  >
                                    {sign || "N/A"}
                                  </td>
                                );
                              })}

                              {/* 2. Low Minus Open Sign */}
                              {headers.map((header, index) => {
                                const key =
                                  header.name
                                    .split("/")
                                    .join("")
                                    .toLowerCase() + "1min";
                                const sign = item[key]?.lowMinusOpenSign;

                                return (
                                  <td
                                    className={`border-[#F6F6F6] min-w-[91.95px] ${sign === "+"
                                      ? "bg-[#7fe9a4]"
                                      : sign === "-"
                                        ? "bg-[#f3b2b2]"
                                        : sign === 0 || sign === "0"
                                          ? "bg-[#f7dc14]"
                                          : "bg-[#E5E7EB]"
                                      } ${index === headers.length - 1
                                        ? "border-r-4 border-white"
                                        : ""
                                      }`}
                                  >
                                    {sign || "N/A"}
                                  </td>
                                );
                              })}

                              {/* 3. High Minus Open Sign */}
                              {headers.map((header, index) => {
                                const key =
                                  header.name
                                    .split("/")
                                    .join("")
                                    .toLowerCase() + "1min";
                                const sign = item[key]?.highMinusOpenSign;

                                return (
                                  <td
                                    className={`border-[#F6F6F6] min-w-[91.95px] ${sign === "+"
                                      ? "bg-[#7fe9a4]"
                                      : sign === "-"
                                        ? "bg-[#f3b2b2]"
                                        : sign === 0 || sign === "0"
                                          ? "bg-[#f7dc14]"
                                          : "bg-[#E5E7EB]"
                                      } ${index === headers.length - 1
                                        ? "border-r-4 border-white"
                                        : ""
                                      }`}
                                  >
                                    {sign || "N/A"}
                                  </td>
                                );
                              })}
                            </tr>
                          </>
                        );
                      })}

                      <tr className="bg-[#dccafe5e] text-center">
                        <td
                          className="py-2  font-bold   min-w-[80.8px]"
                          colSpan={4}
                        >
                          % data missing
                        </td>
                        {/* <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                        {/* <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className={`py-2 border-r-4 border-white`}></td>

                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? parseFloat(
                                    item[
                                      key
                                    ].closeminusopenmissingEvent.replace(
                                      "%",
                                      ""
                                    )
                                  )
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];

                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];
                          // console.log("filterObject" , filterObject)
                          if (filterObject) {
                            let rawValue =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopenmissingEvent;
                            let value = parseFloat(rawValue);

                            // console.log("rawValue" , rawValue)
                            //   console.log("value" , value)
                            let bgColor = "";
                            if (value <= 65) {
                              bgColor = "text-[#e06969]";
                            } else if (value > 65 && value <= 80) {
                              bgColor = "text-[#e4c900]";
                            } else if (value > 80) {
                              bgColor = "text-[#34c567]";
                            } else {
                              bgColor = "text-[#88898c]";
                            }
                            return (
                              <td
                                className={`text-[15px] py-2    ${index === headers.length - 1
                                  ? "border-r-4 border-white"
                                  : ""
                                  } `}
                              >
                                {rawValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].lowminusopenmissingEvent
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)

                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finalValue =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopenmissingEvent;
                          // console.log("finalValue" , finalValue)
                          let value = parseFloat(finalValue);
                          let bgColor = "";
                          if (value <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (value > 65 && value <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (value > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }

                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2    ${index === headers.length - 1
                                  ? "border-r-4 border-white"
                                  : ""
                                  } `}
                              >
                                {finalValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].HighminusopenmissingEvent
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finaldata =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopenmissingEvent;
                          let value = parseFloat(finaldata);
                          let bgColor = "";
                          if (value <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (value > 65 && value <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (value > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }
                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${index === headers.length - 1
                                  ? "border-r-4 border-white"
                                  : ""
                                  } `}
                              >
                                {finaldata}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold " colSpan={4}>
                          Non- Zero event (Positive currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                        {/* <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className={`py-2 border-r-4 border-white`}></td>
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? parseFloat(
                                    item[
                                      key
                                    ].closeminusopennonZeroPositive.replace(
                                      "%",
                                      ""
                                    )
                                  )
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];

                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];
                          // console.log("filterObject" , filterObject)

                          if (filterObject) {
                            let rawValue =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonZeroPositive;
                            let rawValue_negative =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonZeroNegative;
                            let value = parseFloat(rawValue);
                            let value_negative = parseFloat(rawValue_negative);
                            // console.log("rawValue" , rawValue)

                            let maxValue = Math.max(value, value_negative);
                            //   console.log("value" , value)

                            let bgColor = "";
                            if (maxValue <= 65) {
                              bgColor = "text-[#e06969]";
                            } else if (maxValue > 65 && maxValue <= 80) {
                              bgColor = "text-[#e4c900]";
                            } else if (maxValue > 80) {
                              bgColor = "text-[#34c567]";
                            } else {
                              bgColor = "text-[#88898c]";
                            }
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor}  ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  } `}
                              >
                                {rawValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].lowminusopennonZeroPositive
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finalValue =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonZeroPositive;
                          const finalValue_negative =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonZeroNegative;
                          // console.log("finalValue" , finalValue)

                          if (filterObject) {
                            let value = parseFloat(finalValue);
                            let value_negative =
                              parseFloat(finalValue_negative);

                            let maxValue = Math.max(value, value_negative);
                            let bgColor = "";
                            if (maxValue <= 65) {
                              bgColor = "text-[#e06969]";
                            } else if (maxValue > 65 && maxValue <= 80) {
                              bgColor = "text-[#e4c900]";
                            } else if (maxValue > 80) {
                              bgColor = "text-[#34c567]";
                            } else {
                              bgColor = "text-[#88898c]";
                            }
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {finalValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].HighminusopennonZeroPositive
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finaldata =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonZeroPositive;
                          const finaldata_negative =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonZeroNegative;
                          let value = parseFloat(finaldata);
                          let value_negative = parseFloat(finaldata_negative);

                          let maxValue = Math.max(value, value_negative);
                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }

                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor}  ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {finaldata}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold " colSpan={4}>
                          Non- Zero event (Negative currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                           <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className={`py-2 border-r-4 border-white`}></td>
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? parseFloat(
                                    item[
                                      key
                                    ].closeminusopennonZeroNegative.replace(
                                      "%",
                                      ""
                                    )
                                  )
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];

                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];
                          // console.log("filterObject" , filterObject)
                          if (filterObject) {
                            let rawValue =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonZeroNegative;
                            let rawValue_positive =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonZeroPositive;
                            let value = parseFloat(rawValue);
                            let value_positive = parseFloat(rawValue_positive);

                            let maxValue = Math.max(value, value_positive);
                            let bgColor = "";
                            if (maxValue <= 65) {
                              bgColor = "text-[#e06969]";
                            } else if (maxValue > 65 && maxValue <= 80) {
                              bgColor = "text-[#e4c900]";
                            } else if (maxValue > 80) {
                              bgColor = "text-[#34c567]";
                            } else {
                              bgColor = "text-[#88898c]";
                            }
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  } `}
                              >
                                {rawValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].lowminusopennonZeroNegative
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finalValue =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonZeroNegative;
                          const finalValue_positive =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonZeroPositive;
                          // console.log("finalValue" , finalValue)

                          let value = parseFloat(finalValue);
                          let value_positive = parseFloat(finalValue_positive);

                          let maxValue = Math.max(value, value_positive);
                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }

                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor}   ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {finalValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].HighminusopennonZeroNegative
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finaldata =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonZeroNegative;
                          const finaldata_positive =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonZeroPositive;
                          let value = parseFloat(finaldata);
                          let value_positive = parseFloat(finaldata_positive);

                          let maxValue = Math.max(value, value_positive);

                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }
                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {finaldata}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold " colSpan={4}>
                          Flat event (Positive currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                           <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className={`py-2 border-r-4 border-white`}></td>
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? parseFloat(
                                    item[
                                      key
                                    ].closeminusopennonFlatPostive.replace(
                                      "%",
                                      ""
                                    )
                                  )
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];

                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];
                          // console.log("filterObject" , filterObject)
                          if (filterObject) {
                            let rawValue =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonFlatPostive;
                            let rawValue_negative =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonFlatNegative;
                            let value = parseFloat(rawValue);
                            let value_negative = parseFloat(rawValue_negative);
                            let maxValue = Math.max(value, value_negative);
                            let bgColor = "";
                            if (maxValue <= 65) {
                              bgColor = "text-[#e06969]";
                            } else if (maxValue > 65 && maxValue <= 80) {
                              bgColor = "text-[#e4c900]";
                            } else if (maxValue > 80) {
                              bgColor = "text-[#34c567]";
                            } else {
                              bgColor = "text-[#88898c]";
                            }
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  } `}
                              >
                                {rawValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].lowminusopennonFlatPositive
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finalValue =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonFlatPositive;
                          const finalValue_negative =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonFlatNegative;

                          // console.log("finalValue" , finalValue)
                          let value = parseFloat(finalValue);
                          let value_negative = parseFloat(finalValue_negative);
                          let maxValue = Math.max(value, value_negative);

                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }

                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {finalValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].HighminusopennonFlatPositive
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finaldata =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonFlatPositive;
                          const finaldata_negative =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonFlatNegative;
                          let value = parseFloat(finaldata);
                          let value_negative = parseFloat(finaldata_negative);

                          let maxValue = Math.max(value, value_negative);

                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }
                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  } `}
                              >
                                {finaldata}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                      </tr>
                      <tr className="bg-[#dccafe5e] text-center">
                        <td className="py-2 font-bold" colSpan={4}>
                          Flat event (Negative currency correlation)
                        </td>
                        {/* <td className="py-2 "></td>
                           <td className="py-2 "></td>
                           <td className="py-2 "></td> */}
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className="py-2 "></td>

                        <td className="py-2 "></td>
                        <td className="py-2 "></td>
                        <td className={`py-2 border-r-4 border-white`}></td>
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? parseFloat(
                                    item[
                                      key
                                    ].closeminusopennonFlatNegative.replace(
                                      "%",
                                      ""
                                    )
                                  )
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];

                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];
                          // console.log("filterObject" , filterObject)
                          if (filterObject) {
                            let rawValue =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonFlatNegative;
                            let rawValue_positive =
                              filterObject[Object.keys(filterObject)[0]]
                                .closeminusopennonFlatPostive;
                            // console.log("rawValue_positive" , rawValue_positive)
                            let value = parseFloat(rawValue);
                            let value_positive = parseFloat(rawValue_positive);

                            // console.log("value_positive" , value_positive)
                            let maxValue = Math.max(value, value_positive);
                            // console.log("maxValue" ,maxValue)
                            let bgColor = "";
                            if (maxValue <= 65) {
                              bgColor = "text-[#e06969]";
                            } else if (maxValue > 65 && maxValue <= 80) {
                              bgColor = "text-[#e4c900]";
                            } else if (maxValue > 80) {
                              bgColor = "text-[#34c567]";
                            } else {
                              bgColor = "text-[#88898c]";
                            }
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  } `}
                              >
                                {rawValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].lowminusopennonFlatNegative
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finalValue =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonFlatNegative;
                          const finalValue_positive =
                            filterObject[Object.keys(filterObject)[0]]
                              .lowminusopennonFlatPositive;
                          // console.log("finalValue" , finalValue)
                          let value = parseFloat(finalValue);
                          let value_positive = parseFloat(finalValue_positive);

                          let maxValue = Math.max(value, value_positive);

                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }
                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  } `}
                              >
                                {finalValue}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                        {headers.map((header, index) => {
                          const allValues =
                            volatilityImpact_secondtable_flatPOS_flatNEV
                              .map((item) => {
                                let key = Object.keys(item).find((k) =>
                                  k.includes("1min")
                                );
                                return key
                                  ? item[key].HighminusopennonFlatNegative
                                  : null;
                              })
                              .filter((value) => !isNaN(value)); // Ensure only numeric values

                          // Get unique sorted values
                          const sortedValues = [...new Set(allValues)].sort(
                            (a, b) => b - a
                          );
                          // console.log("sortedValues" , sortedValues)
                          const highest = sortedValues[0];
                          const secondHighest = sortedValues[1];
                          const thirdHighest = sortedValues[2];
                          let filterObject =
                            volatilityImpact_secondtable_flatPOS_flatNEV.filter(
                              (item) =>
                                Object.keys(item).includes(header.id + "1min")
                            )[0];

                          const finaldata =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonFlatNegative;
                          const finaldata_positive =
                            filterObject[Object.keys(filterObject)[0]]
                              .HighminusopennonFlatPositive;

                          let value = parseFloat(finaldata);
                          let value_positive = parseFloat(finaldata_positive);
                          let maxValue = Math.max(value, value_positive);

                          let bgColor = "";
                          if (maxValue <= 65) {
                            bgColor = "text-[#e06969]";
                          } else if (maxValue > 65 && maxValue <= 80) {
                            bgColor = "text-[#e4c900]";
                          } else if (maxValue > 80) {
                            bgColor = "text-[#34c567]";
                          } else {
                            bgColor = "text-[#88898c]";
                          }
                          if (filterObject) {
                            return (
                              <td
                                className={`text-[15px] py-2  ${bgColor} ${value === maxValue
                                  ? "font-bold"
                                  : "font-medium"
                                  } ${index === headers.length - 1
                                    ? "border-r-4 border-white"
                                    : ""
                                  }`}
                              >
                                {finaldata}
                              </td>
                            );
                          } else {
                            return <td>N/A</td>;
                          }
                        })}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        // <----------if no data available in backend ( 400 error)---------------->
        <div>
          <div className="font-semibold m-6 font-xl text-center flex justify-center items-center ">
            Wait !! Data is in Progress .....
          </div>
          <div className="flex items-center justify-center  w-screen ">
            <Bars
              height="80"
              width="80"
              color="#94A3B8"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              className="loader"
            />
          </div>
        </div>
      )}

      <div>
        {modalShow && (
          <div
            id="popup-modal"
            className="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black bg-opacity-15 z-[999]"
            onClick={() => setModalshow(!modalShow)}
          >
            <div className="relative p-4 w-full max-w-md">
              <div className="relative bg-white rounded-lg shadow">
                <img
                  src={logout_eye_btn}
                  alt="logout_eye_btn"
                  className="h-[33px] w-[33px] absolute top-[12%] left-[47%]"
                />
                <div className="p-4 md:p-5 text-center z-[999]">
                  <h3 className="mb-5 mt-[15%] text-lg font-bold text-[#240D3A]">
                    Are you sure you want to refresh the page? This action will
                    clear all locally stored data.
                  </h3>
                  <div className="flex items-center justify-center">
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="text-[#240D3A]  bg-[#ecebeb] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={handleRefresh}
                    >
                      Yes
                    </button>
                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      className="ml-4 text-white  bg-[#240D3A] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
                      onClick={() => setModalshow(!modalShow)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EventshistoryUserTrial;





// import React, { useEffect, useState, useCallback, useRef } from "react";
// import axios from "axios";
// import { Space } from "antd";
// import { useNavigate } from "react-router-dom";
// import { Bars } from "react-loader-spinner";
// import movementicon from "../assets/average_tradeall.png";
// import eye_btn_tooltip from "../assets/IBUTTON.png";
// import color1 from "../assets/highest_average.png";
// import color2 from "../assets/second_highest_average.png";
// import color3 from "../assets/third_highest_average.png";
// import livegraph_icon from "../assets/line_chart.png";
// import color4 from "../assets/color4.png";
// import color5 from "../assets/color5.png";
// import color6 from "../assets/color6.png";
// import { IoArrowBack } from "react-icons/io5";
// import color7 from "../assets/color7.png";
// import color8 from "../assets/color8.png";
// import color9 from "../assets/color9.png";
// import "react-toastify/dist/ReactToastify.css";
// import { toast } from "react-toastify";
// import crossicon from "../assets/cross1.png";
// import refresh_icon from "../assets/refresh.png";
// import logout_eye_btn from "../assets/IBUTTON.png";
// import dateicon from "../assets/date.png";
// import eventicon from "../assets/event.png";
// import timeicon from "../assets/time1).png";
// import locationicon from "../assets/location(1).png";
// import impacticon from "../assets/impact(1).png";
// import frequencyicon from "../assets/calendar(1).png";
// import RingLoader from "react-spinners/RingLoader";
// import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
// import UserNavbar from "../components/user/userNavbar";
// import styles from "../components/tradeall.module.css";

// const EventshistoryUserTrial = () => {
//   const navigate = useNavigate();

//   const [run_modalloader, setRun_modalloader] = useState(true);
//   const [run_clickedevent_dateapi, setRunclickedevent_dateapi] =
//     useState(false);
//   const [run_clickedevent_dateapi2, setRunclickedevent_dateapi2] =
//     useState(false);
//   const [runclickedevent_dateapi3, setRunclickedevent_dateapi3] =
//     useState(false);
//   const [Loading_3rdtable, setLoading_3rdtable] = useState(false);

//   const [timeclickedurl_state, setTimeclickedurl_state] = useState(1);

//   const [isgraphbuttonDisabled, setIsgraphbuttonDisbled] = useState(false);
//   const [optionValue, setOptionValue] = useState(6);

//   const [eventname_forerror, seteventname_forerror] = useState("");

//   // <----------------here is the final averge of flat points---------->

//   const [isReloadLoading, setIsReloadLoading] = useState(false);

//   // const [errorMessage, setErrorMessage] = useState("");
//   // const [eventHistory, setEventHistory] = useState([]);
//   // const [eventHistory2, setEventHistory2] = useState([]);
//   const [clickedtimeButton, setClickedtimeButton] = useState("1min");
//   const [country, setCountry] = useState("");
//   const [eventdate, setEventDate] = useState("");
//   const [event, setEvent] = useState("");
//   const [impact, setimpact] = useState("");
//   const [date, setdate] = useState("");
//   const [time, settime] = useState("");

//   const [impacthighlow, setimpacthighlow] = useState([]);
//   const [impacthighlowbeforethis, setimpacthighlowbeforethis] = useState([]);
//   const [modalimpactdatabeforetime, setmodalimpactdatabeforetime] = useState(
//     []
//   );
//   const [modalimpactdataontime, setmodalimpactdataontime] = useState([]);

//   const [frequency_date, setFrequency_date] = useState();
//   const [Loading, setLoading] = useState(false);

//   const [selectedTime, setSelectedTime] = useState(1);
//   const [allEventHistory, setAllEventHistory] = useState([]);
//   const [allEventHistory2, setAllEventHistory2] = useState([]);

//   // <<--------for flat 0 averages----->

//   const [eventimpactontimespecificdate, seteventimpactontimespecificdate] =
//     useState();
//   const [
//     eventimpactbeforetimespecificdate,
//     seteventimpactbeforetimespecificdate,
//   ] = useState();

//   const [clickeddate_Loading, setclickeddate_Loading] = useState(true);
//   const [modalShow, setModalshow] = useState(false);

//   const [showTooltip, setShowTooltip] = useState(false);
//   const [showTooltip2, setShowTooltip2] = useState(false);
//   const [showTooltip3, setShowTooltip3] = useState(false);

//   const tooltipRef = useRef(null);

//   const handleImageClick = (event) => {
//     event.stopPropagation(); // Prevent immediate closing on click
//     setShowTooltip((prev) => !prev);
//   };
//   const handleImageClick2 = (event) => {
//     event.stopPropagation(); // Prevent immediate closing on click
//     setShowTooltip2((prev) => !prev);
//   };
//   const handleImageClick3 = (event) => {
//     event.stopPropagation(); // Prevent immediate closing on click
//     setShowTooltip3((prev) => !prev);
//   };

//   const handleClickOutside = (event) => {
//     if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
//       setShowTooltip(false);
//       setShowTooltip2(false);
//       setShowTooltip3(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   });

//   const UKHeaders = [
//     { name: "GBP/AUD", id: "gbpaud" },
//     { name: "GBP/CAD", id: "gbpcad" },
//     { name: "GBP/CHF", id: "gbpchf" },
//     { name: "EUR/GBP", id: "eurgbp" },
//     { name: "GBP/JPY", id: "gbpjpy" },
//     { name: "GBP/NZD", id: "gbpnzd" },
//     { name: "GBP/USD", id: "gbpusd" },
//   ];
//   const USHeaders = [
//     { name: "AUD/USD", id: "audusd" },
//     { name: "USD/CAD", id: "usdcad" },
//     { name: "USD/CHF", id: "usdchf" },
//     { name: "EUR/USD", id: "eurusd" },
//     { name: "GBP/USD", id: "gbpusd" },
//     { name: "USD/JPY", id: "usdjpy" },
//     { name: "NZD/USD", id: "nzdusd" },
//   ];
//   const JPHeaders = [
//     { name: "AUD/JPY", id: "audjpy" },
//     { name: "CAD/JPY", id: "cadjpy" },
//     { name: "CHF/JPY", id: "chfjpy" },
//     { name: "EUR/JPY", id: "eurjpy" },
//     { name: "GBP/JPY", id: "gbpjpy" },
//     { name: "NZD/JPY", id: "nzdjpy" },
//     { name: "USD/JPY", id: "usdjpy" },
//   ];
//   const CAHeaders = [
//     { name: "AUD/CAD", id: "audcad" },
//     { name: "CAD/CHF", id: "cadchf" },
//     { name: "EUR/CAD", id: "eurcad" },
//     { name: "GBP/CAD", id: "gbpcad" },
//     { name: "CAD/JPY", id: "cadjpy" },
//     { name: "NZD/CAD", id: "nzdcad" },
//     { name: "USD/CAD", id: "usdcad" },
//   ];
//   const CHEHeaders = [
//     { name: "AUD/CHF", id: "audchf" },
//     { name: "CAD/CHF", id: "cadchf" },
//     { name: "EUR/CHF", id: "eurchf" },
//     { name: "GBP/CHF", id: "gbpchf" },
//     { name: "CHF/JPY", id: "chfjpy" },
//     { name: "NZD/CHF", id: "nzdchf" },
//     { name: "USD/CHF", id: "usdchf" },
//   ];
//   const EUHeaders = [
//     { name: "EUR/AUD", id: "euraud" },
//     { name: "EUR/CAD", id: "eurcad" },
//     { name: "EUR/CHF", id: "eurchf" },
//     { name: "EUR/GBP", id: "eurgbp" },
//     { name: "EUR/JPY", id: "eurjpy" },

//     { name: "EUR/NZD", id: "eurnzd" },
//     { name: "EUR/USD", id: "eurusd" },
//   ];
//   const AUHeaders = [
//     { name: "AUD/CAD", id: "audcad" },
//     { name: "AUD/CHF", id: "audchf" },
//     { name: "EUR/AUD", id: "euraud" },
//     { name: "GBP/AUD", id: "gbpaud" },
//     { name: "AUD/JPY", id: "audjpy" },
//     { name: "AUD/NZD", id: "audnzd" },
//     { name: "AUD/USD", id: "audusd" },
//   ];
//   const NZHeaders = [
//     { name: "AUD/NZD", id: "audnzd" },
//     { name: "NZD/CAD", id: "nzdcad" },
//     { name: "NZD/CHF", id: "nzdchf" },
//     { name: "EUR/NZD", id: "eurnzd" },
//     { name: "GBP/NZD", id: "gbpnzd" },

//     { name: "NZD/JPY", id: "nzdjpy" },
//     { name: "NZD/USD", id: "nzdusd" },
//   ];

//   const headersMap =
//     country === "UK"
//       ? UKHeaders
//       : country === "US"
//       ? USHeaders
//       : country === "JP"
//       ? JPHeaders
//       : country === "CA"
//       ? CAHeaders
//       : country === "CH"
//       ? CHEHeaders
//       : country === "EU" ||
//         country === "DE" ||
//         country === "IT" ||
//         country === "FR"
//       ? EUHeaders
//       : country === "AU"
//       ? AUHeaders
//       : NZHeaders;

//   const headers = headersMap.sort((a, b) => a.name.localeCompare(b.name)) || [];

//   const handlegeneratechart = () => {
//     // window.open("/user/graphdata", "_blank");
//     // navigate("/admin/graphdata");

//     const urlParams = new URLSearchParams(window.location.search);
//     const eventId = decodeURIComponent(urlParams.get("eventId"));
//     // alert(eventId)
//     const url = new URL(window.location.origin + "/user/graphdata");
//     url.searchParams.set("eventName", event);
//     url.searchParams.set("eventcountry", country);
//     url.searchParams.set("eventId", eventId);
//     url.searchParams.set("eventdate", eventdate);
//     const newTab = window.open(url.toString(), "_blank");
//   };

//   const handlelivechart = () => {
//     const url = new URL(window.location.origin + "/user/livecharts");
//     const newTab = window.open(url.toString(), "_blank");
//   };

//   // <---------------headers------------>
//   const getheaderscount_highlow = async () => {
//     console.log("hi am in header code now ");
//     setclickeddate_Loading(true);
//     if (run_clickedevent_dateapi) {
//       try {
//         const urlParams = new URLSearchParams(window.location.search);
//         const eventName = decodeURIComponent(urlParams.get("eventName"));
//         const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));

//         console.log("eventcountry", eventcountry);
//         const eventimpact = decodeURIComponent(urlParams.get("eventimpact"));
//         const eventtime = decodeURIComponent(urlParams.get("eventtime"));
//         const eventdate = decodeURIComponent(urlParams.get("eventdate"));

//         const uniqueKey = `${eventName}-${eventcountry}-${eventdate}-${eventtime}`;
//         setEventDate(eventdate);
//         setCountry(eventcountry);
//         setEvent(eventName);
//         setimpact(eventimpact);
//         setdate(eventdate);
//         settime(eventtime);
//         const tokenfromls = localStorage.getItem("usertoken");
//         const headers = { authorization: tokenfromls };

//         // Fetch specific date impact data
//         const response5 = await axios.post(
//           `${process.env.REACT_APP_URL}/eventsimpactonaspecificdate`,
//           { eventName, eventcountry, eventdate, eventtime },
//           { headers }
//         );

//         const specificdateimpactontime = response5.data;
//         // console.log("specificdateimpactontime", specificdateimpactontime);

//         // Fetch before specific date impact data
//         const response6 = await axios.post(
//           `${process.env.REACT_APP_URL}/eventsimpactbeforeaspecificdate`,
//           { eventName, eventcountry, eventdate, eventtime },
//           { headers }
//         );

//         const specificdateimpactbeforetime = response6.data;
//         // console.log(
//         //   "specificdateimpactbeforetime",
//         //   specificdateimpactbeforetime
//         // );
//         setRunclickedevent_dateapi2(true);

//         seteventimpactontimespecificdate(specificdateimpactontime);
//         seteventimpactbeforetimespecificdate(specificdateimpactbeforetime);
//         setclickeddate_Loading(false);
//       } catch (error) {
//         console.error("Error fetching specific date impact data:", error);
//         setclickeddate_Loading(false);
//       }
//     }
//   };

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const urlCountry = decodeURIComponent(urlParams.get("eventcountry"));
//     setCountry(urlCountry);
//   }, []);

//   useEffect(() => {
//     if (run_clickedevent_dateapi) {
//       getheaderscount_highlow();
//     }
//   }, [run_clickedevent_dateapi]);

//   // <-----------modal high low count------------>
//   const handlegetmodaldata_fromApi = async () => {
//     if (run_clickedevent_dateapi2) {
//       //  console.log("hi")
//       try {
//         const urlParams = new URLSearchParams(window.location.search);
//         const eventName = decodeURIComponent(urlParams.get("eventName"));
//         const eventcountry = decodeURIComponent(urlParams.get("eventcountry"));
//         // const eventimpact = decodeURIComponent(urlParams.get('eventimpact'));
//         const eventtime = decodeURIComponent(urlParams.get("eventtime"));
//         const eventdate = decodeURIComponent(urlParams.get("eventdate"));

//         // // <---------------data first time run and setting into local------------->

//         const tokenfromls = localStorage.getItem("usertoken");
//         const h = { authorization: tokenfromls };

//         const response2 = await axios.post(
//           `${process.env.REACT_APP_URL}/findhighlowhistoryevents`,
//           { eventName, eventcountry },
//           { headers: h }
//         );

//         // console.log("response2", response2);
//         const response3 = await axios.post(
//           `${process.env.REACT_APP_URL}/highloweventbeforedate`,
//           { eventName, eventcountry },
//           { headers: h }
//         );
//         // console.log("response3", response3);

//         // <-----------this code is for on time-------------->
//         const gethighlowimpact = response2.data;
//         const modalimpacthighlowontime = gethighlowimpact.impactdata1;
//         const summaryimpacthighlow = gethighlowimpact.impactdata2;

//         // <-----------this code is for before time-------------->
//         const impactdata = response3.data;
//         const finalimpactsummary = impactdata.impactdata2;
//         const modalimpactdata2 = impactdata.impactdata1;
//         // <-------------main data--------------->
//         setRun_modalloader(false);
//         const dataToStore3 = {
//           finalimpactsummary,
//           summaryimpacthighlow,
//           modalimpacthighlowontime,
//           modalimpactdata2,
//         };
//         setimpacthighlow(summaryimpacthighlow);
//         setmodalimpactdataontime(modalimpacthighlowontime);
//         setimpacthighlowbeforethis(finalimpactsummary);
//         setmodalimpactdatabeforetime(modalimpactdata2);
//       } catch (error) {
//         console.log("error", error);
//         setRun_modalloader(false);
//       }
//     }
//   };

//   useEffect(() => {
//     if (run_clickedevent_dateapi2) {
//       handlegetmodaldata_fromApi();
//     }
//   }, [run_clickedevent_dateapi2]);

//   const handleModalShowClick = () => {
//     setModalshow(true);
//   };

//   const handleRefresh = () => {
//     setIsReloadLoading(true);
//     setLoading(false);
//     // Loop through localStorage and remove any item with "Clickeddate_data_"
//     Object.keys(localStorage).forEach((key) => {
//       if (
//         key.includes("Clickeddate_data_") ||
//         key.includes("table3_historyData_") ||
//         key.includes("clickedmodal_data_2ndpage_")
//       ) {
//         localStorage.removeItem(key);
//       }
//     });

//     localStorage.removeItem("All_events_history");
//     localStorage.removeItem("lastDeletionTime");
//     localStorage.removeItem("UserId");
//     localStorage.removeItem("userId");
//     localStorage.removeItem("selectedtime");
//     localStorage.removeItem("4GraphDataobjects");

//     localStorage.removeItem("token");
//     localStorage.removeItem("todayDate");
//     localStorage.removeItem("previousDate_u_search_history");

//     localStorage.removeItem("selectedtime");

//     setIsReloadLoading(false);
//     setLoading(false);
//     // historydata_table(selectedTime);
//     getFirstTabledata();
//     window.location.reload();
//   };

//   const handlegoback = () => {
//     navigate("/user/economicdata");
//   };

//   const [filteredModalData, setFilteredModalData] = useState([]);
//   const handleShowModalbeforetime = (date) => {
//     const filteredData = modalimpactdatabeforetime.filter(
//       (item) => item.date === date
//     );
//     setFilteredModalData(filteredData);
//     document.getElementById("my_modal_2").showModal();
//   };

//   const handleShowModalbeforetime_2nd_table = (date) => {
//     const filteredData = modalimpactdatabeforetime.filter(
//       (item) => item.date === date
//     );
//     setFilteredModalData(filteredData);
//     document.getElementById("my_modal_2_2nd_table").showModal();
//   };

//   const handleShowModalbeforetime_3rd_table = (date) => {
//     const filteredData = modalimpactdatabeforetime.filter(
//       (item) => item.date === date
//     );
//     setFilteredModalData(filteredData);
//     document.getElementById("my_modal_2_3rdtable").showModal();
//   };

//   const [filteredModalDataontime, setFilteredModalDataontime] = useState([]);
//   const handleShowModalontime = (date) => {
//     const filteredData = modalimpactdataontime.filter(
//       (item) => item.date === date
//     );
//     setFilteredModalDataontime(filteredData);
//     document.getElementById("my_modal_3").showModal();
//   };
//   const handleShowModalontime_2nd_table = (date) => {
//     const filteredData = modalimpactdataontime.filter(
//       (item) => item.date === date
//     );
//     setFilteredModalDataontime(filteredData);
//     document.getElementById("my_modal_3_2nd_table").showModal();
//   };
//   const handleShowModalontime_3rd_table = (date) => {
//     const filteredData = modalimpactdataontime.filter(
//       (item) => item.date === date
//     );
//     setFilteredModalDataontime(filteredData);
//     document.getElementById("my_modal_3_3rd_table").showModal();
//   };

//   useEffect(() => {
//     const modal = document.getElementById("my_modal_3_3rd_table");

//     const handleOpen = () => {
//       document.body.style.overflow = "hidden"; // Prevent background scrolling
//     };

//     const handleClose = () => {
//       document.body.style.overflow = "auto"; // Restore scrolling
//     };

//     if (modal) {
//       modal.addEventListener("click", (event) => {
//         if (event.target === modal) {
//           modal.close(); // Close modal when clicking outside
//         }
//       });

//       modal.addEventListener("cancel", handleClose); // When user presses "Escape"
//       modal.addEventListener("close", handleClose); // When modal closes normally
//       modal.addEventListener("DOMNodeInserted", handleOpen); // Detect when it's added
//     }

//     return () => {
//       if (modal) {
//         modal.removeEventListener("cancel", handleClose);
//         modal.removeEventListener("close", handleClose);
//         modal.removeEventListener("DOMNodeInserted", handleOpen);
//       }
//       document.body.style.overflow = "auto"; // Cleanup on unmount
//     };
//   }, [handleShowModalontime_3rd_table, handleShowModalbeforetime_3rd_table]);
//   function autoClickButton() {
//     var button = document.getElementById("aashima_id");
//     button.click();
//   }
//   function autoClickButton_2nd_table() {
//     var button = document.getElementById("aashima_id_2nd_table");
//     button.click();
//   }
//   function autoClickButton_3rd_table() {
//     var button = document.getElementById("aashima_id_3rd_table");
//     button.click();
//   }
//   function autoClickButton1() {
//     var button = document.getElementById("closemod11");
//     button.click();
//   }
//   function autoClickButton1_2nd_table() {
//     var button = document.getElementById("closemod11__2nd_table");
//     button.click();
//   }
//   function autoClickButton1_3rd_table() {
//     var button = document.getElementById("closemod11__3rd_table");
//     button.click();
//   }

//   const [volatilityImpact_firsttable, setVolatilityImpact_firsttable] =
//     useState([]);
//   const [
//     volatilityImpact_firsttable_nonzero,
//     setVolatilityImpact_firsttable_nonzero,
//   ] = useState([]);
//   const [
//     volatilityImpact_firsttable_zero,
//     setVolatilityImpact_firsttable_zero,
//   ] = useState([]);

//   const [volatilityImpact_secondtable, setVolatilityImpact_secondtable] =
//     useState([]);

//   const [
//     volatilityImpact_secondtable_flatPOS_flatNEV,
//     setVolatilityImpact_secondtable_flatPOS_flatNEV,
//   ] = useState([]);
//   const [eventRange, setEventRange] = useState("6");
//   const [eventType, setEventType] = useState("1min");

//   const handleOptionChange = (value) => {
//     setEventRange(value);
//     // setOptionValue(value)
//     // console.log("value", value)
//   };

//   const handletimebtnclick = (value) => {
//     setEventType(value);
//     // console.log("value", value)
//   };
//   // <--both tables data ---below api--->
//   const getFirstTabledata = async () => {
//     try {
//       // if (timeclicked === 1) {
//       //   setoff_minutebuttons1(true);
//       //   setoff_minutebuttons2(false);
//       //   setoff_minutebuttons3(false);
//       //   setoff_minutebuttons4(false);
//       // } else if (timeclicked === 5) {
//       //   setoff_minutebuttons1(true);
//       //   setoff_minutebuttons2(true);
//       //   setoff_minutebuttons3(false);
//       //   setoff_minutebuttons4(false);
//       // } else if (timeclicked === 15) {
//       //   setoff_minutebuttons1(true);
//       //   setoff_minutebuttons2(true);
//       //   setoff_minutebuttons3(true);
//       //   setoff_minutebuttons4(false);
//       // } else {
//       //   setoff_minutebuttons1(true);
//       //   setoff_minutebuttons2(true);
//       //   setoff_minutebuttons3(true);
//       //   setoff_minutebuttons4(true);
//       // }
//       // console.log("hi i ma in api" , eventRange , eventType)
//       const urlParams = new URLSearchParams(window.location.search);
//       const eventId = decodeURIComponent(urlParams.get("eventId"));
//       setLoading(true);
//       const response = await axios.get(
//         `${process.env.REACT_APP_URL}/user/geteventtable/${eventId}`,
//         {
//           params: {
//             eventRange: eventRange,
//             eventType: eventType,
//           },
//         }
//       );
//       // console.log("eventRange:", eventRange, "eventType:", eventType);

//       // console.log("response.data" , response.data)

//       // const res_data = response.data.volatilityEvent.data;
//       const res_data = response.data.volatilityEvent.data.output;
//       const res_data_nonzero = response.data.volatilityEvent.data.nonZeroEvent;
//       const res_data_zero = response.data.volatilityEvent.data.zeroEvent;
//       const sorted_res_data = res_data.sort((a, b) =>
//         Object.keys(a)[0].localeCompare(Object.keys(b)[0])
//       );
//       const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) =>
//         Object.keys(a)[0].localeCompare(Object.keys(b)[0])
//       );
//       const sorted_res_data_zero = res_data_zero.sort((a, b) =>
//         Object.keys(a)[0].localeCompare(Object.keys(b)[0])
//       );
//       // console.log("sorted_res_data" , sorted_res_data);
//       // console.log("sorted_res_data_nonzero-------->" , sorted_res_data_nonzero);
//       // console.log("sorted_res_data_zero-------->" , sorted_res_data_zero);
//       setVolatilityImpact_firsttable(sorted_res_data);
//       setVolatilityImpact_firsttable_nonzero(sorted_res_data_nonzero);
//       setVolatilityImpact_firsttable_zero(sorted_res_data_zero);

//       // setLoading_3rdtable(true);

//       // <----second table---->
//       const second_table_res_data = response.data.event.data.output;
//       const second_table_res_data_nonzero =
//         response.data.event.data.nonZeroEvent;

//       const second_table_res_data_zero = response.data.event.data.zeroEvent;
//       const second_table_res_data_flatPOS_flatNEV =
//         response.data.event.data.postiveNegative;

//       setVolatilityImpact_secondtable(second_table_res_data);
//       // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
//       // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
//       setVolatilityImpact_secondtable_flatPOS_flatNEV(
//         second_table_res_data_flatPOS_flatNEV
//       );
//       setLoading(false);
//       setRunclickedevent_dateapi(true);
//       setRunclickedevent_dateapi2(true);
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   useEffect(() => {
//     getFirstTabledata();
//     handleOptionChange();
//     handletimebtnclick();
//   }, []);

//   useEffect(() => {
//     const dates = volatilityImpact_firsttable.map((item) => item.date);
//     // Function to parse dates and calculate the difference in days
//     function getDateDifferences(dates) {
//       const dateDifferences = [];
//       for (let i = 0; i < dates.length - 1; i++) {
//         const date1 = new Date(dates[i]);
//         const date2 = new Date(dates[i + 1]);
//         const differenceInTime = Math.abs(date2.getTime() - date1.getTime());
//         const differenceInDays = differenceInTime / (1000 * 3600 * 24);
//         dateDifferences.push(differenceInDays);
//       }
//       return dateDifferences;
//     }

//     // Get the date differences for the first 6 days
//     const first6Dates = dates.slice(0, 6);
//     const dateDifferences = getDateDifferences(first6Dates);
//     const sumOfDifferences = dateDifferences.reduce(
//       (sum, diff) => sum + diff,
//       0
//     );
//     const averageGap = sumOfDifferences / dateDifferences.length;
//     const roundedAverageGap = Math.round(averageGap);
//     setFrequency_date(roundedAverageGap);
//     // console.log('Average gap between the first 6 days:', roundedAverageGap);
//   }, [volatilityImpact_firsttable]);

//   const [selectedIds, setSelectedIds] = useState([]);
//   const [selectedIndexes, setSelectedIndexes] = useState([]);

//   // const handleCheckboxChange = (e, id, index) => {
//   const handleCheckboxChange = (e, id) => {
//     if (e.target.checked) {
//       // setSelectedIndexes((prev) => [...prev, index]);
//       setSelectedIds((prev) => [...prev, id]);
//     } else {
//       // setSelectedIndexes((prev) => prev.filter((i) => i !== index));
//       setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
//     }
//   };

//   useEffect(() => {
//     getFirstTabledata();
//   }, [eventRange, eventType]);

//   const handleSend = async () => {
//     try {
//       console.log("selectedIds", selectedIds);
//       const response = await axios.post(
//         `${process.env.REACT_APP_URL}/user/getParticularRowsTable`,
//         { ids: selectedIds }
//       );
//       toast.success("final rows selected.", { position: "top-right" });
//       // console.log('Success:', response.data);
//       const res_data = response.data.volatilityEvent.data.output;
//       const res_data_nonzero = response.data.volatilityEvent.data.nonZeroEvent;
//       const res_data_zero = response.data.volatilityEvent.data.zeroEvent;
//       const sorted_res_data = res_data.sort((a, b) =>
//         Object.keys(a)[0].localeCompare(Object.keys(b)[0])
//       );
//       const sorted_res_data_nonzero = res_data_nonzero.sort((a, b) =>
//         Object.keys(a)[0].localeCompare(Object.keys(b)[0])
//       );
//       const sorted_res_data_zero = res_data_zero.sort((a, b) =>
//         Object.keys(a)[0].localeCompare(Object.keys(b)[0])
//       );
//       // console.log("res_data" , res_data);
//       // console.log("sorted_res_data_zero-------->" , sorted_res_data_zero);
//       setVolatilityImpact_firsttable(sorted_res_data);
//       setVolatilityImpact_firsttable_nonzero(sorted_res_data_nonzero);
//       setVolatilityImpact_firsttable_zero(sorted_res_data_zero);
//       setSelectedIds([]);
//       // setLoading_3rdtable(true);

//       // <----second table---->
//       const second_table_res_data = response.data.event.data.output;
//       const second_table_res_data_nonzero =
//         response.data.event.data.nonZeroEvent;

//       const second_table_res_data_zero = response.data.event.data.zeroEvent;
//       const second_table_res_data_flatPOS_flatNEV =
//         response.data.event.data.postiveNegative;

//       setVolatilityImpact_secondtable(second_table_res_data);
//       // setVolatilityImpact_secondtable_nonzero(second_table_res_data_nonzero)
//       // setVolatilityImpact_secondtable_zero(second_table_res_data_zero)
//       setVolatilityImpact_secondtable_flatPOS_flatNEV(
//         second_table_res_data_flatPOS_flatNEV
//       );
//       setSelectedIds([]);
//       // console.log("selectedids" , selectedIds)
//     } catch (error) {
//       console.error("Error sending IDs:", error);
//     }
//   };

//   return (
//     <>
//       {volatilityImpact_firsttable.length > 0 && !Loading ? (
//         <div className="">
//           <UserNavbar />

//           <div className={` mx-auto  flex justify-center items-center w-full`}>
//             <div
//               className={`${styles.eventpage} flex flex-col mx-auto mt-[20%] sm:mt-[20%] md:mt-[10%] lg:mt-[8%] xl:mt-[3%] bg-[#fff]  rounded-[18px] justify-center items-start md:items-center`}
//             >
//               <div
//                 className={`  ${styles.eventpage} flex flex-col sm:flex-col md:flex-col lg:flex-col xl:flex-row px-[2%] pb-[1%] pt-[3%] `}
//               >
//                 <div className=" font-bold flex text-[15px]  sm:text-[15px] md:text-[18px] text-[#5829A9] w-[363px]">
//                   {" "}
//                   <span className="font-medium flex px-1 text-[#240D3A] pr-2 w-[113px]">
//                     <img
//                       src={eventicon}
//                       alt="eventicon"
//                       className="h-[20px] w-[20px] mr-2 mt-1 "
//                     />{" "}
//                     Event :
//                   </span>
//                   <span className="md:w-[300px] mr-[3%] "> {event}</span>{" "}
//                 </div>
//                 <div className="text-[15px] sm:text-[15px] md:text-[18px] font-bold text-[#5829A9] md:w-[200px]  flex ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-[0%]">
//                   <span className="font-medium flex px-1 text-[#240D3A]">
//                     <img
//                       src={locationicon}
//                       alt="locationicon"
//                       className="h-[20px] w-[20px] mr-2 mt-1 font-bold "
//                     />{" "}
//                     Country :
//                   </span>{" "}
//                   {country}{" "}
//                 </div>
//                 <div className="flex text-[15px] sm:text-[15px] md:text-[18px] font-semibold flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-row">
//                   <div className="w-[200px] font-bold flex text-[#5829A9] ">
//                     <span className="font-medium flex px-1 text-[#240D3A]">
//                       <img
//                         src={dateicon}
//                         alt="dateicon"
//                         className="h-[20px] w-[20px] mr-2 mt-1 "
//                       />
//                       Date :{" "}
//                     </span>{" "}
//                     {date}{" "}
//                   </div>{" "}
//                   <div className="text-[#5829A9] ml-0 lg:ml-10 font-bold md:w-[300px] flex">
//                     <span className="font-medium flex px-1 text-[#240D3A]">
//                       <img
//                         src={timeicon}
//                         alt="timeicon"
//                         className="h-[20px] w-[20px] mr-2 mt-1 "
//                       />
//                       Time (GMT) :
//                     </span>{" "}
//                     {time.slice(0, 5)}{" "}
//                   </div>
//                 </div>
//                 <div className="flex text-[15px] sm:text-[15px] md:text-[18px] font-semibold   ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-[0%] xl:mr-[3%]">
//                   {" "}
//                   <div className="text-[#5829A9] ml-0 md:w-[180px] font-bold flex">
//                     <span className="font-medium flex px-1 text-[#240D3A]">
//                       <img
//                         src={impacticon}
//                         alt="impacticon"
//                         className="h-[20px] w-[20px] mr-2 mt-1 "
//                       />
//                       Impact :
//                     </span>
//                     {impact}{" "}
//                   </div>
//                 </div>

//                 <div className="text-[#5829A9]  font-bold flex text-[15px] sm:text-[15px] md:text-[18px]   md:w-[430px]  ml-0 sm:ml-0 md:ml-0 lg:ml-0 xl:ml-0">
//                   {" "}
//                   <span className="font-medium flex px-1 text-[#240D3A]">
//                     {" "}
//                     <img
//                       src={frequencyicon}
//                       alt="frequencyicon"
//                       className="h-[20px] w-[20px] mr-2 mt-1 "
//                     />
//                     Average frequency of event release :
//                   </span>{" "}
//                   {frequency_date}
//                 </div>
//               </div>
//               <hr className="bg-[#A0A0A0] bg-opacity-[5%] h-1 w-full" />
//               <div className=" flex flex-col text-[15px] sm:text-[15px] md:text-[18px] text-[#240d3a] py-[1%] px-[8%] md:px-0 lg:px-[1%] xl:px-[2%] w-full text-center justify-center items-start md:items-center lg:items-start">
//                 <h1 className="font-bold text-start my-1">
//                   Event count on
//                   <span className="font-semibold text-[#5829A9]">
//                     {" "}
//                     {date}
//                   </span>{" "}
//                   at{" "}
//                   <span className="font-semibold text-[#5829A9]">
//                     {time.slice(0, 5)}
//                   </span>{" "}
//                   :{" "}
//                   <span className="ml-3 font-semibold">
//                     {
//                       clickeddate_Loading ? (
//                         <span className="loader1 text-red-400">Loading...</span>
//                       ) : // console.log("eventimpactontimespecificdate" , eventimpactontimespecificdate)
//                       eventimpactontimespecificdate.every(
//                           (item) => item === ""
//                         ) ? (
//                         "No data"
//                       ) : (
//                         eventimpactontimespecificdate || "No data"
//                       )

//                       // eventimpactontimespecificdate || "None"
//                     }
//                   </span>
//                 </h1>
//                 <h1 className="font-bold text-start my-1 w-[90%] ">
//                   Event count on
//                   <span className="font-semibold text-[#5829A9]">
//                     {" "}
//                     {date}{" "}
//                   </span>{" "}
//                   before{" "}
//                   <span className="font-semibold text-[#5829A9]">
//                     {" "}
//                     {time.slice(0, 5)}{" "}
//                   </span>{" "}
//                   :{" "}
//                   <span className="ml-3 font-semibold">
//                     {
//                       clickeddate_Loading ? (
//                         <span className="loader1 text-red-400">Loading...</span>
//                       ) : // console.log("eventimpactbeforetimespecificdate",  eventimpactbeforetimespecificdate)
//                       eventimpactbeforetimespecificdate.every(
//                           (item) => item === ""
//                         ) ? (
//                         "No data"
//                       ) : (
//                         eventimpactbeforetimespecificdate || "No data"
//                       )
//                       // eventimpactbeforetimespecificdate || "None"
//                     }
//                   </span>
//                 </h1>
//               </div>
//             </div>
//           </div>

//           <div className="flex flex-col sm:flex-col md:flex-row lg:flex-row xl:flex-row justify-between mx-[3%] mt-[2%]">
//             <div>
//               <IoArrowBack
//                 className=" cursor-pointer mb-2"
//                 onClick={() => navigate("/user/economicdata")}
//                 title="Back Button"
//               />
//               <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
//                 <Space
//                   style={{
//                     width: "100%",
//                     paddingTop: 0,
//                     height: "46px",
//                   }}
//                   direction="vertical"
//                 >
//                   <FormControl sx={{ width: 200, height: 46 }}>
//                     <InputLabel id="range-select-label">
//                       Select Range
//                     </InputLabel>
//                     <Select
//                       labelId="range-select-label"
//                       value={eventRange}
//                       defaultValue="6"
//                       onChange={(e) => handleOptionChange(e.target.value)}
//                       label="Events Range"
//                       sx={{ height: 46 }}
//                     >
//                       {/* <---chnges for noe demo by  kushgara , we are changing values----> */}
//                       <MenuItem value="6">Last 6</MenuItem>
//                       <MenuItem value="12">Last 12</MenuItem>
//                       <MenuItem value="24">Last 24</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Space>
//               </div>
//               <div className="relative block sm:block md:inline-block lg:inline-block xl:inline-block pr-3 mb-4 sm:mb-4 md:mb-4 lg:mb-0 xl:mb-0">
//                 <Space
//                   style={{
//                     width: "100%",
//                     paddingTop: 0,
//                     height: "46px",
//                   }}
//                   direction="vertical"
//                 >
//                   <FormControl sx={{ width: 200, height: 46 }}>
//                     <InputLabel id="time-select-label">Select Time</InputLabel>
//                     <Select
//                       labelId="time-select-label"
//                       value={eventType}
//                       defaultValue="1min"
//                       onChange={(e) => handletimebtnclick(e.target.value)}
//                       label="Select Time"
//                       sx={{ height: 46 }}
//                     >
//                       <MenuItem value="1min">1 min</MenuItem>
//                       <MenuItem value="5min" disabled>
//                         5 min
//                       </MenuItem>
//                       <MenuItem value="15min" disabled>
//                         15 min
//                       </MenuItem>
//                       <MenuItem value="1hour" disabled>
//                         1 hr
//                       </MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Space>
//               </div>
//             </div>
//             <div className="flex">
//               <div
//                 className={`h-[40px] p-3  text-[#240d3a] font-small text-[14px] flex border border-solid border-[#240d3a] items-center rounded-md ${
//                   isgraphbuttonDisabled
//                     ? "cursor-not-allowed opacity-50"
//                     : "cursor-pointer"
//                 }`}
//                 onClick={
//                   !isgraphbuttonDisabled ? handlegeneratechart : undefined
//                 }
//               >
//                 <img
//                   src={movementicon}
//                   title="Generate graphs"
//                   alt="graphs"
//                   className="w-[25px] h-[22px]"
//                 />

//                 <h1 className="ml-2">Generate Charts </h1>
//               </div>
//               <div
//                 className={`h-[40px] p-3 mx-3  text-[#240d3a] font-small text-[14px] flex border border-solid border-[#240d3a] items-center rounded-md cursor-not-allowed opacity-50 pointer-events-none${
//                   isgraphbuttonDisabled
//                     ? "cursor-not-allowed opacity-50"
//                     : "cursor-pointer"
//                 }`}
//                 disabled
//                 // onClick={!isgraphbuttonDisabled ? handlelivechart : undefined}
//               >
//                 <img
//                   src={livegraph_icon}
//                   title="Live graph"
//                   alt="graph"
//                   className="w-[25px] h-[22px]"
//                 />

//                 <h1 className="ml-2">Live Graph</h1>
//               </div>
//               <div className="ml-2">
//                 <img
//                   src={refresh_icon}
//                   alt="Refresh"
//                   title="Refresh"
//                   className={`h-[40px] w-[40px] cursor-pointer`}
//                   onClick={handleModalShowClick}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="mx-[3%] my-3  py-2   mt-5 flex justify-between">
//             <div className="flex justify-start w-[290px]">
//               <div className="relative inline-block  ">
//                 {/* Icon */}
//                 {showTooltip && (
//                   <div className="fixed inset-0  backdrop-blur-[1px] z-10"></div>
//                 )}

//                 {/* Tooltip */}
//                 {showTooltip && (
//                   <div
//                     ref={tooltipRef}
//                     className="w-[256px] left-[180px] md:w-[514px] md:left-[460px] border-white rounded-[8px] bg-white absolute bottom-[155%]  transform -translate-x-1/2 z-[99]  text-[#240d3a] text-sm p-4  shadow-lg "
//                   >
//                     <div className="bg-[#f7f7f7] p-3 flex text-center flex-col sm:flex-col md:flex-row">
//                       <div className="text-center sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
//                         <div>
//                           <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
//                             Summary Color Key :{" "}
//                           </h1>
//                         </div>
//                         <div className="mt-2">
//                           <div className="flex items-center my-2">
//                             <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                               Highest Average:
//                             </h1>
//                             <img
//                               src={color1}
//                               title="color"
//                               alt="color"
//                               className="ml-4 w-[25px] h-[27px]"
//                             />
//                             {/* <span className="font-bold ml-2">,</span> */}
//                           </div>
//                           <div className="flex items-center my-2">
//                             <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                               {" "}
//                               2nd Highest Average:
//                             </h1>
//                             <img
//                               src={color2}
//                               title="color"
//                               alt="color"
//                               className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                             />
//                             {/* <span className="font-bold ml-2">,</span> */}
//                           </div>
//                           <div className="flex items-center my-2">
//                             <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                               {" "}
//                               3rd Highest Average:
//                             </h1>
//                             <img
//                               src={color3}
//                               title="color"
//                               alt="color"
//                               className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                             />
//                             {/* <span className="ml-[8px]">,</span> */}
//                           </div>
//                         </div>
//                       </div>

//                       <div className="text-center sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
//                         <div>
//                           <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
//                             Table Color Key :{" "}
//                           </h1>
//                         </div>
//                         <div className="mt-2">
//                           <div className="flex items-center my-2">
//                             <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                               {">500 % :"}
//                             </h1>
//                             <img
//                               src={color4}
//                               title="color"
//                               alt="color"
//                               className="ml-4 w-[25px] h-[27px]"
//                             />
//                             {/* <span className="font-bold ml-2">,</span> */}
//                           </div>
//                           <div className="flex items-center my-2">
//                             <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                               {"300-500 % :"}
//                             </h1>
//                             <img
//                               src={color5}
//                               title="color"
//                               alt="color"
//                               className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                             />
//                             {/* <span className="font-bold ml-2">,</span> */}
//                           </div>
//                           <div className="flex items-center my-2">
//                             <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                               {"<300 % :"}
//                             </h1>
//                             <img
//                               src={color6}
//                               title="color"
//                               alt="color"
//                               className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                             />
//                             {/* <span className="ml-[8px]">,</span> */}
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Triangle Tip */}
//                     <div className="absolute bottom-[-10px] left-[8%] transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white"></div>
//                   </div>
//                 )}
//               </div>
//               <h1 className=" font-bold text-[20px] text-[#240d3a]">
//                 Event Volatility Impact
//               </h1>
//               <img
//                 src={eye_btn_tooltip}
//                 title="Information of Volatility Correlation Table"
//                 alt="eye_btn_tooltip"
//                 className="w-[24px] h-[27px]  cursor-pointer pb-2"
//                 onClick={handleImageClick}
//               />
//               :
//             </div>

//             <div className="flex items-end justify-end mb-4 ">
//               <h1
//                 className="rounded-[8px] flex  justify-center text-white bg-[#240D3A] border border-solid border-[#5b6b8b] p-2 items-end cursor-pointer font-bold "
//                 title="Click here for final selection of rows"
//                 onClick={handleSend}
//               >
//                 Final Selected Rows
//               </h1>
//             </div>
//           </div>

//           {/* <button onClick={handleSend} className="btn">
//           Send
//         </button> */}

//           <div className="overflow-auto relative">
//             <div
//               className={`mx-[3%] overflow-x-auto overflow-y-auto relative${
//                 optionValue === "last 6"
//                   ? "max-h-[103vh]"
//                   : optionValue === "last 12"
//                   ? "max-h-[165vh]"
//                   : optionValue === "last 24"
//                   ? "max-h-[300vh]"
//                   : ""
//               }`}
//             >
//               <table
//                 className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
//               >
//                 <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
//                   <tr>
//                     <th
//                       className="bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white "
//                       colSpan={12}
//                     ></th>
//                     <th
//                       className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white  text-white"
//                       colSpan={7}
//                     >
//                       % Price movement vs. prior 5 minute range (High-Low)
//                     </th>
//                     <th
//                       className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
//                       colSpan={7}
//                     >
//                       {`Total points moved post release (High – Low , (1min))`}
//                     </th>
//                     <th
//                       className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
//                       colSpan={11}
//                     >
//                       {`Total points moved post release (High – Low , (5min))`}
//                     </th>
//                   </tr>
//                   <tr className="h-[81px]">
//                     <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
//                       Make selection
//                     </th>
//                     <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
//                       S. No
//                     </th>
//                     <th className="sticky top-0 py-2 px-2 w-[73px]">Date</th>
//                     <th className="sticky top-0 py-2 px-2 w-[91px]">
//                       Time(GMT)
//                     </th>
//                     <th
//                       className={`sticky top-0 py-2 px-2 w-[200px] min-w-[200px]`}
//                     >
//                       Event count before this time
//                     </th>
//                     <th className="sticky top-0 py-2 w-[150px] px-2 min-w-[150px]">
//                       Event count at this time
//                     </th>
//                     <th className="sticky top-0 py-2 px-2 w-[77px]">
//                       Previous
//                     </th>
//                     <th className="sticky top-0 py-2 px-2 w-[60px]">Actual</th>
//                     <th className="sticky top-0 py-2 px-2 w-[77px]">
//                       Estimate
//                     </th>

//                     <th className="sticky w-[97px] top-0 py-2 px-2  min-w-[99.33px]">
//                       Act - Prev
//                     </th>

//                     <th className="z-[99] w-[98px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6]  min-w-[99.33px]">
//                       Act - Est
//                     </th>
//                     <th className=" z-[99] w-[100px] sticky top-0 py-2 px-2 border-r-[4px] border-[#F6F6F6] bg-[#b38dd3] bg-opacity-[56%] ">
//                       Final movement direction
//                     </th>

//                     {headers.map((header, index) => (
//                       <th
//                         key={header.id}
//                         className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
//                           index === headers.length - 1
//                             ? "border-r-4 border-white"
//                             : ""
//                         }`}
//                       >
//                         {header.name}
//                         {/* <br />
//                         (severity) */}
//                       </th>
//                     ))}
//                     {headers.map((header, index) => (
//                       <th
//                         key={header.id}
//                         className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
//                           index === headers.length - 1
//                             ? "border-r-4 border-white"
//                             : ""
//                         }`}
//                       >
//                         {header.name}
//                       </th>
//                     ))}
//                     {headers.map((header, index) => (
//                       <th
//                         key={header.id}
//                         className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
//                           index === headers.length - 1
//                             ? "border-r-4 border-white"
//                             : ""
//                         }`}
//                       >
//                         {header.name}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
//                   {volatilityImpact_firsttable.map((item, index) => {
//                     // {console.log("me hu ji item jo aya hu map ke time pAR--->" , item)}
//                     const itemDatecheck = item.date.split(" ")[0];

//                     // Filtering impacthighlow array to find the matching data
//                     const matchingData = impacthighlow.find((data) =>
//                       data.startsWith(itemDatecheck)
//                     );

//                     const normalizeDate = (dateStr) => {
//                       return dateStr.split(" ")[0];
//                     };

//                     const filterImpactData = (date) => {
//                       const normalizedDate = normalizeDate(date);

//                       return impacthighlowbeforethis.filter((impact) => {
//                         const impactDate = impact.split(":")[0];

//                         return impactDate === normalizedDate;
//                       });
//                     };

//                     const impactData = filterImpactData(item.date);
//                     return (
//                       <>
//                         <tr
//                           key={index}
//                           className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] "
//                         >
//                           <td>
//                             <input
//                               type="checkbox"
//                               // item={geteditdata}

//                               className="mt-0 ml-4"
//                               onChange={(e) =>
//                                 handleCheckboxChange(e, item._id)
//                               }
//                               checked={selectedIds.includes(item._id)}
//                               // checked={selectedIndexes.includes(index)}
//                               //  checked={selectedIds.includes(item._id)}
//                             />
//                           </td>
//                           <td className="py-2 min-w-[81px]">{index + 1}.</td>
//                           <td className="py-2 ">{item.date}</td>
//                           <td className="py-2 ">{item.time.slice(0, 5)}</td>

//                           {run_modalloader ? (
//                             <td className="min-w-[200px] w-[200px]">
//                               {" "}
//                               <span className="loader1 text-[#1c72ca] text-center">
//                                 Loading...
//                               </span>
//                             </td>
//                           ) : (
//                             <>
//                               <td
//                                 className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
//                                 onClick={() =>
//                                   handleShowModalbeforetime(item.date)
//                                 }
//                               >
//                                 {impactData.length > 0 ? (
//                                   impactData.map((impact, i) => {
//                                     const impactParts = impact.split(" ");
//                                     // Remove the first element (date and time)
//                                     const formattedImpact = impactParts
//                                       .slice(1)
//                                       .join(" ");

//                                     return (
//                                       <span key={i} className="font-bold block">
//                                         {formattedImpact}
//                                       </span>
//                                     );
//                                   })
//                                 ) : (
//                                   <span className="font-bold">No Data</span>
//                                 )}
//                               </td>

//                               <dialog
//                                 id="my_modal_2"
//                                 onClick={() => {
//                                   autoClickButton();
//                                 }}
//                                 className={` ${styles.addmodalDirection_eventhistory} modal p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 absolute max-h-[60vh]  top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
//                               >
//                                 <form
//                                   method="dialog"
//                                   className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
//                                 >
//                                   <div className="modal-box relative top-[3px]">
//                                     <div
//                                       onClick={() => {
//                                         autoClickButton();
//                                       }}
//                                     >
//                                       <button id="aashima_id">
//                                         <img
//                                           alt="img"
//                                           src={crossicon}
//                                           className="w-[20px] h-[20px]"
//                                         ></img>
//                                       </button>
//                                     </div>
//                                     <div className="">
//                                       {filteredModalData.length > 0 ? (
//                                         <>
//                                           {/* High Impact */}
//                                           {filteredModalData.some(
//                                             (data) =>
//                                               data.impact.toLowerCase() ===
//                                               "high"
//                                           ) && (
//                                             <div className="text-center flex items-center justify-center">
//                                               <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
//                                                 High Impact :-
//                                               </h3>
//                                             </div>
//                                           )}
//                                           <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
//                                             {filteredModalData.map(
//                                               (data, index) => {
//                                                 if (
//                                                   data.impact.toLowerCase() ===
//                                                   "high"
//                                                 ) {
//                                                   return (
//                                                     <div
//                                                       key={index}
//                                                       className="text-start pl-[20px] my-4"
//                                                     >
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={dateicon}
//                                                             alt="dateicon"
//                                                             className="h-[20px] w-[20px] mr-2  "
//                                                           />
//                                                           Date:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.date}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={timeicon}
//                                                             alt="timeicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />
//                                                           Time:{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.time.slice(
//                                                             0,
//                                                             5
//                                                           )}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={locationicon}
//                                                             alt="locationicon"
//                                                             className="h-[20px] w-[20px] mr-2 font-bold "
//                                                           />{" "}
//                                                           Country:{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.country}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={eventicon}
//                                                             alt="eventicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />{" "}
//                                                           Event :{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.event}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <hr />
//                                                     </div>
//                                                   );
//                                                 }
//                                                 return null;
//                                               }
//                                             )}
//                                           </div>

//                                           {/* Medium Impact */}
//                                           {filteredModalData.some(
//                                             (data) =>
//                                               data.impact.toLowerCase() ===
//                                               "medium"
//                                           ) && (
//                                             <div className="text-center flex items-center justify-center">
//                                               <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
//                                                 Medium Impact :-
//                                               </h3>
//                                             </div>
//                                           )}
//                                           <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
//                                             {filteredModalData.map(
//                                               (data, index) => {
//                                                 if (
//                                                   data.impact.toLowerCase() ===
//                                                   "medium"
//                                                 ) {
//                                                   return (
//                                                     <div
//                                                       key={index}
//                                                       className="text-start pl-[20px] my-4"
//                                                     >
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={dateicon}
//                                                             alt="dateicon"
//                                                             className="h-[20px] w-[20px] mr-2  "
//                                                           />{" "}
//                                                           Date:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.date}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={timeicon}
//                                                             alt="timeicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />{" "}
//                                                           Time:{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.time.slice(
//                                                             0,
//                                                             5
//                                                           )}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={locationicon}
//                                                             alt="locationicon"
//                                                             className="h-[20px] w-[20px] mr-2 font-bold "
//                                                           />{" "}
//                                                           Country:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.country}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={eventicon}
//                                                             alt="eventicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />{" "}
//                                                           Event:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.event}
//                                                         </span>
//                                                       </p>
//                                                       <hr />
//                                                     </div>
//                                                   );
//                                                 }
//                                                 return null;
//                                               }
//                                             )}
//                                           </div>
//                                         </>
//                                       ) : (
//                                         <p className="text-center mt-4">
//                                           No Data
//                                         </p>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </form>
//                               </dialog>
//                             </>
//                           )}

//                           {run_modalloader ? (
//                             <td>
//                               <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
//                                 Loading...
//                               </span>
//                             </td>
//                           ) : (
//                             <>
//                               {" "}
//                               <td
//                                 className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
//                                 onClick={() => handleShowModalontime(item.date)}
//                               >
//                                 {matchingData && (
//                                   <span className="font-bold text-[13px]">
//                                     {matchingData.includes(": ")
//                                       ? matchingData.substring(
//                                           matchingData.indexOf(": ") + 2
//                                         )
//                                       : matchingData}
//                                   </span>
//                                 )}
//                               </td>
//                               <dialog
//                                 id="my_modal_3"
//                                 onClick={() => {
//                                   autoClickButton1();
//                                 }}
//                                 className={`  ${styles.addmodalDirection_eventhistory} modal p-6 absolute max-h-[60vh] top-[106%] sm:top-[106%] md:top-[106%] lg:top-[44%] xl:top-[44%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
//                               >
//                                 <form
//                                   method="dialog"
//                                   className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
//                                 >
//                                   <div className="modal-box relative top-[3px]">
//                                     <div
//                                       onClick={() => {
//                                         autoClickButton1();
//                                       }}
//                                     >
//                                       <button id="closemod11">
//                                         <img
//                                           alt="img"
//                                           src={crossicon}
//                                           className="w-[20px] h-[20px]"
//                                         ></img>
//                                       </button>
//                                     </div>
//                                     <div>
//                                       {filteredModalDataontime.length > 0 ? (
//                                         <>
//                                           {/* High Impact */}
//                                           {filteredModalDataontime.some(
//                                             (data) =>
//                                               data.impact.toLowerCase() ===
//                                               "high"
//                                           ) && (
//                                             <div className="text-center flex items-center justify-center">
//                                               <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
//                                                 High Impact :-
//                                               </h3>
//                                             </div>
//                                           )}
//                                           <div className="">
//                                             {filteredModalDataontime.map(
//                                               (data, index) => {
//                                                 if (
//                                                   data.impact.toLowerCase() ===
//                                                   "high"
//                                                 ) {
//                                                   return (
//                                                     <div
//                                                       key={index}
//                                                       className="text-start pl-[20px] my-4"
//                                                     >
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={dateicon}
//                                                             alt="dateicon"
//                                                             className="h-[20px] w-[20px] mr-2  "
//                                                           />
//                                                           Date:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.date}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={timeicon}
//                                                             alt="timeicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />
//                                                           Time:{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.time.slice(
//                                                             0,
//                                                             5
//                                                           )}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={locationicon}
//                                                             alt="locationicon"
//                                                             className="h-[20px] w-[20px] mr-2 font-bold "
//                                                           />{" "}
//                                                           Country:{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.country}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={eventicon}
//                                                             alt="eventicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />{" "}
//                                                           Event :{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.event}{" "}
//                                                         </span>
//                                                       </p>
//                                                       <hr />
//                                                     </div>
//                                                   );
//                                                 }
//                                                 return null;
//                                               }
//                                             )}
//                                           </div>

//                                           {/* Medium Impact */}
//                                           {filteredModalDataontime.some(
//                                             (data) =>
//                                               data.impact.toLowerCase() ===
//                                               "medium"
//                                           ) && (
//                                             <div className="text-center flex items-center justify-center">
//                                               <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
//                                                 Medium Impact :-
//                                               </h3>
//                                             </div>
//                                           )}
//                                           <div className="">
//                                             {filteredModalDataontime.map(
//                                               (data, index) => {
//                                                 if (
//                                                   data.impact.toLowerCase() ===
//                                                   "medium"
//                                                 ) {
//                                                   return (
//                                                     <div
//                                                       key={index}
//                                                       className="text-start pl-[20px] my-4"
//                                                     >
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={dateicon}
//                                                             alt="dateicon"
//                                                             className="h-[20px] w-[20px] mr-2  "
//                                                           />{" "}
//                                                           Date:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.date}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={timeicon}
//                                                             alt="timeicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />{" "}
//                                                           Time:{" "}
//                                                         </span>
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.time.slice(
//                                                             0,
//                                                             5
//                                                           )}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={locationicon}
//                                                             alt="locationicon"
//                                                             className="h-[20px] w-[20px] mr-2 font-bold "
//                                                           />{" "}
//                                                           Country:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.country}
//                                                         </span>
//                                                       </p>
//                                                       <p className="flex items-center mb-[6px] text-[16px]">
//                                                         <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                           <img
//                                                             src={eventicon}
//                                                             alt="eventicon"
//                                                             className="h-[20px] w-[20px] mr-2 "
//                                                           />{" "}
//                                                           Event:
//                                                         </span>{" "}
//                                                         <span className="text-[#5a2989]">
//                                                           {" "}
//                                                           {data.event}
//                                                         </span>
//                                                       </p>
//                                                       <hr />
//                                                     </div>
//                                                   );
//                                                 }
//                                                 return null;
//                                               }
//                                             )}
//                                           </div>
//                                         </>
//                                       ) : (
//                                         <p className="text-center mt-4">
//                                           No Data
//                                         </p>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </form>
//                               </dialog>
//                             </>
//                           )}

//                           <td className="py-2 ">{item.previous}</td>
//                           <td className="py-2 ">{item.actual}</td>
//                           <td className="py-2 ">{item.estimate}</td>

//                           <td
//   className={`py-2 text-[#240d3a] font-bold ${
//     item.actualminusprevious == null ||
//     item.actualminusprevious === "N/A" ||
//     item.actualminusprevious === ""
//       ? "bg-[#E5E7EB]"
//       : parseFloat(item.actualminusprevious) > 0
//       ? "bg-[#5de98e]"
//       : parseFloat(item.actualminusprevious) === 0
//       ? "bg-[#f1d500]"
//       : parseFloat(item.actualminusprevious) < 0
//       ? "bg-[#ff8e8ef2]"
//       : "bg-[#E5E7EB]"
//   }`}
// >
//   {item.actualminuspreviousdivestimate != null &&
//    item.actualminuspreviousdivestimate !== "N/A"
//     ? item.actualminuspreviousdivestimate
//     : "N/A"}

//   <br />

//   {item.actualminusprevious != null &&
//    item.actualminusprevious !== "N/A"
//     ? `(${item.actualminusprevious})`
//     : ""}
// </td>

//                           <td
//   className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
//     item.actualminusestimate == null ||
//     item.actualminusestimate === "N/A" ||
//     item.actualminusestimate === ""
//       ? "bg-[#E5E7EB]"
//       : parseFloat(item.actualminusestimate) > 0
//       ? "bg-[#5de98e]"
//       : parseFloat(item.actualminusestimate) === 0
//       ? "bg-[#f1d500]"
//       : parseFloat(item.actualminusestimate) < 0
//       ? "bg-[#ff8e8ef2]"
//       : "bg-[#E5E7EB]"
//   }`}
// >
//   {item.actualminusestimatedivestimate != null &&
//    item.actualminusestimatedivestimate !== "N/A"
//     ? item.actualminusestimatedivestimate
//     : "N/A"}

//   <br />

//   {item.actualminusestimate != null &&
//    item.actualminusestimate !== "N/A"
//     ? `(${item.actualminusestimate})`
//     : ""}
// </td>

//                         <td
//   className={`py-2 text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
//     item.finalMovement == null ||
//     item.finalMovement === "N/A" ||
//     item.finalMovement === ""
//       ? "bg-[#E5E7EB]"
//       : parseFloat(item.finalMovement) > 0
//       ? "bg-[#5de98e]"
//       : parseFloat(item.finalMovement) === 0
//       ? "bg-[#f1d500]"
//       : parseFloat(item.finalMovement) < 0
//       ? "bg-[#ff8e8ef2]"
//       : "bg-[#E5E7EB]"
//   }`}
// >
//   {item.finalMovementperc != null &&
//    item.finalMovementperc !== "N/A"
//     ? item.finalMovementperc
//     : "N/A"}

//   <br />

//   {item.finalMovement != null &&
//    item.finalMovement !== "N/A"
//     ? `(${item.finalMovement})`
//     : ""}
// </td>
//                           {/* <---------1st section table-------------> */}

//                           {headers.map((header, index) => {
//                             // {console.log("----> me hu ji header thike",headers , header,item,header.name.split("/").join("").toLowerCase() + "1minprevfive")}

//                             return (
//                               <td
//                                 className={`border-[#F6F6F6] min-w-[91.95px] ${
//                                   parseFloat(
//                                     item[
//                                       header.name
//                                         .split("/")
//                                         .join("")
//                                         .toLowerCase() + "1minprevfive"
//                                     ]?.[0]?.highlow
//                                   ) > 500
//                                     ? "bg-[#7fe9a4]"
//                                     : parseFloat(
//                                         item[
//                                           header.name
//                                             .split("/")
//                                             .join("")
//                                             .toLowerCase() + "1minprevfive"
//                                         ]?.[0]?.highlow
//                                       ) >= 300 &&
//                                       parseFloat(
//                                         item[
//                                           header.name
//                                             .split("/")
//                                             .join("")
//                                             .toLowerCase() + "1minprevfive"
//                                         ]?.[0]?.highlow
//                                       ) <= 500
//                                     ? "bg-[#f7dc14]"
//                                     : parseFloat(
//                                         item[
//                                           header.name
//                                             .split("/")
//                                             .join("")
//                                             .toLowerCase() + "1minprevfive"
//                                         ]?.[0]?.highlow
//                                       ) < 300
//                                     ? "bg-[#f3b2b2]"
//                                     : "bg-[#E5E7EB]"
//                                 }  ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {item[
//                                   header.name
//                                     .split("/")
//                                     .join("")
//                                     ?.toLocaleLowerCase() + "1minprevfive"
//                                 ][0]?.highlow || "N/A"}
//                                 {/* {JSON.stringify(item[
//                                   header.name
//                                     .split("/")
//                                     .join("")
//                                     ?.toLocaleLowerCase() + "1minprevfive"
//                                 ][0])} */}
//                               </td>
//                             );
//                           })}

//                           {headers.map((header, index) => {
//                             //
//                             return (
//                               <td
//                                 className={`border-[#F6F6F6] min-w-[91.95px] ${
//                                   parseFloat(
//                                     item[
//                                       header.name
//                                         .split("/")
//                                         .join("")
//                                         .toLowerCase() + "1minprevfive"
//                                     ]?.[0]?.highlow
//                                   ) > 500
//                                     ? "bg-[#7fe9a4]"
//                                     : parseFloat(
//                                         item[
//                                           header.name
//                                             .split("/")
//                                             .join("")
//                                             .toLowerCase() + "1minprevfive"
//                                         ]?.[0]?.highlow
//                                       ) >= 300 &&
//                                       parseFloat(
//                                         item[
//                                           header.name
//                                             .split("/")
//                                             .join("")
//                                             .toLowerCase() + "1minprevfive"
//                                         ]?.[0]?.highlow
//                                       ) <= 500
//                                     ? "bg-[#f7dc14]"
//                                     : parseFloat(
//                                         item[
//                                           header.name
//                                             .split("/")
//                                             .join("")
//                                             .toLowerCase() + "1minprevfive"
//                                         ]?.[0]?.highlow
//                                       ) < 300
//                                     ? "bg-[#f3b2b2]"
//                                     : "bg-[#E5E7EB]"
//                                 }  ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {item[
//                                   header?.name
//                                     ?.split("/")
//                                     .join("")
//                                     ?.toLocaleLowerCase() + "1min"
//                                 ][0]?.highlow || "N/A"}
//                               </td>
//                             );
//                           })}

//                           {headers.map((header, index) => {
//                             const colorcodeofTable1 =
//                               item[
//                                 header.name.split("/").join("").toLowerCase() +
//                                   "1minnextfive"
//                               ]?.[0]?.highlow;

//                             const dividedValue =
//                               colorcodeofTable1 /
//                               item[
//                                 header.name.split("/").join("").toLowerCase() +
//                                   "1min"
//                               ]?.[0]?.highlow;
//                             //

//                             return (
//                               <td
//                                 className={`border-[#F6F6F6] min-w-[91.95px] ${
//                                   dividedValue >= 1.5
//                                     ? "bg-[#7fe9a4]"
//                                     : dividedValue >= 1.2 && dividedValue < 1.5
//                                     ? "bg-[#f7dc14]"
//                                     : dividedValue < 1.2
//                                     ? "bg-[#f3b2b2]"
//                                     : "bg-[#E5E7EB]"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {item[
//                                   header.name
//                                     .split("/")
//                                     .join("")
//                                     ?.toLocaleLowerCase() + "1minnextfive"
//                                 ][0]?.highlow || "N/A"}
//                               </td>
//                             );
//                           })}
//                         </tr>
//                       </>
//                     );
//                   })}

//                   {/* <------normal average of 1st table------> */}
//                   <tr className="bg-[#dccafe5e] text-center">
//                     <td
//                       className="py-2 font-bold min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
//                       colSpan={4}
//                     >
//                       Non-Zero event (average movement)
//                     </td>

//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className={`py-2 border-r-4 border-white`}></td>

//                     {headers.map((header, index) => {
//                       const allValues = volatilityImpact_firsttable_nonzero
//                         .map((item) => {
//                           let key = Object.keys(item).find((k) =>
//                             k.includes("1min")
//                           );
//                           return key
//                             ? parseFloat(
//                                 item[key].highminlowprevfive.replace("%", "")
//                               )
//                             : null;
//                         })
//                         .filter((value) => !isNaN(value)); // Ensure only numeric values

//                       // Get unique sorted values
//                       const sortedValues = [...new Set(allValues)].sort(
//                         (a, b) => b - a
//                       );
//                       // console.log("sortedValues" , sortedValues)
//                       const highest = sortedValues[0];
//                       const secondHighest = sortedValues[1];
//                       const thirdHighest = sortedValues[2];

//                       let filterObject =
//                         volatilityImpact_firsttable_nonzero.filter((item) =>
//                           Object.keys(item).includes(header.id + "1min")
//                         )[0];
//                       // console.log("filterObject" , filterObject)
//                       if (filterObject) {
//                         let rawValue =
//                           filterObject[Object.keys(filterObject)[0]]
//                             .highminlowprevfive;
//                         let value = parseFloat(rawValue.replace("%", ""));

//                         // console.log("value" , value)
//                         let bgColor = "";
//                         if (value === highest) {
//                           bgColor = "text-[#089ee4]";
//                         } else if (value === secondHighest) {
//                           bgColor = "text-[#52aed8]";
//                         } else if (value === thirdHighest) {
//                           bgColor = "text-[#88c3d4]";
//                         }
//                         return (
//                           <td
//                             className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {rawValue}
//                           </td>
//                         );
//                       } else {
//                         return <td>N/A</td>;
//                       }
//                     })}
//                     {headers.map((header, index) => {
//                       const allValues = volatilityImpact_firsttable_nonzero
//                         .map((item) => {
//                           let key = Object.keys(item).find((k) =>
//                             k.includes("1min")
//                           );
//                           return key ? item[key].highminlow : null;
//                         })
//                         .filter((value) => !isNaN(value)); // Ensure only numeric values

//                       // Get unique sorted values
//                       const sortedValues = [...new Set(allValues)].sort(
//                         (a, b) => b - a
//                       );
//                       // console.log("sortedValues" , sortedValues)
//                       const highest = sortedValues[0];
//                       const secondHighest = sortedValues[1];
//                       const thirdHighest = sortedValues[2];
//                       let filterObject =
//                         volatilityImpact_firsttable_nonzero.filter((item) =>
//                           Object.keys(item).includes(header.id + "1min")
//                         )[0];

//                       const finalValue =
//                         filterObject[Object.keys(filterObject)[0]].highminlow;
//                       // console.log("finalValue" , finalValue)

//                       let bgColor = "";
//                       if (finalValue === highest) {
//                         bgColor = "text-[#089ee4]";
//                       } else if (finalValue === secondHighest) {
//                         bgColor = "text-[#52aed8]";
//                       } else if (finalValue === thirdHighest) {
//                         bgColor = "text-[#88c3d4]";
//                       }
//                       if (filterObject) {
//                         return (
//                           <td
//                             className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             } `}
//                           >
//                             {finalValue}
//                           </td>
//                         );
//                       } else {
//                         return <td>N/A</td>;
//                       }
//                     })}
//                     {headers.map((header, index) => {
//                       const allValues = volatilityImpact_firsttable_nonzero
//                         .map((item) => {
//                           let key = Object.keys(item).find((k) =>
//                             k.includes("1min")
//                           );
//                           return key ? item[key].highminlownextfive : null;
//                         })
//                         .filter((value) => !isNaN(value)); // Ensure only numeric values

//                       // Get unique sorted values
//                       const sortedValues = [...new Set(allValues)].sort(
//                         (a, b) => b - a
//                       );
//                       // console.log("sortedValues" , sortedValues)
//                       const highest = sortedValues[0];
//                       const secondHighest = sortedValues[1];
//                       const thirdHighest = sortedValues[2];
//                       let filterObject =
//                         volatilityImpact_firsttable_nonzero.filter((item) =>
//                           Object.keys(item).includes(header.id + "1min")
//                         )[0];

//                       const finaldata =
//                         filterObject[Object.keys(filterObject)[0]]
//                           .highminlownextfive;
//                       let bgColor = "";
//                       if (finaldata === highest) {
//                         bgColor = "text-[#089ee4]";
//                       } else if (finaldata === secondHighest) {
//                         bgColor = "text-[#52aed8]";
//                       } else if (finaldata === thirdHighest) {
//                         bgColor = "text-[#88c3d4]";
//                       }
//                       if (filterObject) {
//                         return (
//                           <td
//                             className={`text-[15px] py-2  ${bgColor}  ${bgColor}  ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {finaldata}
//                           </td>
//                         );
//                       } else {
//                         return <td>N/A</td>;
//                       }
//                     })}
//                   </tr>

//                   {/* <------FLAT Average of 3rd table------> */}
//                   <tr className="bg-[#dccafe5e] text-center">
//                     <td
//                       className="py-2  font-bold   min-w-[80.8px] min-h-[66.97px] h-[66.97px]"
//                       colSpan={4}
//                     >
//                       Flat event (average movement)
//                     </td>

//                     <td className="py-2 "></td>
//                     <td className="py-2 "></td>
//                     <td className="py-2 "></td>
//                     <td className="py-2 "></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className="py-2"></td>
//                     <td className={`py-2 border-r-4 border-white`}></td>
//                     {headers.map((header, index) => {
//                       const allValues = volatilityImpact_firsttable_zero
//                         .map((item) => {
//                           let key = Object.keys(item).find((k) =>
//                             k.includes("1min")
//                           );
//                           return key
//                             ? parseFloat(item[key].highminlowprevfive)
//                             : null;
//                         })
//                         .filter((value) => !isNaN(value)); // Ensure only numeric values

//                       // Get unique sorted values
//                       const sortedValues = [...new Set(allValues)].sort(
//                         (a, b) => b - a
//                       );
//                       // console.log("sortedValues" , sortedValues)
//                       const highest = sortedValues[0];
//                       const secondHighest = sortedValues[1];
//                       const thirdHighest = sortedValues[2];
//                       let filterObject =
//                         volatilityImpact_firsttable_zero.filter((item) =>
//                           Object.keys(item).includes(header.id + "1min")
//                         )[0];
//                       const rawValue =
//                         filterObject[Object.keys(filterObject)[0]]
//                           .highminlowprevfive;
//                       const Value = parseFloat(rawValue.replace("%", ""));

//                       let bgColor = "";

//                       if (Value > 0) {
//                         if (Value === highest) {
//                           bgColor = "text-[#089ee4]";
//                         } else if (Value === secondHighest) {
//                           bgColor = "text-[#52aed8]";
//                         } else if (Value === thirdHighest) {
//                           bgColor = "text-[#88c3d4]";
//                         }
//                       }
//                       if (filterObject) {
//                         return (
//                           <td
//                             className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {rawValue}
//                           </td>
//                         );
//                       } else {
//                         return <td>N/A</td>;
//                       }
//                     })}
//                     {headers.map((header, index) => {
//                       const allValues = volatilityImpact_firsttable_zero
//                         .map((item) => {
//                           let key = Object.keys(item).find((k) =>
//                             k.includes("1min")
//                           );
//                           return key ? item[key].highminlow : null;
//                         })
//                         .filter((value) => !isNaN(value)); // Ensure only numeric values

//                       // Get unique sorted values
//                       const sortedValues = [...new Set(allValues)].sort(
//                         (a, b) => b - a
//                       );
//                       // console.log("sortedValues" , sortedValues)
//                       const highest = sortedValues[0];
//                       const secondHighest = sortedValues[1];
//                       const thirdHighest = sortedValues[2];
//                       let filterObject =
//                         volatilityImpact_firsttable_zero.filter((item) =>
//                           Object.keys(item).includes(header.id + "1min")
//                         )[0];
//                       const finalvalue =
//                         filterObject[Object.keys(filterObject)[0]].highminlow;

//                       let bgColor = "";
//                       if (finalvalue > 0) {
//                         if (finalvalue === highest) {
//                           bgColor = "text-[#089ee4]";
//                         } else if (finalvalue === secondHighest) {
//                           bgColor = "text-[#52aed8]";
//                         } else if (finalvalue === thirdHighest) {
//                           bgColor = "text-[#88c3d4]";
//                         }
//                       }
//                       if (filterObject) {
//                         return (
//                           <td
//                             className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {finalvalue}
//                           </td>
//                         );
//                       } else {
//                         return <td>N/A</td>;
//                       }
//                     })}
//                     {headers.map((header, index) => {
//                       const allValues = volatilityImpact_firsttable_zero
//                         .map((item) => {
//                           let key = Object.keys(item).find((k) =>
//                             k.includes("1min")
//                           );
//                           return key ? item[key].highminlownextfive : null;
//                         })
//                         .filter((value) => !isNaN(value)); // Ensure only numeric values

//                       // Get unique sorted values
//                       const sortedValues = [...new Set(allValues)].sort(
//                         (a, b) => b - a
//                       );
//                       // console.log("sortedValues" , sortedValues)
//                       const highest = sortedValues[0];
//                       const secondHighest = sortedValues[1];
//                       const thirdHighest = sortedValues[2];
//                       let filterObject =
//                         volatilityImpact_firsttable_zero.filter((item) =>
//                           Object.keys(item).includes(header.id + "1min")
//                         )[0];
//                       const finaldata =
//                         filterObject[Object.keys(filterObject)[0]]
//                           .highminlownextfive;

//                       let bgColor = "";

//                       if (finaldata > 0) {
//                         if (finaldata === highest) {
//                           bgColor = "text-[#089ee4]";
//                         } else if (finaldata === secondHighest) {
//                           bgColor = "text-[#52aed8]";
//                         } else if (finaldata === thirdHighest) {
//                           bgColor = "text-[#88c3d4]";
//                         }
//                       }
//                       if (filterObject) {
//                         return (
//                           <td
//                             className={`text-[15px] py-2  ${bgColor}  ${bgColor} ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {finaldata}
//                           </td>
//                         );
//                       } else {
//                         return <td>N/A</td>;
//                       }
//                     })}
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* <---second table ----> */}

//           {Loading_3rdtable ? (
//             <div className="mt-5">
//               <div className="font-semibold m-2 font-xl text-center flex justify-center items-center">
//                 Wait !! Correlation and Average Movement Tables are Loading ....
//               </div>

//               <div className="flex items-center justify-center  w-screen ">
//                 <RingLoader
//                   height="80"
//                   width="80"
//                   color="#94A3B8"
//                   ariaLabel="bars-loading"
//                   wrapperStyle={{}}
//                   wrapperClass=""
//                   visible={true}
//                   className=" flex items-center justify-center  mt-10 w-[100%]"
//                 />
//               </div>
//             </div>
//           ) : (
//             <>
//               <div className="m-3  py-2 px-3  mt-4 flex ">
//                 <div className="relative inline-block ml-[2%] ">
//                   {/* Icon */}

//                   {showTooltip2 && (
//                     <div className="fixed inset-0  backdrop-blur-[1px] z-10"></div>
//                   )}
//                   {/* Tooltip */}
//                   {showTooltip2 && (
//                     <div
//                       ref={tooltipRef}
//                       className="w-[250px] left-[160px] md:w-[514px] border-white rounded-[8px] bg-white absolute bottom-[155%] md:left-[454px] lg:left-[502px] transform -translate-x-1/2 z-[99]  text-[#240d3a] text-sm p-4  shadow-lg"
//                     >
//                       <div className="bg-[#f7f7f7] p-3 ">
//                         <h1 className="m-1 text-[170E32] font-bold text-[18px]">
//                           Non-Zero Events Definition:{" "}
//                           <span className="text-[#5a2989] text-[14px]">
//                             Actual release values differing from the estimated
//                             value, and from the previous release value when
//                             equal to the estimated value.{" "}
//                           </span>
//                         </h1>
//                         <h1 className="mt-4 m-1 text-[170E32] font-bold text-[18px]">
//                           Flat Events Definition:{" "}
//                           <span className="text-[#5a2989] text-[14px]">
//                             Actual release values are same as the estimated
//                             value and the previous release value.{" "}
//                           </span>
//                         </h1>
//                         <div className="sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
//                           <div>
//                             <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
//                               Summary Color Key :{" "}
//                             </h1>
//                           </div>
//                           <div className="mt-2">
//                             <div className="flex items-center my-2">
//                               <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                                 Highest Average:
//                               </h1>
//                               <img
//                                 src={color1}
//                                 title="color"
//                                 alt="color"
//                                 className="ml-4 w-[25px] h-[27px]"
//                               />
//                               {/* <span className="font-bold ml-2">,</span> */}
//                             </div>
//                             <div className="flex items-center my-2">
//                               <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                                 {" "}
//                                 2nd Highest Average:
//                               </h1>
//                               <img
//                                 src={color2}
//                                 title="color"
//                                 alt="color"
//                                 className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                               />
//                               {/* <span className="font-bold ml-2">,</span> */}
//                             </div>
//                             <div className="flex items-center my-2">
//                               <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                                 {" "}
//                                 3rd Highest Average:
//                               </h1>
//                               <img
//                                 src={color3}
//                                 title="color"
//                                 alt="color"
//                                 className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                               />
//                               {/* <span className="ml-[8px]">,</span> */}
//                             </div>
//                           </div>
//                         </div>

//                         <div className="sm:flex-col flex-col md:flex-col lg:flex-col xl:flex-col flex mt-[5%] sm:mt-[5%] md:mt-[5%] lg:mt-[0%] xl:mt-[0%]">
//                           <div>
//                             <h1 className="font-bold text-[#240d3a] text-[18px] mt-3 mx-[4px]">
//                               Table Color Key :{" "}
//                             </h1>
//                           </div>
//                           <div className="mt-2">
//                             <div className="flex items-center my-2">
//                               <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                                 {"Positive values :"}
//                               </h1>
//                               <img
//                                 src={color7}
//                                 title="color"
//                                 alt="color"
//                                 className="ml-4 w-[25px] h-[27px]"
//                               />
//                               {/* <span className="font-bold ml-2">,</span> */}
//                             </div>
//                             <div className="flex items-center my-2">
//                               <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                                 {" "}
//                                 {"Flat values:"}
//                               </h1>
//                               <img
//                                 src={color8}
//                                 title="color"
//                                 alt="color"
//                                 className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                               />
//                               {/* <span className="font-bold ml-2">,</span> */}
//                             </div>
//                             <div className="flex items-center my-2">
//                               <h1 className="w-[175px] font-bold text-[#5a2989] pl-0 sm:pl-0 md:pl-6 lg:pl-6 xl:pl-6  md:text-[14px] lg:text-[14px] xl:text-[14px]">
//                                 {" "}
//                                 {"Negative values:"}
//                               </h1>
//                               <img
//                                 src={color9}
//                                 title="color"
//                                 alt="color"
//                                 className="ml-0 sm:ml-0 md:ml-4 lg:ml-4 xl:ml-4 w-[25px] h-[27px]"
//                               />
//                               {/* <span className="ml-[8px]">,</span> */}
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Triangle Tip */}
//                       <div className="absolute bottom-[-10px] left-[8%] transform -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white"></div>
//                     </div>
//                   )}
//                 </div>
//                 <h1 className=" ml-1 font-bold text-[20px] text-[#240d3a]">
//                   Event Volatility Correlation
//                 </h1>
//                 <img
//                   src={eye_btn_tooltip}
//                   title="Information of Volatility Correlation Table"
//                   alt="eye_btn_tooltip"
//                   className="w-[24px] h-[27px]  cursor-pointer pb-2"
//                   onClick={handleImageClick2}
//                 />
//                 :
//               </div>

//               {/* <------------------second table--------------> */}
//               <div className="overflow-auto relative">
//                 {/* <div className="  mx-[3%] overflow-x-auto overflow-y-auto  max-h-[91vh] "> */}
//                 <div
//                   className={`mx-[3%] overflow-x-auto overflow-y-auto relative ${
//                     optionValue === "last 6"
//                       ? "max-h-[91vh]"
//                       : optionValue === "last 12"
//                       ? "max-h-[130vh]"
//                       : optionValue === "last 24"
//                       ? "max-h-[214vh]"
//                       : ""
//                   }`}
//                 >
//                   <table
//                     className={` ${styles.tableuser} min-w-full  overflow-x-scroll m-auto  font-semibold `}
//                   >
//                     <thead className="bg-[#D2C2F0]   text-[#240d3a]  sticky top-0 z-5 text-[14px] font-semibold border-b-[12px] border-solid border-[#F6F6F6] rounded-[8px]  z-[99]">
//                       <tr>
//                         <th
//                           className="bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white "
//                           colSpan={12}
//                         ></th>
//                         <th
//                           className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white  text-white"
//                           colSpan={7}
//                         >
//                           {`Close price - Open Price ${
//                             timeclickedurl_state === 1
//                               ? "(1min)"
//                               : timeclickedurl_state === 5
//                               ? "(5min)"
//                               : timeclickedurl_state === 15
//                               ? "(15min)"
//                               : timeclickedurl_state === 60
//                               ? "(1hour)"
//                               : "(1min)"
//                           }`}
//                         </th>
//                         <th
//                           className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
//                           colSpan={7}
//                         >
//                           {`Low price - Open Price ${
//                             timeclickedurl_state === 1
//                               ? "(1min)"
//                               : timeclickedurl_state === 5
//                               ? "(5min)"
//                               : timeclickedurl_state === 15
//                               ? "(15min)"
//                               : timeclickedurl_state === 60
//                               ? "(1hour)"
//                               : "(1min)"
//                           }`}
//                         </th>
//                         <th
//                           className="text-[18px] bg-[#5a2989] h-[50.96] min-h-[50.96] border-r-2 border-r-white text-white"
//                           colSpan={12}
//                         >
//                           {`High price - Open Price ${
//                             timeclickedurl_state === 1
//                               ? "(1min)"
//                               : timeclickedurl_state === 5
//                               ? "(5min)"
//                               : timeclickedurl_state === 15
//                               ? "(15min)"
//                               : timeclickedurl_state === 60
//                               ? "(1hour)"
//                               : "(1min)"
//                           }`}
//                         </th>
//                       </tr>
//                       <tr className="h-[81px]">
//                         <th className="sticky top-0 py-2 px-2 min-w-[81px] w-[80px]">
//                           Make selection
//                         </th>
//                         <th className="sticky top-0 py-2 px-2">S. No</th>
//                         <th className="sticky top-0 py-2 px-2">Date</th>
//                         <th className="sticky top-0 py-2 px-2">Time(GMT)</th>
//                         <th className="sticky top-0 py-2 px-2  min-w-[200px] w-[200px]">
//                           Event count before this time
//                         </th>
//                         <th className="sticky top-0 py-2 px-2  min-w-[150px] w-[150px]">
//                           Event count at this time
//                         </th>

//                         <th className="sticky top-0 py-2 px-2">Previous</th>

//                         <th className="sticky top-0 py-2 px-2">Actual</th>
//                         <th className="sticky top-0 py-2 px-2">Estimate</th>
//                         <th className="sticky top-0 py-2 px-2  w-[97px]  min-w-[95.99px]">
//                           Act - Prev
//                         </th>
//                         <th className="sticky top-0 py-2 px-2  border-r-4 border-[#F6F6F6] w-[98px]  min-w-[95.99px] ">
//                           Act - Est
//                         </th>
//                         <th className="sticky top-0 py-2 px-2  border-r-4 bg-[#b38dd3] bg-opacity-[56%] border-[#F6F6F6] w-[100px] min-w-[95.99px] ">
//                           Final movement direction
//                         </th>

//                         {headers.map((header, index) => (
//                           <th
//                             key={header.id}
//                             className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {header.name}
//                             <br />
//                             movement
//                           </th>
//                         ))}

//                         {headers.map((header, index) => (
//                           <th
//                             key={header.id}
//                             className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {header.name}
//                             <br />
//                             movement
//                           </th>
//                         ))}
//                         {headers.map((header, index) => (
//                           <th
//                             key={header.id}
//                             className={`sticky top-0 py-2 px-2 bg-[#D2C2F0] text-[#240d3a] ${
//                               index === headers.length - 1
//                                 ? "border-r-4 border-white"
//                                 : ""
//                             }`}
//                           >
//                             {header.name}
//                             <br />
//                             movement
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody className="bg-[#F6F6F6]  z-0 text-[#240d3a] font-bold text-[14px] relative">
//                       {volatilityImpact_secondtable.map((item, index) => {
//                         const itemDatecheck = item.date.split(" ")[0];

//                         // Filtering impacthighlow array to find the matching data
//                         const matchingData = impacthighlow.find((data) =>
//                           data.startsWith(itemDatecheck)
//                         );

//                         const normalizeDate = (dateStr) => {
//                           return dateStr.split(" ")[0];
//                         };

//                         const filterImpactData = (date) => {
//                           const normalizedDate = normalizeDate(date);

//                           return impacthighlowbeforethis.filter((impact) => {
//                             const impactDate = impact.split(":")[0];

//                             return impactDate === normalizedDate;
//                           });
//                         };

//                         const impactData = filterImpactData(item.date);

//                         return (
//                           <>
//                             <tr
//                               key={index}
//                               className=" cursor-pointer  text-center bg-white  border-y-[16px] border-solid border-[#F6F6F6] relative"
//                             >
//                               <td>
//                                 <input
//                                   type="checkbox"
//                                   // item={geteditdata}

//                                   className="mt-0 ml-4"
//                                   onChange={(e) =>
//                                     handleCheckboxChange(e, item._id)
//                                   }
//                                   checked={selectedIds.includes(item._id)}
//                                   // checked={selectedIndexes.includes(index)}
//                                   // checked={checkednull[geteditdata._id]}
//                                 />
//                               </td>
//                               <td className="py-2 min-w-[81px]">
//                                 {index + 1}.
//                               </td>
//                               <td className="py-2 ">{item.date}</td>
//                               <td className="py-2 ">{item.time.slice(0, 5)}</td>

//                               {/* <---today----> */}
//                               {run_modalloader ? (
//                                 <td className="min-w-[200px] w-[200px]">
//                                   {" "}
//                                   <span className="loader1 text-[#1c72ca] text-center">
//                                     Loading...
//                                   </span>
//                                 </td>
//                               ) : (
//                                 <>
//                                   <td
//                                     className="py-2  text-[13px] min-w-[200px] w-[200px] relative cursor-pointer"
//                                     onClick={() =>
//                                       handleShowModalbeforetime_2nd_table(
//                                         item.date
//                                       )
//                                     }
//                                   >
//                                     {impactData.length > 0 ? (
//                                       impactData.map((impact, i) => {
//                                         const impactParts = impact.split(" ");
//                                         // Remove the first element (date and time)
//                                         const formattedImpact = impactParts
//                                           .slice(1)
//                                           .join(" ");

//                                         return (
//                                           <span
//                                             key={i}
//                                             className="font-bold block"
//                                           >
//                                             {formattedImpact}
//                                           </span>
//                                         );
//                                       })
//                                     ) : (
//                                       <span className="font-bold">No Data</span>
//                                     )}
//                                   </td>

//                                   <dialog
//                                     id="my_modal_2_2nd_table"
//                                     onClick={() => {
//                                       autoClickButton_2nd_table();
//                                     }}
//                                     className={` ${styles.addmodalDirection_eventhistory_2ndTable} modal p-2 sm:p-2 md:p-2 lg:p-6 xl:p-6 absolute max-h-[60vh]  top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
//                                   >
//                                     <form
//                                       method="dialog"
//                                       className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
//                                     >
//                                       <div className="modal-box relative top-[3px]">
//                                         <div
//                                           onClick={() => {
//                                             autoClickButton_2nd_table();
//                                           }}
//                                         >
//                                           <button id="aashima_id_2nd_table">
//                                             <img
//                                               alt="img"
//                                               src={crossicon}
//                                               className="w-[20px] h-[20px]"
//                                             ></img>
//                                           </button>
//                                         </div>
//                                         <div className="">
//                                           {filteredModalData.length > 0 ? (
//                                             <>
//                                               {/* High Impact */}
//                                               {filteredModalData.some(
//                                                 (data) =>
//                                                   data.impact.toLowerCase() ===
//                                                   "high"
//                                               ) && (
//                                                 <div className="text-center flex items-center justify-center">
//                                                   <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
//                                                     High Impact :-
//                                                   </h3>
//                                                 </div>
//                                               )}
//                                               <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
//                                                 {filteredModalData.map(
//                                                   (data, index) => {
//                                                     if (
//                                                       data.impact.toLowerCase() ===
//                                                       "high"
//                                                     ) {
//                                                       return (
//                                                         <div
//                                                           key={index}
//                                                           className="text-start pl-[20px] my-4"
//                                                         >
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={dateicon}
//                                                                 alt="dateicon"
//                                                                 className="h-[20px] w-[20px] mr-2  "
//                                                               />
//                                                               Date:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.date}{" "}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={timeicon}
//                                                                 alt="timeicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />
//                                                               Time:{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.time.slice(
//                                                                 0,
//                                                                 5
//                                                               )}{" "}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={
//                                                                   locationicon
//                                                                 }
//                                                                 alt="locationicon"
//                                                                 className="h-[20px] w-[20px] mr-2 font-bold "
//                                                               />{" "}
//                                                               Country:{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {
//                                                                 data.country
//                                                               }{" "}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={eventicon}
//                                                                 alt="eventicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />{" "}
//                                                               Event :{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.event}{" "}
//                                                             </span>
//                                                           </p>
//                                                           <hr />
//                                                         </div>
//                                                       );
//                                                     }
//                                                     return null;
//                                                   }
//                                                 )}
//                                               </div>

//                                               {/* Medium Impact */}
//                                               {filteredModalData.some(
//                                                 (data) =>
//                                                   data.impact.toLowerCase() ===
//                                                   "medium"
//                                               ) && (
//                                                 <div className="text-center flex items-center justify-center">
//                                                   <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
//                                                     Medium Impact :-
//                                                   </h3>
//                                                 </div>
//                                               )}
//                                               <div className="bg-white px-0 sm:px-0 md:px-[20px] py-[10px] rounded-[8px]">
//                                                 {filteredModalData.map(
//                                                   (data, index) => {
//                                                     if (
//                                                       data.impact.toLowerCase() ===
//                                                       "medium"
//                                                     ) {
//                                                       return (
//                                                         <div
//                                                           key={index}
//                                                           className="text-start pl-[20px] my-4"
//                                                         >
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={dateicon}
//                                                                 alt="dateicon"
//                                                                 className="h-[20px] w-[20px] mr-2  "
//                                                               />{" "}
//                                                               Date:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.date}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={timeicon}
//                                                                 alt="timeicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />{" "}
//                                                               Time:{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.time.slice(
//                                                                 0,
//                                                                 5
//                                                               )}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={
//                                                                   locationicon
//                                                                 }
//                                                                 alt="locationicon"
//                                                                 className="h-[20px] w-[20px] mr-2 font-bold "
//                                                               />{" "}
//                                                               Country:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.country}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={eventicon}
//                                                                 alt="eventicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />{" "}
//                                                               Event:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.event}
//                                                             </span>
//                                                           </p>
//                                                           <hr />
//                                                         </div>
//                                                       );
//                                                     }
//                                                     return null;
//                                                   }
//                                                 )}
//                                               </div>
//                                             </>
//                                           ) : (
//                                             <p className="text-center mt-4">
//                                               No Data
//                                             </p>
//                                           )}
//                                         </div>
//                                       </div>
//                                     </form>
//                                   </dialog>
//                                 </>
//                               )}

//                               {run_modalloader ? (
//                                 <td>
//                                   <span className="loader1 text-[#1c72ca] text-center min-w-[150px] w-[150px]">
//                                     Loading...
//                                   </span>
//                                 </td>
//                               ) : (
//                                 <>
//                                   {" "}
//                                   <td
//                                     className=" py-2 px-4  min-w-[140px] relative cursor-pointer"
//                                     onClick={() =>
//                                       handleShowModalontime_2nd_table(item.date)
//                                     }
//                                   >
//                                     {matchingData && (
//                                       <span className="font-bold text-[13px]">
//                                         {matchingData.includes(": ")
//                                           ? matchingData.substring(
//                                               matchingData.indexOf(": ") + 2
//                                             )
//                                           : matchingData}
//                                       </span>
//                                     )}
//                                   </td>
//                                   <dialog
//                                     id="my_modal_3_2nd_table"
//                                     onClick={() => {
//                                       autoClickButton1_2nd_table();
//                                     }}
//                                     className={`  ${styles.addmodalDirection_eventhistory_2ndTable} modal p-6 absolute max-h-[60vh] top-[200%] sm:top-[200%] md:top-[200%] lg:top-[147%] xl:top-[147%]  bg-[f6f6f6] rounded-[8px] w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[80vw] xl:w-[29vw] `}
//                                   >
//                                     <form
//                                       method="dialog"
//                                       className="modal-  relative top-[-10px]  right-[-6px] text-right w-[80vw] sm:w-[80vw] md:w-[80vw] lg:w-[60vw] xl:w-[25vw]"
//                                     >
//                                       <div className="modal-box relative top-[3px]">
//                                         <div
//                                           onClick={() => {
//                                             autoClickButton1_2nd_table();
//                                           }}
//                                         >
//                                           <button id="closemod11__2nd_table">
//                                             <img
//                                               alt="img"
//                                               src={crossicon}
//                                               className="w-[20px] h-[20px]"
//                                             ></img>
//                                           </button>
//                                         </div>
//                                         <div>
//                                           {filteredModalDataontime.length >
//                                           0 ? (
//                                             <>
//                                               {/* High Impact */}
//                                               {filteredModalDataontime.some(
//                                                 (data) =>
//                                                   data.impact.toLowerCase() ===
//                                                   "high"
//                                               ) && (
//                                                 <div className="text-center flex items-center justify-center">
//                                                   <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4  w-[193px] text-[#240d3a]">
//                                                     High Impact :-
//                                                   </h3>
//                                                 </div>
//                                               )}
//                                               <div className="">
//                                                 {filteredModalDataontime.map(
//                                                   (data, index) => {
//                                                     if (
//                                                       data.impact.toLowerCase() ===
//                                                       "high"
//                                                     ) {
//                                                       return (
//                                                         <div
//                                                           key={index}
//                                                           className="text-start pl-[20px] my-4"
//                                                         >
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className=" flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={dateicon}
//                                                                 alt="dateicon"
//                                                                 className="h-[20px] w-[20px] mr-2  "
//                                                               />
//                                                               Date:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.date}{" "}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={timeicon}
//                                                                 alt="timeicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />
//                                                               Time:{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.time.slice(
//                                                                 0,
//                                                                 5
//                                                               )}{" "}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={
//                                                                   locationicon
//                                                                 }
//                                                                 alt="locationicon"
//                                                                 className="h-[20px] w-[20px] mr-2 font-bold "
//                                                               />{" "}
//                                                               Country:{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {
//                                                                 data.country
//                                                               }{" "}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={eventicon}
//                                                                 alt="eventicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />{" "}
//                                                               Event :{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.event}{" "}
//                                                             </span>
//                                                           </p>
//                                                           <hr />
//                                                         </div>
//                                                       );
//                                                     }
//                                                     return null;
//                                                   }
//                                                 )}
//                                               </div>

//                                               {/* Medium Impact */}
//                                               {filteredModalDataontime.some(
//                                                 (data) =>
//                                                   data.impact.toLowerCase() ===
//                                                   "medium"
//                                               ) && (
//                                                 <div className="text-center flex items-center justify-center">
//                                                   <h3 className="font-bold text-lg mt-4 mb-4  py-2 px-4 text-[#240d3a]">
//                                                     Medium Impact :-
//                                                   </h3>
//                                                 </div>
//                                               )}
//                                               <div className="">
//                                                 {filteredModalDataontime.map(
//                                                   (data, index) => {
//                                                     if (
//                                                       data.impact.toLowerCase() ===
//                                                       "medium"
//                                                     ) {
//                                                       return (
//                                                         <div
//                                                           key={index}
//                                                           className="text-start pl-[20px] my-4"
//                                                         >
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={dateicon}
//                                                                 alt="dateicon"
//                                                                 className="h-[20px] w-[20px] mr-2  "
//                                                               />{" "}
//                                                               Date:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.date}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={timeicon}
//                                                                 alt="timeicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />{" "}
//                                                               Time:{" "}
//                                                             </span>
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.time.slice(
//                                                                 0,
//                                                                 5
//                                                               )}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={
//                                                                   locationicon
//                                                                 }
//                                                                 alt="locationicon"
//                                                                 className="h-[20px] w-[20px] mr-2 font-bold "
//                                                               />{" "}
//                                                               Country:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.country}
//                                                             </span>
//                                                           </p>
//                                                           <p className="flex items-center mb-[6px] text-[16px]">
//                                                             <span className="flex items-center font-semibold pr-2 text-[#240d3a]">
//                                                               <img
//                                                                 src={eventicon}
//                                                                 alt="eventicon"
//                                                                 className="h-[20px] w-[20px] mr-2 "
//                                                               />{" "}
//                                                               Event:
//                                                             </span>{" "}
//                                                             <span className="text-[#5a2989]">
//                                                               {" "}
//                                                               {data.event}
//                                                             </span>
//                                                           </p>
//                                                           <hr />
//                                                         </div>
//                                                       );
//                                                     }
//                                                     return null;
//                                                   }
//                                                 )}
//                                               </div>
//                                             </>
//                                           ) : (
//                                             <p className="text-center mt-4">
//                                               No Data
//                                             </p>
//                                           )}
//                                         </div>
//                                       </div>
//                                     </form>
//                                   </dialog>
//                                 </>
//                               )}

//                               <td className="py-2">{item.previous}</td>
//                               <td className="py-2">{item.actual}</td>
//                               <td className="py-2">{item.estimate}</td>

//                               <td
//                                 className={`py-2  text-[#240d3a] font-bold  ${
//                                   item.actualminusprevious === "N/A"
//                                     ? "bg-[#E5E7EB]"
//                                     : item.actualminusprevious > 0
//                                     ? "bg-[#5de98e]"
//                                     : item.actualminusprevious == 0
//                                     ? "bg-[#f1d500]"
//                                     : item.actualminusprevious < 0
//                                     ? "bg-[#ff8e8ef2]"
//                                     : "bg-[#E5E7EB]"
//                                 }`}
//                               >
//                                 {/* {item.actualminusprevious != null && item.actualminuspreviousdivestimate != 'N/A' && item.actualminuspreviousSign ?
//                          `(${item.actualminuspreviousSign})` : "N/A"} */}
//                                 {item.actualminusprevious === "N/A"
//                                   ? "N/A"
//                                   : item.actualminusprevious != null
//                                   ? item.actualminuspreviousSign !== ""
//                                     ? `(${item.actualminuspreviousSign})`
//                                     : "" // empty string if sign is empty
//                                   : "N/A"}

//                                 {/* {item.actualminuspreviousSign ? `(${item.actualminuspreviousSign})` : ""} */}
//                               </td>

//                               <td
//                                 className={`py-2  text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
//                                   item.actualminusestimate === "N/A"
//                                     ? "bg-[#E5E7EB]"
//                                     : item.actualminusestimate > 0
//                                     ? "bg-[#5de98e]"
//                                     : item.actualminusestimate == 0
//                                     ? "bg-[#f1d500]"
//                                     : item.actualminusestimate < 0
//                                     ? "bg-[#ff8e8ef2]"
//                                     : "bg-[#E5E7EB]"
//                                 }`}
//                               >
//                                 {item.actualminusestimate === "N/A"
//                                   ? "N/A"
//                                   : item.actualminusestimate != null
//                                   ? item.actualminusestimateSign !== ""
//                                     ? `(${item.actualminusestimateSign})`
//                                     : "" // empty string if sign is empty
//                                   : "N/A"}
//                                 {/* {item.actualminusestimateSign ? `(${item.actualminusestimateSign})` : ""} */}
//                               </td>

//                               <td
//                                 className={`py-2  text-[#240d3a] font-bold border-r-[4px] border-[#F6F6F6] ${
//                                   item.finalMovement === "N/A"
//                                     ? "bg-[#E5E7EB]"
//                                     : item.finalMovement > 0
//                                     ? "bg-[#5de98e]"
//                                     : item.finalMovement == 0
//                                     ? "bg-[#f1d500]"
//                                     : item.finalMovement < 0
//                                     ? "bg-[#ff8e8ef2]"
//                                     : "bg-[#E5E7EB]"
//                                 }`}
//                               >
//                                 {item.finalMovement === "N/A"
//                                   ? "N/A"
//                                   : item.finalMovement != null
//                                   ? item.finalMovementSign !== ""
//                                     ? `(${item.finalMovementSign})`
//                                     : "" // empty string if sign is empty
//                                   : "N/A-----"}
//                                 {/* ({item.finalMovementSign}) */}
//                                 {/* {item.finalMovementSign ? `(${item.finalMovementSign})` : ""} */}
//                               </td>

//                               {/* <------first section table----> */}
//                               {/* 1. Close Minus Open Sign */}
//                               {headers.map((header, index) => {
//                                 const key =
//                                   header.name
//                                     .split("/")
//                                     .join("")
//                                     .toLowerCase() + "1min";
//                                 const sign = item[key]?.closeMinusOpenSign;

//                                 return (
//                                   <td
//                                     className={`border-[#F6F6F6] min-w-[91.95px] ${
//                                       sign === "+"
//                                         ? "bg-[#7fe9a4]"
//                                         : sign === "-"
//                                         ? "bg-[#f3b2b2]"
//                                         : sign === 0 || sign === "0"
//                                         ? "bg-[#f7dc14]"
//                                         : "bg-[#E5E7EB]"
//                                     } ${
//                                       index === headers.length - 1
//                                         ? "border-r-4 border-white"
//                                         : ""
//                                     }`}
//                                   >
//                                     {sign || "N/A"}
//                                   </td>
//                                 );
//                               })}

//                               {/* 2. Low Minus Open Sign */}
//                               {headers.map((header, index) => {
//                                 const key =
//                                   header.name
//                                     .split("/")
//                                     .join("")
//                                     .toLowerCase() + "1min";
//                                 const sign = item[key]?.lowMinusOpenSign;

//                                 return (
//                                   <td
//                                     className={`border-[#F6F6F6] min-w-[91.95px] ${
//                                       sign === "+"
//                                         ? "bg-[#7fe9a4]"
//                                         : sign === "-"
//                                         ? "bg-[#f3b2b2]"
//                                         : sign === 0 || sign === "0"
//                                         ? "bg-[#f7dc14]"
//                                         : "bg-[#E5E7EB]"
//                                     } ${
//                                       index === headers.length - 1
//                                         ? "border-r-4 border-white"
//                                         : ""
//                                     }`}
//                                   >
//                                     {sign || "N/A"}
//                                   </td>
//                                 );
//                               })}

//                               {/* 3. High Minus Open Sign */}
//                               {headers.map((header, index) => {
//                                 const key =
//                                   header.name
//                                     .split("/")
//                                     .join("")
//                                     .toLowerCase() + "1min";
//                                 const sign = item[key]?.highMinusOpenSign;

//                                 return (
//                                   <td
//                                     className={`border-[#F6F6F6] min-w-[91.95px] ${
//                                       sign === "+"
//                                         ? "bg-[#7fe9a4]"
//                                         : sign === "-"
//                                         ? "bg-[#f3b2b2]"
//                                         : sign === 0 || sign === "0"
//                                         ? "bg-[#f7dc14]"
//                                         : "bg-[#E5E7EB]"
//                                     } ${
//                                       index === headers.length - 1
//                                         ? "border-r-4 border-white"
//                                         : ""
//                                     }`}
//                                   >
//                                     {sign || "N/A"}
//                                   </td>
//                                 );
//                               })}
//                             </tr>
//                           </>
//                         );
//                       })}

//                       <tr className="bg-[#dccafe5e] text-center">
//                         <td
//                           className="py-2  font-bold   min-w-[80.8px]"
//                           colSpan={4}
//                         >
//                           % data missing
//                         </td>
//                         {/* <td className="py-2 "></td>
//                            <td className="py-2 "></td> */}
//                         {/* <td className="py-2 "></td> */}
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className={`py-2 border-r-4 border-white`}></td>

//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? parseFloat(
//                                       item[
//                                         key
//                                       ].closeminusopenmissingEvent.replace(
//                                         "%",
//                                         ""
//                                       )
//                                     )
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];

//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];
//                           // console.log("filterObject" , filterObject)
//                           if (filterObject) {
//                             let rawValue =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopenmissingEvent;
//                             let value = parseFloat(rawValue);

//                             // console.log("rawValue" , rawValue)
//                             //   console.log("value" , value)
//                             let bgColor = "";
//                             if (value <= 65) {
//                               bgColor = "text-[#e06969]";
//                             } else if (value > 65 && value <= 80) {
//                               bgColor = "text-[#e4c900]";
//                             } else if (value > 80) {
//                               bgColor = "text-[#34c567]";
//                             } else {
//                               bgColor = "text-[#88898c]";
//                             }
//                             return (
//                               <td
//                                 className={`text-[15px] py-2    ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {rawValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].lowminusopenmissingEvent
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)

//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finalValue =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopenmissingEvent;
//                           // console.log("finalValue" , finalValue)
//                           let value = parseFloat(finalValue);
//                           let bgColor = "";
//                           if (value <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (value > 65 && value <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (value > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }

//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2    ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {finalValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].HighminusopenmissingEvent
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finaldata =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopenmissingEvent;
//                           let value = parseFloat(finaldata);
//                           let bgColor = "";
//                           if (value <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (value > 65 && value <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (value > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }
//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {finaldata}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                       </tr>
//                       <tr className="bg-[#dccafe5e] text-center">
//                         <td className="py-2 font-bold " colSpan={4}>
//                           Non- Zero event (Positive currency correlation)
//                         </td>
//                         {/* <td className="py-2 "></td>
//                            <td className="py-2 "></td> */}
//                         {/* <td className="py-2 "></td> */}
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>

//                         <td className={`py-2 border-r-4 border-white`}></td>
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? parseFloat(
//                                       item[
//                                         key
//                                       ].closeminusopennonZeroPositive.replace(
//                                         "%",
//                                         ""
//                                       )
//                                     )
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];

//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];
//                           // console.log("filterObject" , filterObject)

//                           if (filterObject) {
//                             let rawValue =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonZeroPositive;
//                             let rawValue_negative =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonZeroNegative;
//                             let value = parseFloat(rawValue);
//                             let value_negative = parseFloat(rawValue_negative);
//                             // console.log("rawValue" , rawValue)

//                             let maxValue = Math.max(value, value_negative);
//                             //   console.log("value" , value)

//                             let bgColor = "";
//                             if (maxValue <= 65) {
//                               bgColor = "text-[#e06969]";
//                             } else if (maxValue > 65 && maxValue <= 80) {
//                               bgColor = "text-[#e4c900]";
//                             } else if (maxValue > 80) {
//                               bgColor = "text-[#34c567]";
//                             } else {
//                               bgColor = "text-[#88898c]";
//                             }
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor}  ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {rawValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].lowminusopennonZeroPositive
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finalValue =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonZeroPositive;
//                           const finalValue_negative =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonZeroNegative;
//                           // console.log("finalValue" , finalValue)

//                           if (filterObject) {
//                             let value = parseFloat(finalValue);
//                             let value_negative =
//                               parseFloat(finalValue_negative);

//                             let maxValue = Math.max(value, value_negative);
//                             let bgColor = "";
//                             if (maxValue <= 65) {
//                               bgColor = "text-[#e06969]";
//                             } else if (maxValue > 65 && maxValue <= 80) {
//                               bgColor = "text-[#e4c900]";
//                             } else if (maxValue > 80) {
//                               bgColor = "text-[#34c567]";
//                             } else {
//                               bgColor = "text-[#88898c]";
//                             }
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {finalValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].HighminusopennonZeroPositive
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finaldata =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonZeroPositive;
//                           const finaldata_negative =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonZeroNegative;
//                           let value = parseFloat(finaldata);
//                           let value_negative = parseFloat(finaldata_negative);

//                           let maxValue = Math.max(value, value_negative);
//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }

//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor}  ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {finaldata}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                       </tr>
//                       <tr className="bg-[#dccafe5e] text-center">
//                         <td className="py-2 font-bold " colSpan={4}>
//                           Non- Zero event (Negative currency correlation)
//                         </td>
//                         {/* <td className="py-2 "></td>
//                            <td className="py-2 "></td>
//                            <td className="py-2 "></td> */}
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>

//                         <td className={`py-2 border-r-4 border-white`}></td>
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? parseFloat(
//                                       item[
//                                         key
//                                       ].closeminusopennonZeroNegative.replace(
//                                         "%",
//                                         ""
//                                       )
//                                     )
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];

//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];
//                           // console.log("filterObject" , filterObject)
//                           if (filterObject) {
//                             let rawValue =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonZeroNegative;
//                             let rawValue_positive =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonZeroPositive;
//                             let value = parseFloat(rawValue);
//                             let value_positive = parseFloat(rawValue_positive);

//                             let maxValue = Math.max(value, value_positive);
//                             let bgColor = "";
//                             if (maxValue <= 65) {
//                               bgColor = "text-[#e06969]";
//                             } else if (maxValue > 65 && maxValue <= 80) {
//                               bgColor = "text-[#e4c900]";
//                             } else if (maxValue > 80) {
//                               bgColor = "text-[#34c567]";
//                             } else {
//                               bgColor = "text-[#88898c]";
//                             }
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {rawValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].lowminusopennonZeroNegative
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finalValue =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonZeroNegative;
//                           const finalValue_positive =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonZeroPositive;
//                           // console.log("finalValue" , finalValue)

//                           let value = parseFloat(finalValue);
//                           let value_positive = parseFloat(finalValue_positive);

//                           let maxValue = Math.max(value, value_positive);
//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }

//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor}   ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {finalValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].HighminusopennonZeroNegative
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finaldata =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonZeroNegative;
//                           const finaldata_positive =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonZeroPositive;
//                           let value = parseFloat(finaldata);
//                           let value_positive = parseFloat(finaldata_positive);

//                           let maxValue = Math.max(value, value_positive);

//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }
//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {finaldata}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                       </tr>
//                       <tr className="bg-[#dccafe5e] text-center">
//                         <td className="py-2 font-bold " colSpan={4}>
//                           Flat event (Positive currency correlation)
//                         </td>
//                         {/* <td className="py-2 "></td>
//                            <td className="py-2 "></td>
//                            <td className="py-2 "></td> */}
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>

//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className={`py-2 border-r-4 border-white`}></td>
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? parseFloat(
//                                       item[
//                                         key
//                                       ].closeminusopennonFlatPostive.replace(
//                                         "%",
//                                         ""
//                                       )
//                                     )
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];

//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];
//                           // console.log("filterObject" , filterObject)
//                           if (filterObject) {
//                             let rawValue =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonFlatPostive;
//                             let rawValue_negative =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonFlatNegative;
//                             let value = parseFloat(rawValue);
//                             let value_negative = parseFloat(rawValue_negative);
//                             let maxValue = Math.max(value, value_negative);
//                             let bgColor = "";
//                             if (maxValue <= 65) {
//                               bgColor = "text-[#e06969]";
//                             } else if (maxValue > 65 && maxValue <= 80) {
//                               bgColor = "text-[#e4c900]";
//                             } else if (maxValue > 80) {
//                               bgColor = "text-[#34c567]";
//                             } else {
//                               bgColor = "text-[#88898c]";
//                             }
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {rawValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].lowminusopennonFlatPositive
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finalValue =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonFlatPositive;
//                           const finalValue_negative =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonFlatNegative;

//                           // console.log("finalValue" , finalValue)
//                           let value = parseFloat(finalValue);
//                           let value_negative = parseFloat(finalValue_negative);
//                           let maxValue = Math.max(value, value_negative);

//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }

//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {finalValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].HighminusopennonFlatPositive
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finaldata =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonFlatPositive;
//                           const finaldata_negative =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonFlatNegative;
//                           let value = parseFloat(finaldata);
//                           let value_negative = parseFloat(finaldata_negative);

//                           let maxValue = Math.max(value, value_negative);

//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }
//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {finaldata}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                       </tr>
//                       <tr className="bg-[#dccafe5e] text-center">
//                         <td className="py-2 font-bold" colSpan={4}>
//                           Flat event (Negative currency correlation)
//                         </td>
//                         {/* <td className="py-2 "></td>
//                            <td className="py-2 "></td>
//                            <td className="py-2 "></td> */}
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>

//                         <td className="py-2 "></td>
//                         <td className="py-2 "></td>
//                         <td className={`py-2 border-r-4 border-white`}></td>
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? parseFloat(
//                                       item[
//                                         key
//                                       ].closeminusopennonFlatNegative.replace(
//                                         "%",
//                                         ""
//                                       )
//                                     )
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];

//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];
//                           // console.log("filterObject" , filterObject)
//                           if (filterObject) {
//                             let rawValue =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonFlatNegative;
//                             let rawValue_positive =
//                               filterObject[Object.keys(filterObject)[0]]
//                                 .closeminusopennonFlatPostive;
//                             // console.log("rawValue_positive" , rawValue_positive)
//                             let value = parseFloat(rawValue);
//                             let value_positive = parseFloat(rawValue_positive);

//                             // console.log("value_positive" , value_positive)
//                             let maxValue = Math.max(value, value_positive);
//                             // console.log("maxValue" ,maxValue)
//                             let bgColor = "";
//                             if (maxValue <= 65) {
//                               bgColor = "text-[#e06969]";
//                             } else if (maxValue > 65 && maxValue <= 80) {
//                               bgColor = "text-[#e4c900]";
//                             } else if (maxValue > 80) {
//                               bgColor = "text-[#34c567]";
//                             } else {
//                               bgColor = "text-[#88898c]";
//                             }
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {rawValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].lowminusopennonFlatNegative
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finalValue =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonFlatNegative;
//                           const finalValue_positive =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .lowminusopennonFlatPositive;
//                           // console.log("finalValue" , finalValue)
//                           let value = parseFloat(finalValue);
//                           let value_positive = parseFloat(finalValue_positive);

//                           let maxValue = Math.max(value, value_positive);

//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }
//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 } `}
//                               >
//                                 {finalValue}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                         {headers.map((header, index) => {
//                           const allValues =
//                             volatilityImpact_secondtable_flatPOS_flatNEV
//                               .map((item) => {
//                                 let key = Object.keys(item).find((k) =>
//                                   k.includes("1min")
//                                 );
//                                 return key
//                                   ? item[key].HighminusopennonFlatNegative
//                                   : null;
//                               })
//                               .filter((value) => !isNaN(value)); // Ensure only numeric values

//                           // Get unique sorted values
//                           const sortedValues = [...new Set(allValues)].sort(
//                             (a, b) => b - a
//                           );
//                           // console.log("sortedValues" , sortedValues)
//                           const highest = sortedValues[0];
//                           const secondHighest = sortedValues[1];
//                           const thirdHighest = sortedValues[2];
//                           let filterObject =
//                             volatilityImpact_secondtable_flatPOS_flatNEV.filter(
//                               (item) =>
//                                 Object.keys(item).includes(header.id + "1min")
//                             )[0];

//                           const finaldata =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonFlatNegative;
//                           const finaldata_positive =
//                             filterObject[Object.keys(filterObject)[0]]
//                               .HighminusopennonFlatPositive;

//                           let value = parseFloat(finaldata);
//                           let value_positive = parseFloat(finaldata_positive);
//                           let maxValue = Math.max(value, value_positive);

//                           let bgColor = "";
//                           if (maxValue <= 65) {
//                             bgColor = "text-[#e06969]";
//                           } else if (maxValue > 65 && maxValue <= 80) {
//                             bgColor = "text-[#e4c900]";
//                           } else if (maxValue > 80) {
//                             bgColor = "text-[#34c567]";
//                           } else {
//                             bgColor = "text-[#88898c]";
//                           }
//                           if (filterObject) {
//                             return (
//                               <td
//                                 className={`text-[15px] py-2  ${bgColor} ${
//                                   value === maxValue
//                                     ? "font-bold"
//                                     : "font-medium"
//                                 } ${
//                                   index === headers.length - 1
//                                     ? "border-r-4 border-white"
//                                     : ""
//                                 }`}
//                               >
//                                 {finaldata}
//                               </td>
//                             );
//                           } else {
//                             return <td>N/A</td>;
//                           }
//                         })}
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       ) : (
//         // <----------if no data available in backend ( 400 error)---------------->
//         <div>
//           <div className="font-semibold m-6 font-xl text-center flex justify-center items-center ">
//             Wait !! Data is in Progress .....
//           </div>
//           <div className="flex items-center justify-center  w-screen ">
//             <Bars
//               height="80"
//               width="80"
//               color="#94A3B8"
//               ariaLabel="bars-loading"
//               wrapperStyle={{}}
//               wrapperClass=""
//               visible={true}
//               className="loader"
//             />
//           </div>
//         </div>
//       )}

//       <div>
//         {modalShow && (
//           <div
//             id="popup-modal"
//             className="fixed top-0 right-0 bottom-0 left-0 flex justify-center items-center bg-black bg-opacity-15 z-[999]"
//             onClick={() => setModalshow(!modalShow)}
//           >
//             <div className="relative p-4 w-full max-w-md">
//               <div className="relative bg-white rounded-lg shadow">
//                 <img
//                   src={logout_eye_btn}
//                   alt="logout_eye_btn"
//                   className="h-[33px] w-[33px] absolute top-[12%] left-[47%]"
//                 />
//                 <div className="p-4 md:p-5 text-center z-[999]">
//                   <h3 className="mb-5 mt-[15%] text-lg font-bold text-[#240D3A]">
//                     Are you sure you want to refresh the page? This action will
//                     clear all locally stored data.
//                   </h3>
//                   <div className="flex items-center justify-center">
//                     <button
//                       data-modal-hide="popup-modal"
//                       type="button"
//                       className="text-[#240D3A]  bg-[#ecebeb] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
//                       onClick={handleRefresh}
//                     >
//                       Yes
//                     </button>
//                     <button
//                       data-modal-hide="popup-modal"
//                       type="button"
//                       className="ml-4 text-white  bg-[#240D3A] mt-3 font-medium rounded-lg  inline-flex items-center justify-center px-3 py-2 w-[20%]"
//                       onClick={() => setModalshow(!modalShow)}
//                     >
//                       No
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default EventshistoryUserTrial;
